export const fr = {
    addDatabase: {
        addDatabase: "Ajouter base de donnÃ©es",
        addFromFile: "Ajouter depuis un fichier",
        analyse: "Analyse",
        analysingYourData: "Analyser vos donnÃ©es",
        createFromExcel: "CrÃ©er Ã  partir d'Excel",
        databaseImport: "Database import",
        databaseNotImported: "L'importation s'est terminÃ©e avec des erreurs",
        databasePrepared: "Base de donnÃ©es prÃ©parÃ©e avec succÃ¨s",
        excelFile: "Excel file",
        fileInformation: "Informations sur le fichier",
        fixErrors: "To continue please fix following errors and retry",
        importingYourData: "Importer vos donnÃ©es",
        productFilesPath: "Product files path",
        productImagesPath: "Product images path"
    },
    availablePrice: {
        allPackage: "Tous les emballages",
        onePackage: "Un seul emballage",
        priceType: "Type de prix",
        setPriceVatVisibility: "Set VAT visibility",
        setVisibilityAndOrder: "DÃ©terminer ordre d'apparence des types de prix",
        withAndWithoutVat: "Avec et sans TVA",
        withVat: "Avec TVA seulement",
        withoutVat: "Sans TVA"
    },
    barvis: {
        base: "Nom de la base",
        bigCanSize: "Grands boitages",
        coating: "Peinture",
        identifier: "Identifieur",
        laboratory: "Laboratoire",
        orderOverview: "RÃ©capitulatif de la commande",
        rank: "Classement",
        smallCanSize: "Petits boitages"
    },
    basicSetup: {
        alreadyLoggedIn: "Vous Ãªtes dÃ©jÃ  loggÃ© en tant que %{login}.",
        askSupplier: "Demandez Ã  votre fournisseur de logiciel de vous assigner plus de licences.",
        asterisk: "Les champs marquÃ©s d'un asterisk doivent Ãªtre remplis.",
        identificationKeys: "ClÃ©s dâidentification",
        importCustomData:
            "Le cas Ã©chÃ©ant, importer les donnÃ©es personnelles Ã  partir de la version de logiciel prÃ©cÃ©dente.",
        learnIdentification: "Prenez connaissance des clÃ©s d'identification auprÃ¨s de votre fournisseur de logiciel.",
        login: "Les prochaines Ã©tapes de l'installation requiÃ¨rent des droits administrateurs.",
        noDatabase: "Aucune base de donnÃ©es n'a Ã©tÃ© ajoutÃ©Ã©, il est necessaire d'en insÃ©rer au moins une.",
        offlineLicensing: "Licences hors ligne",
        productSelection: "SÃ©lection de produits",
        registrationForm: "Formulaire dâinscription",
        seeQuestionMark: "Voir les petits points d'interrogation pour plus d'information sur le paramÃ©trage.",
        selectDefaultPrinter: "Selectionnez l'imprimante par dÃ©faut et rÃ©glez les paramÃ¨tres supplÃ©mentaires.",
        selectDefaultTemplate:
            "Slectionnez les modÃ¨les existants, creez un nouveau modÃ¨le ou chargez votre propre modÃ¨le.",
        selectDispenser: "Selectionnez la machine Ã  teinter que vous utilisez.",
        selectLanguage: "Selectionnez votre langue.",
        selectProducts: "Selectionnez un des produits disponible que vous souhaitez activer.",
        selectSpectroType: "Selectionnez le type de spectro que vous utilisez.",
        setAdditionalPrinterOptions: "DÃ©finissez les options supplÃ©mentaires de l'imprimante",
        setAutomaticUpdates: "DÃ©finissez les options de mise Ã  jour automatique",
        setCustomItems:
            "DÃ©finissez les Ã©lÃ©ments personnalisÃ©s et la visibilitÃ© des donnÃ©es. Faites dÃ©filer vers le bas pour voir plus d'options.",
        setEnvironment:
            "DÃ©finissez l'environnement global du logiciel. Faites dÃ©filer vers le bas pour voir plus d'options.",
        setFormulaRepresentation:
            "DÃ©finissez l'apparance de la formule. Faites dÃ©filer vers le bas pour voir plus d'options.",
        summary:
            "Vous pouvez modifier les paramÃ¨tres Ã  tout moment et mÃªme trouver plus de possibilitÃ©s de configuration. Amusez-vous en utilisant %{name}!",
        summarySuccess: "Vous Ãªtes fin prÃªts !"
    },
    beforeDispenseColorantBatch: {
        batchNumber: "NumÃ©ro de lot : %{batchNumber}",
        colorantIsDefective: "The canister is filled with a defective batch of colorant. Do not use this batch.",
        defectiveInfoLine1: "Please do not use colorant",
        defectiveInfoLine2: "with this batch number.",
        emptyQuickTint: "Vider le canister en utilisant la teinte rapide.",
        warningInfoLine1: "Colorant",
        warningInfoLine2: "with this batch number may be damaged."
    },
    canisterLevel: {
        canisterLevel: "DÃ©terminer le niveau des canisters",
        criticalLevelCanister: "Niveau de remplissage critique",
        fillToMax: "Remplir au maximum",
        maxDispenseLevel: "Dosage maximum",
        otherCanisters: "Niveau des autres canisters",
        warningLevelCanister: "Avertissement niveau des canisters"
    },
    canisterRefillHistoryModal: {
        batchNumberOfFilling: "NumÃ©ro de lot de remplissage",
        ufiCodeStatus: "UFI code status"
    },
    canistersTab: {
        availableServiceActions: "Actions de service disponibles",
        canisterInformation: "Informations du canister",
        canisterPreview: "Visualisation des niveaux de remplissage des canisters",
        currentLevel: "Niveau actuel",
        errors: "Erreurs",
        fillState: "Niveaux de remplissage",
        fillToMax: "Remplir au maximum",
        fillingAmount: "QuantitÃ© de remplissage",
        finalLevel: "Niveau final",
        minimumAmount: "QuantitÃ© minimum",
        minimumLevel: "Niveau minimum",
        moveTableToRefill: "Bouger la table pour procÃ©der au remplissage",
        refillNoAmount: "QuantitÃ© non renseignÃ©e",
        refillOverLimit: "La quantitÃ© saisie dÃ©passe la capacitÃ© maximum du canister",
        refillSummary: "%{amount} %{unit} %{colorant} seront ajoutÃ©s au canister %{canisterId}.",
        systemWarningAmount: "SystÃ¨me d'alerte de quantitÃ©s",
        warningAmount: "Alerte de quantitÃ©s"
    },
    changeDatabase: {
        changeDatabase: "Changer la base de donnÃ©es",
        databaseWarning: "La base de donnÃ©es %{databaseName} ne peut pas Ãªtre utilisÃ©e pour les raisons suivantes"
    },
    changelog: {
        allVersion: "All versions",
        changelog: "Changelog",
        link: "Link",
        links: "Links",
        version: "Version",
        versionFilter: "Version filter"
    },
    checkBeforeDispensing: {
        checkBeforeDispensingModal:
            "QuantitÃ©s insuffisantes de colorants dans les canisters pour %{numOfPackages} boÃ®tages.",
        fillAdditionally: "Rajouter",
        refillToMax: "Refill to max"
    },
    cleanChannels: {
        cleanAllChannels: "Nettoyer tous les circuits",
        cleanChannels: "Nettoyer circuits",
        cleaningTime: "Temps de nettoyage",
        selectChannels: "SÃ©lectionner les circuits",
        startCleaning: "Commencer le nettoyage"
    },
    clientServerSettings: {
        activeServer: "Serveur actif",
        addNewServer: "Ajouter un nouveau serveur",
        availableServers: "Autres serveurs disponibles",
        clientIdentifier: "Identifieur de client",
        clientServerSettings: "ParamÃ¨tres Client/Serveur",
        disabledStatus: "DÃ©sactivÃ©",
        editServer: "Modifier informations serveur",
        fillRequiredFields: "Champs obligatoires devant Ãªtre remplis",
        noOtherServers: "Pas de serveurs disponibles",
        offlineStatus: "Offline",
        onlineStatus: "Online",
        port: "Port",
        serverName: "Nom du serveur",
        serverNameMissing: "Nom de serveur devant Ãªtre rempli",
        stabileConnection: "Pour assurer un bonne stabilitÃ© de connection, utilisez une adersse IP statique.",
        wrongFormatIp: "Mauvais format d'adresse IP"
    },
    colorSearchTab: {
        notEveryItemSelected: "Au moins un critÃ¨re n'est pas renseignÃ© !"
    },
    colorTab: {
        colorTone: "TonalitÃ© de couleur",
        fandeckPosition: "Position du nuancier",
        moreInfoIcons: "Plus dâicÃ´nes dâinformation",
        notExistingFormula: "Formule inexistante",
        orderBy: "Commande par",
        selectYourGrid: "Selectionnez votre grille",
        showInPanel: "Afficher dans l'Ã©cran",
        warningIcon: "Formule non existante icon d'alerte"
    },
    colorantBatchNumberSettings: {
        batchNumberByPercentage: "Use Batch numbers by percentage",
        batchNumberFromLastFilling: "Use Batch numbers from the last filling",
        defectiveBatchOfColorant: "Lot de colorant dÃ©fectueux",
        enableBatchNumber: "Activer les NumÃ©ros de lots des colorants",
        possibleDamagedBatchOfColorant: "Possibly damaged Batch of colorant",
        scanOrTypeBatchNumber: "Scan or type Batch number"
    },
    colorantPanel: {
        manualMachine: "machine"
    },
    colorantsTable: {
        numberOfColorants: "Nombre de colorants",
        preview: "Previsualisation ",
        prices: "Prix par packaging"
    },
    currencySettings: {
        addNewCurrency: "Ajouter une nouvelle monnaie",
        codePlaceholder: "Code",
        currencySettings: "ParamÃ¨tres de monnaie",
        namePlaceholder: "Nom",
        ratePlaceholder: "Taux",
        setDecimalPlaces: "DÃ©finir le nombre de chiffres aprÃ¨s la virgule",
        setMainCurrency: "DÃ©terminer la monnaie principale",
        setRounding: "ParamÃ©trage de lâarrondi",
        symbolPlaceholder: "Symbole"
    },
    customFandecks: {
        customFandecks: "Base de donnÃ©e personnalisÃ©e",
        deleteButtonWarning: "Toutes les formules du nuancier seront Ã©galement supprimÃ©es.",
        deleteCustomFandeck:
            "Voulez-vous vraiment supprimer ce nuancier personnalisÃ©? Toutes les formules de ce nuancier seront Ã©galement supprimÃ©es.",
        disableStandardFandecks: "Show only custom fandecks",
        enableStandardFandecks: "Show standard fandecks",
        fandeckName: "Nom de nuancier"
    },
    customRedlike: {
        addColorantFromBrand: "Ajouter un colorant de la marque %{brandName}.",
        addNewCustomer: "Ajouter de nouveau client",
        addNewNote: "Ajouter nouvelle note",
        addedDate: "Date ajoutÃ©e",
        addedQuantity: "QuantitÃ© ajoutÃ©e",
        availableMachine: "Machine disponible",
        brand: "Marque",
        brandPlease: "SÃ©lectionnez les marque svp",
        cancelCustomer: "Suppimer client",
        colorPlease: "SÃ©lectionnez la couleur svp",
        confirmCustomerData: "Confirmer infos clients",
        confirmNoteData: "Confirmer les notes",
        confirmSelectedUser: "Souhaitez-vous utiliser %{customerName} pour cette commande ?",
        confirmed: "ConfirmÃ©",
        controlData: "DerniÃ¨re vÃ©rification",
        customerCellNumber: "TÃ©lÃ©phone mobile client",
        customerFilter: "Flitre client",
        customerName: "Nom du client",
        customerPhone: "TÃ©lÃ©phone client",
        customerPlease: "SÃ©lectionnez client svp",
        dateFilter: "Filtre de date",
        enterPin: "Entrer votre code pin",
        enterTheNumberOfPackages: "Entrer le nombre de bidons",
        existingCustomer: "Le client existe dÃ©jÃ ",
        fandeckPlease: "SÃ©lectionner un nuancier ",
        fillCanisterHistory: "Historique de remplissage des canisters",
        findCustomer:
            "Pour assisgner une carte de fidÃ©lirÃ© Ã  cette commande, merci de scanner le code barre ou sÃ©lectionner l'adresse email du client",
        findCustomerByEmail: "Filtre client par email ou code barre",
        finishPreviousStep: "(merci de cloturer les Ã©tapes prÃ©cÃ©dentes)",
        formulaUnit: "UnitÃ© de la formule",
        getBackToList: "Retourner Ã  la liste des clients",
        historyOfOrders: "Historique des commandes",
        insertNote: "Aller vers insertion de notes",
        loadHistoryOrder: "Voulez-vous charger la commande sÃ©lectionnÃ©e?",
        loyaltyCards: "Cartes de fidÃ©litÃ©",
        machineIsAvailable: "LA MACHINE EST DISPONIBLE",
        machineIsUnavailable: "LA MACHINE N'EST PAS DISPONIBLE",
        newLoyaltyCard: "Nouvelle carte de fidÃ©litÃ©",
        noAvailableMachine: "La machine n'est pas disponible",
        noCustomerSelected: "Aucun client n'est sÃ©lectionnÃ©. Voulez-vous continuer?",
        notePlease: "InsÃ©rer vos notes svp",
        openHistory: "Ouvrir l'historique ",
        orAdd: "ou ajouter client",
        orSelect: "ou sÃ©lectionner client",
        orderModification: "La commande d'origine sera modifiÃ©e. Voulez-vous continuer?",
        orderOverview: "RÃ©capitulatif de la commande",
        orderToMachine: "ENVOYER MA COMMANDE A LA MACHINE",
        ordersHistory: "Historique des commandes",
        packagePlease: "SÃ©lectionnez un emballage svp",
        pleaseSelectBrand: "SÃ©lectionnez la marque svp",
        previewImage: "PrÃ©visualisation IMG",
        previewPackage: "PrÃ©visualisation de l'emballage",
        productPlease: "SÃ©lectionnez un produit svp",
        resetFilters: "RÃ©initialiser tous les filtres",
        searchForHistoricalOrders: "Ou chercher des commandes passÃ©es",
        selectBrand: "SÃ©lectionnez la marque svp",
        selectColor: "Aller vers sÃ©lection couleur",
        selectCustomer: "Aller vers sÃ©lection client",
        selectExistingCustomer: "SÃ©lectionner client existant",
        selectFandeck: "Aller vers sÃ©lection du nuancier",
        selectManually:
            "Si vous souhaitez utiliser cette couleur dans la marque %{brandNames}, veuillez la sÃ©lectionner manuellement.",
        selectPackage: "Aller vers sÃ©lection de l'emballage",
        selectProduct: "Aller vers sÃ©lection produit",
        shotsCoefficient: "Coefficient shots",
        showDetail: "Montrer le dÃ©tail",
        showHideEshopName: "Afficher / Masquer le nom de la boutique en ligne de la couleur dans une colonne sÃ©parÃ©e",
        showKeyboard: "Montrer le clavier",
        skipCustomerButton: "Passer la sÃ©lection du client",
        skipCustomerText: "Passer si vous ne souhaitez pas renseigner le nom du client",
        skipNote: "Ignorer la prise de notes et voir le rÃ©capitulatif",
        spectroBrand: "Recherche dans la marque %{brandName}",
        statusAccepted: "AcceptÃ©",
        statusCanceled: "AnnulÃ©",
        statusCreated: "CrÃ©Ã©",
        statusDone: "Fait",
        statusPartlyDone: "Fait partiellement",
        statusPreparing: "En cours de prÃ©paration",
        summaryChosenBase: "Base",
        summaryChosenBrand: "Marque",
        summaryChosenCanSize: "Taille de l'emballage",
        summaryChosenColor: "Couleur",
        summaryChosenColorCard: "Carte de couleur",
        summaryChosenProduct: "Produit",
        summaryChosenQuantity: "QuantitÃ©",
        summaryColorPreview: "PrÃ©visualisation de la couleur",
        summaryCustomNote: "Notes personnalisÃ©es",
        summaryCustomerNumber: "NumÃ©ro client",
        summaryFormula: "Formule",
        summaryFormulaNote: "Notes sur la formule",
        summaryNote: "Notes",
        sureAboutSend: "Etes-vous sur que vous souhaitez envoyer une commande?",
        useCustomerInOrder: "Souhaitez-vous utiliser %{customerName} pour la commande suivante ?",
        uuid: "UUID Â«Â identifiant unique universelÂ Â»",
        viewSummary: "Voir rÃ©capitulatif ",
        volume: "Volume"
    },
    customRedlikeAnother: {
        pinOrderConfirmation: "Code confirmation de commande",
        pinScreenSaverConfirmation: "Code confirmation Ã©conomiseur dâÃ©cran",
        pinSettingsConfirmation: "Code confirmation paramÃ¨tres",
        printAuto: "Autoriser impression automatique",
        printerSettings: "ParamÃ¨tres d'impression",
        selectColorWithFandeck: "SÃ©lection gÃ©nÃ©rale de la couleur avec le  nuancier",
        setKeyboard: "ParamÃ©trage clavier",
        setKioskMode: "ParamÃ©trer mode kiosk",
        setLanguage: "ParamÃ©trer la langue",
        setModule: "ParamÃ©trer le module",
        setQuickSelect: "ParamÃ©trer le choix rapide",
        setScreensaverTimeout: "ParamÃ©trage activation Ã©conomiseur dâÃ©cran",
        setUnit: "ParamÃ©trage de lâunitÃ©"
    },
    customRedlikeMachine: {
        action: "Action",
        additionalPrint: "Ãtiquette supplÃ©mentaire",
        brand: "Marque",
        brandAccess: "Lâutilisateur '%{userName}' nâa pas accÃ¨s aux donnÃ©es de la marque '%{brandName}'",
        can: "Boite positionnÃ©e",
        canistersLevel: "Visualisation des niveaux de remplissage des canisters",
        closeDetailInformation: "Fermer le rÃ©capitulatif",
        colorantsAmount: "QuantitÃ© des colorants",
        confirmRefill: "Confirmer le remplissage des colorants",
        deleteOrder: "Supprimer commande",
        dialogNoMachine: "La machine n'est pas connectÃ©e",
        dialogNoRcc: "Le RCC n'est pas connectÃ©",
        dispense: "Doser",
        dispenserInErrorState: "La machine est en mode erreur",
        dispensingIsOk: "Machine OK",
        emergencyButtonPressed: "Le bouton d'arret d'urgence est activÃ©",
        errorCode: "Code erreur",
        errorEvents: "Erreurs listÃ©es par la machine",
        errorReset: "Erreur lors du redÃ©marrage",
        explanation: "Explication",
        imageNotAvailable: "L'image n'est pas disponible",
        incorrectCanister: "Le mauvais canister a Ã©tÃ© scannÃ©",
        incorrectColorant: "Erreur: le mauvais colorant a Ã©tÃ© scannÃ©. SVP scannez le bon colorant.",
        lastEvents: "ActivitÃ© rÃ©cente",
        machineActions: "Capteurs machine",
        machineConfiguration: "Configuration machine",
        machineError: "Erreur machine",
        machineIsBusy: "Machine occupÃ©e",
        machineNotAvailable: "Machine indisponible",
        machineTinting: "Attendez svp, la machine dose",
        manualScan: "Scan manuel",
        notEnoughSpace: "Erreur: il n'y pas assez d'espace pour cet emballage de colorant",
        numberOfCanistersUnderCriticalLevel: "Le nombre de canistres en dessous du niveau critique est  %{0}",
        numberOfCanistersUnderWarningLevel: "Le nombre de canistres en dessous du niveau dâavertissement est  %{0}",
        offlinePressed: "Bouton hors ligne activÃ©",
        orderSettings: "ParamÃ©trage des commandes",
        otherOrderInformation: "DÃ©tail des commandes",
        packageCount: "Compteur d'emballages",
        packageWithSeparator: "Emballage",
        received: "ReÃ§u",
        receivedOrders: "Commandes reÃ§ues",
        receivedTime: "Nombre de fois reÃ§u",
        recirculation: "Recirculation",
        refillInformation: "Colorant: %{0}, Niveau de remplissage: %{1}, Canister: %{2}",
        resetErrors: "Reset des erreurs",
        scanCanister: "Scanner ce canister",
        scanColorantPackage: "Scanner le bon colorant",
        selectedOrder: "Commande selectionnÃ©e",
        shelfMovingDown: "Plateau Ã©lÃ©vateur monte",
        shelfMovingUp: "Plateau Ã©lÃ©vateur descend",
        solution: "Solution",
        startDispensing: "Commencer le dosage",
        stirring: "Agitation",
        touchToStartFilling: "Toucher pour dÃ©marrer le remplissage des colorants",
        unknownBrand: "Marque inconnue"
    },
    customRedlikeSettings: {
        addPos: "POS info",
        addServer: "Ajouter un serveur",
        adminOperations: "Operations d'administration",
        adminSettings: "ParamÃ¨tres d'administration",
        another: "Autre ",
        aslOrService: "ASL ou service",
        availableMachines: "Machines disponibles",
        barcode: "Code barre",
        basicOperations: "Operations basiques",
        canisterBarcodes: "Code Bar des canisters",
        canisterLevels: "Niveau des canisters",
        closeConnection: "Fermer la connexion",
        closeRedlike: "Fermer %{name}",
        databaseList: "Bases de donnÃ©es",
        disabledStatus: "dÃ©sactivÃ©",
        dispenseLogicType: "Type de dosage.",
        dropServers: "Supprimer les serveurs",
        editServer: "Editer informations serveur",
        lastEvent: "ActivitÃ© rÃ©cente",
        logOut: "Se dÃ©connecter",
        machineConfiguration: "Configuration",
        maxDispenseAmount: "QuantitÃ© dosÃ©e maximum",
        offlineStatus: "Non connectÃ©",
        onlineStatus: "ConnectÃ©",
        openFrondesk: "Ouvrir l'accueil",
        print: "ParamÃ¨tres d'impression",
        rebootPC: "RedÃ©marrer le PC",
        restartRedlike: "RedÃ©marrer %{name}",
        restoreConnection: "Restaurer la connection",
        scanCanisterBarcode: "Scanner le code barre du canister",
        scanOrDeleteCanisterBarcode: "Scanner ou effacer code barre",
        setCanisterBarcode: "ParamÃ©trer le canister du code barre",
        swVersion: "Version du logiciel",
        systemFunctions: "Fonctions systÃ¨me",
        userSettings: "ParamÃ¨tre d'utilisateur"
    },
    customTab: {
        cifCombinationCheck:
            "The color %{colorName} already exists in fandeck %{fandeckName}, but it contains different spectral data. Would you like to overwrite existing data?",
        editColor: "Editer couleur",
        editColorant: "Editer colorant",
        emptyColorant: "Il y a un colorant dont la quantitÃ© est nulle",
        formulaCombinationCheck:
            'The formula with the color name "%{colorName}" already exists. Would you like to overwrite existing formula with the new one?',
        formulaForMasterProduct: "Formule du produit principal",
        formulaForMasterProductWithParam: "Formule du produit principal %{productName}",
        isNotAvailable: "n'est pas disponible",
        noBaseSelected: "La base est requise",
        noColorantsSelected: "Aucun colorant sÃ©lectionnÃ©",
        noFandeckSelected: "Le nuancier est requis ",
        noNameOrCode: "Le nom et le code de la couleur sont obligatoires",
        noProductSelected: "Le produit est requis",
        productPreview: "PrÃ©visualisation du produit",
        saveCustomRecipe: "Enregister formule personnalisÃ©e",
        saveIsNotAvailable: "La sauvegarde n'est pas disponible",
        showSiblingProducts: "Afficher les produits apparentÃ©s",
        siblingProducts: "Produits apparentÃ©s par produit principal"
    },
    customersTab: {
        addCustomer: "Ajouter client",
        additionalSettings: "ParamÃ¨tres supplementaires",
        adress: "Adresse",
        createAndSelect: "Ajouter et sÃ©lectionner",
        createNewCustomer: "CrÃ©er nouveau client",
        editCustomer: "2diter client",
        expiration: "Le client %{name} expirera dans %{dayCount} jours",
        identificationNumber: "NumÃ©ro d'identification",
        information: "Information contact",
        listOfCustomers: "Liste des clients",
        rabat: "Remise",
        selectCustomer: "SÃ©lectionner client existant",
        spentLastMonth: "DÃ©pensÃ©/consommÃ© le mois prÃ©cÃ©dent",
        spentMoney: "Argent dÃ©pensÃ©",
        typeOfMargin: "Type de marge",
        zipCode: "Code postal"
    },
    dialog: {
        cheaperColorSearch: "La recherche de couleurs moins chÃ¨res est en cours",
        competitiveColorSearch: "La recherche d'une teinte approchante est en cours.",
        reallyChangeModule: "Voulez-vous vraiment changer le module?",
        reallyCloseRedlike:
            "Souhaitez vous vraiment fermer %{name}? Toutes les fenetres %{name} seront fermÃ©es, toutes les modifications non sauvegardÃ©es seront perdues.",
        reallyDeleteOrder:
            "Voulez-vous vraiment supprimer cette commande? Toutes les informations relatives Ã  cette commande seront perdues.",
        reallyRebootPC:
            "Voulez-vous vraiment redÃ©marrer ce PC? Tous les panneaux de contrÃ´le seront fermÃ©s, les modifications non sauvegardÃ©es seront perdus.",
        reallyRestartRedlike:
            "Voulez-vous vraiment redÃ©marrer %{name}? Tous les panneaux de contrÃ´le seront fermÃ©s, les modifications non sauvegardÃ©es seront perdus.",
        reallyShutdownPc:
            "Souhaitez vous vraiment Ã©teindre l'ordinateur? Toutes les fenetres %{name} seront fermÃ©es, toutes les modifications non sauvegardÃ©es seront perdues.",
        unlockComputer: "L'ordinateur sera dÃ©verrouillÃ©."
    },
    dispenseLogicTypes: {
        1: "Doser uniquement la quantitÃ© maximum dosable",
        2: "Autoriser le dosage manuel en utilisant la balance pour les quantitÃ©s en dessous du maximum dosable",
        3: "Remplir durant le dosage",
        4: "Forcer la distribution manuelle Ã  l'aide d'une balance uniquement dans le cas d'un emballage personnalisÃ©"
    },
    editCustomFandeck: {
        fandeckName: "Nom de nuancier"
    },
    editFormulaRgbModal: {
        apply: "Appliquer",
        blue: "Bleu",
        green: "Vert",
        modalLabel: "Editer couleur",
        red: "Rouge",
        tryGenerateRgb: "Essayer de gÃ©nÃ©rer le RVB par quantitÃ© de colorants"
    },
    environmentsSettings: {
        allowAutoCloseTab: "Fermer automatiquement l'onglet de formule",
        allowBarcodes: "Autoriser code barres",
        allowBuildingSitePanel: "Permettre la spÃ©cification du chantier",
        allowCustomers: "Autoriser clients",
        allowDeleteConfirmation: "Activer les confirmations de suppression",
        allowDiskSpaceNotification: "Autoriser la notification de lâespace disque",
        allowDispensing: "Autoriser dosage",
        allowFileTransfer: "Autoriser le transfert automatique de fichiers",
        allowFormulaModificationPanel: "Autoriser le panneau de modification de la formule",
        allowFormulaStatusPanel: "Autoriser le panneau de statut des formules",
        allowInternalNotes: "Autoriser les notes internes",
        allowLight: "Autoriser %{name}",
        allowOrderNotificationModal: "Afficher notifications pour les nouvelles commandes",
        allowOrdering: "Autoriser les commandes",
        allowPricing: "Autoriser la tarification",
        allowPrint: "Autoriser impression",
        allowProductPreviewImage: "Autoriser le chargement des photos produits pendant le dosage",
        allowQualityControl: "Allow quality control",
        allowSearchCheaperColors: "Permettre la recherche de couleurs moins chÃ¨res",
        allowSound: "Autoriser les notifications sonores pour les commandes",
        allowSpectro: "Autoriser spectro",
        allowTabs: "Autoriser onglets",
        applyZoom: "Autoriser zoom",
        automaticLogout: "DÃ©connexion automatique",
        barcodeScan: "Scan du code-barres",
        canisterBarcode: "Code barre des canisters",
        canisterLevel: "Niveau des canisters",
        changelog: "Journal des changements",
        closeTab: "Ferme tableau",
        colorDifference: "Ãcart de couleur",
        colorPanelNavItem: "Palette",
        competitiveColorSearch: "Recherche d'une teinte approchante",
        customBanner: "BanniÃ¨re personnalisÃ©e",
        customCurrencyFormat: "Format de devise",
        customDateFormat: "Format de date",
        customNumberFormat: "Format des chiffres",
        customTimeFormat: "Format de lâheure",
        deltaA: "Delta A",
        deltaB: "Delta B",
        deltaE: "Delta E",
        deltaL: "Delta L",
        deltaMetamerism: "Delta metamerism",
        discount: "Afficher la rÃ©duction",
        dispensingHistory: "Historique",
        dispensingNotes: "Autoriser les notes de dosage",
        enableCustomers: "Activier clients",
        enableDeleteConfirmation: "Activer la confirmation de suppression",
        enableDispensing: "Autoriser dosage",
        enableLight: "Activer %{name}",
        enableMarginMarkup: "Autoriser marges ",
        enableNotes: "Autoriser notes",
        enableOrdering: "Autoriser commandes",
        enableProductPreviewImage: "Autoriser prÃ©visualisation de l'image",
        enableSpectro: "Autoriser spectro",
        enableVirtualKeyboard: "Autoriser clavier virtuel",
        environmentsSettings: "ParamÃ¨tres d'environnement",
        exportTranslationKeys: "Exporter les clÃ©s de traduction",
        formulaNotes: "Autoriser les notes sur formule",
        hintTooltips: "informations et conseils",
        image: "Image",
        keyboardShortcuts: "Raccourcis clavier",
        languageBased: "BasÃ© sur la langue",
        lockYourComputer: "Verrouiller votre ordinateur",
        machineReset: "Reset machine",
        manageTranslations: "GÃ©rer les traductions",
        margin: "Marges uniquement",
        markup: "Markup uniquement",
        matchingRowCount: "ParamÃ©trer le nombre de formules Ã  trouver",
        maxNumberTabs: "Nombre maximum de formules",
        memoryTabs: "Conserver les onglets rÃ©cemment ouverts",
        moreInfo: "Couleur + image + info complÃ©mentaires",
        navigationItems: "ParamÃ¨tres des icones de navigation",
        newTab: "Nouveau tableau",
        numberOfPriceGroups: "Nombre de groupes de prix",
        order: "Commande",
        orderId: "ID commande",
        ordersHistory: "Historique des commandes",
        overwriteLastTab: "Remplacer le dernier onglet formule",
        priceCalculation: "Calcul des prix",
        priceDefBothPurchasePrimary: "Les deux, achat primaire",
        priceDefBothSellPrimary: "Les deux, vente primaire",
        priceDefPurchaseOnly: "Prix dâachat uniquement",
        priceDefSellOnly: "Prix de vente uniquement",
        priceDefinition: "DÃ©finition du prix",
        priceGroupsEnabled: "Activer les groupes de prix",
        runLightAtStartUp: "Lancer %{light} au dÃ©marrage",
        screenSaverTimeout: "DÃ©lai d'expiration de l'Ã©conomiseur d'Ã©cran",
        selectedSpectro: "Spectro sÃ©lectionnÃ© %{spectro}.",
        selectedSpectroNone: "Aucun spectro sÃ©lectionnÃ©.",
        setAutomaticClientStart: "Lancer %{name} au dÃ©marrage de l'ordinateur",
        setCustomHomeButton: "Configurer le bouton retour",
        setDecimalPlaces: "Configurer le nombre de chiffres aprÃ¨s la virgule",
        setFormulaPreview: "Configurer la prÃ©visualisation des formules",
        setFormulaUnit: "Configurer les unitÃ©s de formule",
        setFts: "Utiliser la checherche de texte intÃ©gral",
        setInfoItemInRgb: "Configurer les informations visibles dans le panneau de prÃ©visualisation des couleurs",
        setKeyboardShortcuts: "Configurer les raccourcis clavier",
        setKioskMode: "Configure le mode kiosk",
        setKioskModeOff: "DÃ©sactiver mode kiosk",
        setKioskModeOn: "Activer mode kiosk",
        setNavigationItems: "Configuration les icones de navigation",
        setNavigationItemsList: "Configurer la visibilitÃ© et l'ordre des icones de navigation",
        setOrderSearchItems: "Configurer les paramÃ¨tres de recherche des commandes",
        setRounding: "ParamÃ©trer lâarrondi",
        setSearchParameters: "Configurer les parmÃ¨tres de recherche de formule",
        setTabLimit: "Configurer les limites de table",
        setYourLanguage: "Configurer la langue",
        setZoom: "Configurer le zoom",
        showLocalPrices: "Show local prices",
        skipPlaceCanDialogEnabled:
            "Ce paramÃ¨tre ne peut pas etre changÃ© car la fenetre de dialogue positionner l'emballage a Ã©tÃ© dÃ©sactivÃ© dans les ParamÃ©tres Machine",
        sortItems: "Tried les icones de navigation",
        startDispensing: "Commencer le dosage",
        stir: "Agitation des canisters"
    },
    error: {
        errorDetail: "DÃ©tail de l'erreur",
        errorOccurred:
            "Une erreur inattendue sâest produite. Contactez notre Ã©quipe dâassistance au %{0}, et nous vous rÃ©pondrons dÃ¨s que possible.",
        hideDetail: "Cacher le dÃ©tail"
    },
    favoritesTab: {
        addFolder: "Ajouter un dossier",
        closeTabToLoadFormula:
            "SVP fermez une des formules pour ouvrir un nouveau tableau. Vous avez atteint le nombre maximum de tableaux.",
        deleteFolder: "Supprimer dossier",
        editFolder: "Editer dossier",
        favoriteFormulas: "Formules favorites",
        formulaNotes: "Notes de formule",
        message: {
            formulasFromFolder: "Formules depuis le dossier",
            moveAllFormulas: "DÃ©placer toutes les formules de ce dossier vers son parent",
            removeAllFormulas: "Supprimer toutes les formules de ce dossier",
            wantToDeleteFolder: "Voulez-vous vraiment supprimer ce dossier?"
        },
        newFolder: "Nouveau dossier",
        packages: "Emballages",
        pricePerPackage: "Prix par emballage",
        regularPrice: "Prix standard",
        removeFromFavorites: "Retirer des favoris",
        specialPriceOff: "Prix spÃ©cial %{number}% de rÃ©duction",
        specialPriceVIP: "Prix special VIP"
    },
    fileTransfer: {
        afterImport: "AprÃ¨s importation",
        alreadyExists: "La tÃ¢che pour le type et le format donnÃ©s existe dÃ©jÃ ",
        customFormulaSimple: "Formule personnalisÃ©e simple",
        direction: "Direction",
        exportTask: "Exportation de fichiers",
        fileTransferNotification: "Avis de transfert de fichiers",
        flashMessage: "Message flash",
        importTask: "Importation de fichiers",
        noInformation: "Aucune information",
        protocol: {
            folder: "Dossier",
            ftp: "Protocole FTP",
            ftps: "Protocole FTPS",
            redlikeStorage: "%{softwareName} Protocole de stockage FTP",
            sftp: "SFTP protocol"
        },
        protocolDescription: {
            folder: "VÃ©rification du protocole des fichiers dans le dossier local dÃ©fini.",
            ftp: "Protocole vÃ©rifiant les fichiers dans un dossier FTP distant Ã  lâaide dâune connexion FTP standard.",
            ftps: "Protocole de vÃ©rification des fichiers dans le serveur distant FTPS (FTP-SSL / FTP Secure) Ã  lâaide dâune connexion FTP standard.",
            redlikeStorage: "Protocole de vÃ©rification des fichiers dans le stockage %{softwareName}."
        },
        remoteFolder: "Dossier distant",
        startType: "Type de dÃ©part",
        statusbar: "Informations sur la barre dâÃ©tat",
        testConnection: "Test de connexion",
        xMoreLeft: "(%{amount} more left)",
        xmlImporting: "XML file is being imported"
    },
    filtering: {
        consumptionType: "Type de consommation",
        filter: "Filtre ",
        from: "Depuis",
        to: "Vers"
    },
    findText: {
        findTextTitle: "Rechercher du texte",
        removeMarks: "Supprimer les marques",
        search: "Recherche de mot"
    },
    flashMessage: {
        VMNotAllowed: "VM pas autorisÃ©",
        addedToStock: "Successfully added items to stock",
        allRecordsDeleted: "Ous les enregistrements importÃ©s ont Ã©tÃ© supprimÃ©s avec succÃ¨s",
        autologinFailed: "La connexion automatique Ã  la base de donnÃ©es a Ã©chouÃ©.",
        autotaskDuplicateName:
            "Database integrity error: %{0} item with %{1} %{2} already exists, please use different %{3}",
        barcodeIsUsed: "Le code-barres est dÃ©jÃ  utilisÃ©.",
        barcodeNotFound: "Le code barre n'a pas Ã©tÃ© trouvÃ©",
        bugReportSent: "Votre rapport d'erreur a Ã©tÃ© envoyÃ©",
        cannoctConnectToServer: "Echec connection serveur",
        cannotWriteLicense: "Echec lecture licence",
        clientConnectionRejected: "Connection rejetÃ©e",
        clientNotLoggedIn: "Le client n'est pas connectÃ©e",
        colorFromInactiveDatabase: "Color is from inactive database %{0}.",
        colorantPackageRemovedStock: "Le bidon de colorant a Ã©tÃ© retirÃ© du stock avec succÃ¨s.",
        competitiveSearchEmpty:
            "Aucune teinte approchante trouvÃ©e. Lancez une formulation ou faites une demande de contretypage.",
        competitiveSearchSelectProduct: "Please select product to start competitive color search.",
        computerBackdated: "Ordinateur antidatÃ©",
        connectionFailed: "Ãchec du test de connexion : %{0}",
        connectionSuccess: "Le test de connexion a rÃ©ussi",
        corruptedLicenseFile: "Fichier licence corrompu",
        customFormulaCreated: "Formule locale crÃ©Ã©e avec succÃ¨s !",
        customFormulaCreationError: "Error while creating custom formula.",
        customFormulaFromXmlCreationError:
            "Error while creating custom formula with colorants '%{colorants}' for combination of product '%{product}', fandeck '%{fandeck}', color '%{color}' and base '%{base}'.",
        customerNotFound: "Le client n'a pas Ã©tÃ© trouvÃ©",
        dataNotAvailable: "Le serveur ne peut pas se connecter Ã  la base de donnÃ©es",
        datacolorMatching: {
            couldNotConnect:
                "Impossible de se connecter Ã  Datacolor Matching, soit le serveur est en panne, soit le PC est hors ligne.",
            disabled: "Datacolor Matching dÃ©sactivÃ©.",
            internalError: "Erreur interne de Datacolor Matching : '%{0}'",
            invalidCredentials: "No or invalid credentials for Datacolor Matching provided, contact database provider.",
            noCansAvailable: "No cans available for selected color file (product line), contact database provider."
        },
        defaultMessage: "Une erreur inattendue a eu lieu durant la derniÃ¨re action du serveur",
        deleteAll: "Supprimer tout",
        deletingImportedData: "Suppression des enregistrements importÃ©s.",
        disableWinterPlugin:
            "Vous pouvez dÃ©sactiver le plugin d'hiver en utilisant la liste dÃ©roulante sur le cÃ´tÃ© droit de l'onglet de navigation",
        duplicateBarcode: "Dupliquer code-barres dÃ©jÃ  existant.",
        duplicateName: "Le nom du duplicata existe dÃ©jÃ¡",
        emptyFandeck: "Selected fandeck is empty.",
        emptyStock: "There are no records in stock for the item you have used.",
        expiredLicense: "La licence a expirÃ©e",
        exportSuccess: "Les donnÃ©es ont Ã©tÃ© exportÃ©es avec succÃ©s",
        fandeckExist: "Ce nom de nuancier personnalisÃ© existe dÃ©jÃ .",
        featureNotAutorized: "Option non autorisÃ©e",
        fileExportComplete: "Le fichier a Ã©tÃ© importÃ© avec succÃ¨s",
        fileExportError: "An error occurred during file export.",
        fileSaveComplete: "Le fichier a Ã©tÃ© enregistrÃ© avec succÃ¨s.",
        fileSaveError: "An error occurred during file saving.",
        fileTransferCustomFormulaRecordsAdded:
            "De nouveaux enregistrements de formules personnalisÃ©es ont Ã©tÃ© ajoutÃ©s Ã  partir du fichier reÃ§u.",
        fileTransferCustomFormulaRecordsNotFullyProcessed:
            "Impossible de traiter entiÃ¨rement les donnÃ©es de la formule personnalisÃ©e dans le fichier : '%{0}', voir les fichiers journaux d'erreur pour plus d'informations.",
        fileTransferCustomFormulaRecordsProcessed:
            "The new custom formula records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferCustomerRecordsAdded:
            "De nouveaux enregistrements de clients ont Ã©tÃ© ajoutÃ©s Ã  partir du fichier reÃ§u.",
        fileTransferCustomerRecordsNotFullyProcessed:
            "Impossible de traiter entiÃ¨rement les donnÃ©es des clients dans le fichier : '%{0}', voir les fichiers journaux d'erreurs pour plus d'informations.",
        fileTransferCustomerRecordsProcessed:
            "The new customer records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferFileNotProvided: "Fichier non fourni ou vide.",
        fileTransferHistoryRecordsAdded:
            "De nouveaux enregistrements de l'historique ont Ã©tÃ© ajoutÃ©s Ã  partir du fichier reÃ§u.",
        fileTransferHistoryRecordsNotFullyProcessed:
            "Impossible de traiter complÃ¨tement les donnÃ©es de l'historique de distribution dans le fichier : '%{0}', voir les fichiers journaux d'erreurs pour plus d'informations.",
        fileTransferHistoryRecordsProcessed:
            "The new history records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferInvalidFile: "Impossible de traiter les donnÃ©es du fichier, le fichier nâest pas valide.",
        fileTransferOrderRecordsAdded:
            "De nouveaux enregistrements de commandes ont Ã©tÃ© ajoutÃ©s Ã  partir du fichier reÃ§u.",
        fileTransferOrderRecordsNotFullyProcessed:
            "Impossible de traiter entiÃ¨rement les donnÃ©es de la commande dans le fichier : '%{0}', voir les fichiers journaux d'erreurs pour plus d'informations.",
        fileTransferOrderRecordsProcessed:
            "The new order records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferUnknownVersion: "Impossible de dÃ©tecter la version du fichier.",
        filetransferNoData: "Pas de connexion Ã  la base de donnÃ©es, vÃ©rifiez les paramÃ¨tres",
        formulaDataUnavailable: "Formule non disponible",
        helperDefaultMessage: "Une erreur inattendue a eu lieu durant la derniÃ¨re action du serveur d'aide",
        helperServerError: "Erreur du serveur d'aide",
        importAborted: "Le processus d'import de donnÃ©es a Ã©tÃ© interrompu",
        importSuccess: "Les donnÃ©es ont Ã©tÃ© importÃ©es avec succÃ©s",
        incompatibleBaseCan: "L'emballage n'est pas comptabile avec le produit choisi",
        incorrectPassword: "Mot de passe faux. Saisissez le bon mot de passe svp",
        invalidCurrency: "Le code monÃ©taire saisi n'est pas valide. L'Euro est enregistrÃ© comme monnaie par dÃ©faut.",
        invalidDatabaseName: "Le nom de la base de donnÃ©es n'est pas valide",
        invalidEmail: "Votre email n'est pas valide",
        invalidFormulaColorants:
            "There is the software issue in the formula. Formula could be wrong! Contact your support!",
        invalidLicenseCompanyUserKey: "ClÃ© client-sociÃ©tÃ© invalide",
        invalidLicenseFile: "Fichier licence invalide",
        invalidLicenseIdentificationKeys: "Votre clÃ© d'identification licence n'est pas valide",
        invalidLicenseKey: "Votre licence n'est pas valide",
        invalidLicenseProduct: "Votre fichier licence ne correspond pas avec le produit",
        invalidRccResponse: "Une erreur inattendue a eu lieu durant le traitement de la derniÃ¨re requete RCC",
        invalidServerResponse: "Une erreur inattendue a eu lieu durant le processus de la derniÃ¨re requete",
        invalidUrl: "URL non valide",
        itemNotFound: "L'article n'a pas Ã©tÃ© trouvÃ©",
        keyboardShortcutUsedInModal:
            "Ce raccourci clavier ne peut pas etre utilisÃ© dans cette fenetre. Fermez cette fenetre svp",
        keyboardShortcutValidation:
            "Vous ne pouvez pas utiliser le meme raccourci clavier pour deux actions diffÃ©rentes.",
        licenseHasBeenRevoked:
            "Votre licence a Ã©tÃ© annulÃ©e. Pour la renouveller, veuillez contacter votre founrisseur de logiciel.",
        licenseProlongationNeeded:
            "Prolongation de licence requise ( Connectez votre PC Ã  internet pour obtenir une nouvelle licence)",
        licenseUpToDate: "Your license is up to date. No update necessary.",
        licenseUpdateUnsuccessful: "Impossible de mettre Ã  jour la licence.",
        licenseUpdated: "La licence a Ã©tÃ© mise Ã  jour avec succÃ¨s.",
        licensedOnDifferentComputer: "DÃ©jÃ  activÃ©e sur un autre PC",
        logFileArchiveDownloadComplete: "Chargement du fichier LOG effectuÃ©",
        loginError: "Une erreur inattendue a eu lieu durant le processus de connection",
        logoutError: "Une erreur inattendue a eu lieu durant le processus de dÃ©connection",
        machineIsConnecting: "La machine se connecte, attendez svp",
        machineIsNotConnected: "Votre machine n'est PAS CONNECTEE au RCC. VÃ©rifiez les paramÃ¨tres RCC svp",
        malformedFormula: "La formule est malformÃ©e.",
        matching: {
            correctionNotPossible: "Correction cannot be done, use reformulation.",
            forbidden: "Request '%{0}' failed: forbidden.",
            internalServerError: "Erreur interne du serveur.",
            invalidBase: "Invalid base in product.",
            invalidBipp: "Invalid base in product package.",
            invalidColorantId: "Colorant non valide avec ID : %{0}.",
            invalidColorantName: "Colorant non valide avec le nom : %{0}.",
            invalidColorfile: "Fichier de couleur non valide avec ID : %{0} pour le produit avec ID : %{1}.",
            invalidIlluminant: "Invalid illuminant: %{0}",
            invalidProduct: "Produit non valide avec ID : %{0}.",
            invalidSpectralCurve: "Courbe spectrale invalide.",
            noColorfiles: "No color files defined for product with ID: %{0}.",
            notAuthorized: "Request '%{0}' failed: unauthorized.",
            notFound: "Request '%{0}' failed: not found.",
            reformulationNotPossible: "Reformulation cannot be done.",
            unknownError: "Unknown error.",
            validationError: "Request '%{0}' failed due to validation errors: %{0}."
        },
        maxFileSizeExceeded: "DÃ©passement de la taille maximale du fichier de %{0} MB",
        maxTabs: "Nombre maximum de tables ouvertes atteint, fermez en une svp",
        noTemplate: "L'impression ne peut pas se faire car il n'y a aucun modÃ¨le d'Ã©tiquette disponible.",
        openNewTab: "Veuillez ouvrir un nouvel onglet de formule pour charger la formule Ã  l'aide du codes barres",
        orderAlreadyAcquired: "Commande a dÃ©jÃ  Ã©tÃ© transmise, traitement en cours",
        orderCreated: "La commande a Ã©tÃ© envoyÃ© avec succÃ©s",
        passwordIsNotUnique: "L'ancien mot de passe et le nouveau doivent etre diffÃ©rents",
        printCannotBeCarriedOut: "L'impression ne peut pas se faire car le nom de l'imprimante est incorrect.",
        problemWithFileExport: "Malheureusement, un problÃ¨me a eu lieu durant la sauvegarde du fichier LOG.",
        productFileWarning: "La fiche produit est uniquement disponible en ligne.",
        productNotLicensed: "Produit non licenciÃ©",
        rccDefaultMessage: "Une erreur inattendue a eu lieu durant la derniÃ¨re action RCC",
        rccError: "Erreur RCC",
        rccNeedRestart: "RedÃ©marrer votre RCC svp",
        restoredSettings: "Les paramÃ¨tres ont Ã©tÃ© restaurÃ©s.",
        revokedLicense: "La licence a Ã©tÃ© rÃ©voquÃ©e",
        runningOutOfSpace: "Lâordinateur manque dâespace libre.",
        savedFormulaToHistory: "La formule a Ã©tÃ© enregistrÃ©e dans l'historique",
        savedLogArchive: "la sauvegarde LOG a Ã©tÃ© effectuÃ©e",
        scanning: "Balayage de codes-barres en cours",
        serverError: "Erreur serveur",
        setClientIdentifier: "Configurer l'identifieur de client",
        showLess: "Montrer moins",
        showMore: "Montrer plus",
        spectroIsDisconnecting: "Spectro en cours de dÃ©connection, attendez svp",
        spectroIsNotConnected: "Votre spectro n'est PAS CONNECTE Ã  ce moment. VÃ©rifiez votre configuration RCC",
        spectroIsNotSelected: "Votre spectro n'est PAS SELECTIONNE Ã  ce moment. VÃ©rifier votre configuration RCC",
        tmcNotAvailable: "%{tmc} is not available. Please check your %{collector}.",
        tmcNotConnected: "%{tmc} is not connected. Please start your %{collector} and restart server.",
        unknownError: "Erreur inconnue: %{0}",
        userAlreadyLoggedIn: "Vous Ã©tes dÃ©jÃ  connectÃ©!",
        versionNotAllowedByLicense: "Software version is too new and is not allowed for your license.",
        webApiConnectionError: "N'a pas pu se connectÃ© au serveur WEB API",
        webApiInternalError: "Erreur WEB API serveur",
        webApiInvalidUser: "Erreur d'identification utilisateur serveur WEB API",
        webApiNoLicenseAvailable: "Pas de licence disponible pour le WEB API serveur",
        wrongDataSaved: "Wrong data was saved to XML file in the %{0} folder.",
        wrongHelpInput: "Mauvais format d'entrÃ©e de %{0}.",
        wrongRccVersion: "VÃ©rifier la version de votre RCC. Votre client est uniquement compatible avec le RCC %{0}."
    },
    footer: {
        aboutApplication: "A propos de l'application",
        activeUser: "Utilisateur actif.",
        logOut: "DÃ©connection",
        machineErrors: "Erreurs machine"
    },
    formulaProperties: {
        exterior: "Exterior",
        interior: "Interior",
        invalid: "Invalid",
        solvent: "Solvent based",
        universal: "Universal",
        water: "Water based"
    },
    formulaSettings: {
        allUnits: "Toutes les unitÃ©s disponibles dans la base de donnÃ©es",
        allowCustomFormulas: "Autoriser formules personnalisÃ©e",
        allowCustomPackageSize: "Autoriser taille emballage personnalisable",
        allowFormulaAutomaticNaming: "Autoriser la nomination automatiques",
        automaticNaming: "Nomination automatique des formules",
        basePanelSize: "DÃ©finir la taille du panneau de base",
        bippPanelSize: "DÃ©finir la taille de la base dans le panneau de lâemballage du produit",
        blendColorNameAndCode: "Nom et code de la teinte",
        buttonBellowMoreInfo: "Show button below formula notes",
        buttonInColorantPanel: "Show button in Colorants panel",
        colorCodePrimary: "Code couleur en premier lieu",
        colorPanel: "Palette",
        colorPreviewAsImage: "AperÃ§u des couleurs en tant quâimage",
        colorPreviewResizable: "AperÃ§u des couleurs redimensionnables",
        competitiveColorSearch: "Recherche d'une teinte approchante",
        customFormula: "Custom formula",
        customFormulaForMasterProduct: "Allow create custom formulas for master product",
        customFormulaForMasterProductDefault: "Checked by default",
        customFormulas: "Formules personnalisÃ©es",
        customPackageSettingsUnitGrav: "ParamÃ¨tres personnalisÃ©s de lâemballage unitÃ© gravimÃ©trique",
        customPackageSettingsUnitVol: "ParamÃ¨tres personnalisÃ©s de lâemballage unitÃ© volumÃ©trique",
        customPackageSize: "Taille emballage personnalisÃ©e",
        customUnits: "Choisissez des unitÃ©s personnalisÃ©es",
        dropDownCalculate: "DÃ©velopper le menu dÃ©roulant jusqu'Ã  la hauteur de la fenÃªtre",
        editColorants: "Editer colorants",
        editColorantsAllowed: "Autoriser Ã©dition liste colorants",
        fandeckPanelSize: "DÃ©finir la taille du panneau du nuancier",
        favoriteFormulas: "Formules favorites",
        formulaColorPreview: "PrÃ©visualisation de la formule couleur",
        formulaDataSettings: "ParamÃ¨trage des donnÃ©es de formule",
        formulaPanel: "Panneau de formule",
        formulaPanelSize: "DÃ©finir la taille du panneau de formule",
        formulaSettings: "ParamÃ¨tres de formulate",
        generateColorPreview: "GÃ©nÃ©rer un aperÃ§u des couleurs",
        gravimetricOnly: "UnitÃ©s gravimÃ©triques uniquement",
        hideAlternativeFormulas: "Masquer les formules alternatives",
        hideFormulaProperties: "Masquer les propriÃ©tÃ©s de la formule",
        hideHistoricalFormulas: "Cacher les formules de l'historique",
        imagesLocal: "Utiliser uniquement lâimage de la base de donnÃ©es locale",
        imagesOnline: "En premier lieu, essayez dâouvrir lâimage en ligne, si cela Ã©choue, ouvrez lâimage locale.",
        infoPanelResizable: "Panneau dâinformation redimensionnable",
        numberOfColorants: "Number of shown colorants",
        orderByDistance: "Order of search results by the distance",
        productDependent: "L'unitÃ© dÃ©pend du produit sÃ©lectionnÃ©",
        productFilesDialog: "Afficher le dialogue pour ouvrir le fichier local ou le fichier en ligne",
        productFilesLocal: "Utiliser uniquement les fichiers produits de la base de donnÃ©es locale",
        productFilesOnline:
            "En premier lieu, essayez dâouvrir le fichier produit en ligne, en cas dâÃ©chec, ouvrez le fichier local.",
        productPanelSize: "DÃ©finir la taille du panneau du produit",
        searchPanelQuickSelect: "SÃ©lection rapide",
        setAdditionalFormulaPanel: "Configurer panneau de formule additionel",
        setCompetitiveColorSearch: "Recherche teinte concurrente Ã©quivalente",
        setInitialFormulaPanel: "Configurer pannea ude formule initial",
        setMaxToleranceForCompetitiveColors: "RÃ©gler au maximum la tolÃ©rance de recherche de teinte approchante.",
        setNumberOfCompetitiveColors: "RÃ©gler le nombe de teintes approchantes",
        setSearchPanel: "RÃ©gler l'Ã©cran de recherche",
        setVisibilityAndOrder: "Configurer la visibilitÃ© et l'ordre des formules",
        setVisibleUnit: "Configurer les unitÃ©s visibles",
        showColorPreview: "Montrer prÃ©visualisation couleur",
        showInFormulaStatusPanel: "Show in formula status panel",
        showInMoreInfoPanel: "Show in formula notes",
        sorting: "Tri des panneaux de colorants",
        useBase: "Utiliser un Ã©lÃ©ment de sÃ©lection pour la base",
        useBaseInProductPackage: "Utiliser un Ã©lÃ©ment de sÃ©lection pour la base dans lâemballage du produit",
        useColorCode: "Use color code",
        useColorName: "Use color name",
        useFandeckGroups: "Use fandeck groups",
        useProduct: "Utiliser un Ã©lÃ©ment de sÃ©lection pour le produit",
        useProductCode: "Utiliser le code produit",
        useProductGroups: "Utiliser les groupes de produits",
        volumetricOnly: "UnitÃ©s volumÃ©triques uniquement"
    },
    general: {
        accepted: "Accepted",
        active: "DerniÃ¨re activitÃ©",
        actual: "RÃ©el",
        actualLevel: "Niveau actuel",
        add: "Ajouter",
        addColorant: "Ajouter colorant",
        addColorantForPackage: "Add colorant for package",
        addFile: "Ajouter fichier",
        all: "Tous",
        amount: "QuantitÃ©",
        applyNow: "Apply now",
        attachments: "PiÃ¨ces jointes",
        automaticCorrection: "Automatic correction",
        automatically: "Automatiquement",
        available: "Disponible",
        back: "Retour",
        base: "Base",
        baseInProductPackage: "Base dans produit et emballage",
        batchNumber: "NÂ°LOT",
        bottom: "Bas",
        buildingSite: "Chantier",
        calculate: "Calculer",
        can: "Emballage",
        canSize: "Taille emballage ",
        cancel: "Annuler",
        canister: "Canister",
        canisterId: "ID Canister",
        canisterIndex: "Canister Indice",
        canisters: "Canisters",
        cap: "Bouchon",
        capacity: "CapacitÃ©",
        channels: "Circuits",
        choose: "Choisir",
        city: "Ville",
        clean: "Nettoyer Autocap",
        clear: "Transparent",
        client: "Clients",
        close: "Fermer",
        closeAll: "Fermer tout",
        collapseAll: "RÃ©duire tous",
        color: "Couleur",
        colorCode: "Code couleur",
        colorFile: "Colorfile",
        colorName: "Couleur",
        colorPreview: "PrÃ©visualisation couleur",
        colorant: "Colorant",
        colorantBatchNumber: "Colorant Batch number",
        colorantPackage: "Emballage colorant ",
        colorants: "Colorants",
        colors: "Colors",
        company: "SociÃ©tÃ©",
        competitiveColor: "Couleur approchante",
        confirm: "Confirmer",
        confirmDeletion: "Souhaitez-vous vraiment supprimer cet Ã©lÃ©ment de faÃ§on permanente ?",
        confirmHelpSettings:
            "Souhaitez-vous vraiment enregistrer le formulaire et laisser certain champs non remplis  ?",
        connect: "Connecter ",
        continue: "Suivant",
        correction: "Correction",
        country: "Pays",
        created: "CrÃ©Ã©",
        creationDateOf: "Date de crÃ©ation de",
        criticalLevel: "Niveau critique",
        currency: "Devise",
        currentBatchNumber: "Current batch number",
        currentUfiCode: "Current UFI code",
        custom: "AccÃ¨s formules labo",
        customData: "Custom data",
        customFandeck: "Nuancier personnalisÃ©",
        customFormula: "CrÃ©ation formule locale",
        customPackage: "Personnaliser",
        customPackageSettings: "ParamÃ¨tres des emballages personnalisÃ©s",
        customer: "Client",
        customerVersion: "Version client",
        customers: "Clients",
        database: "Base de donnÃ©es",
        date: "Date",
        default: "Par dÃ©faut",
        delete: "Suppimer",
        deleteImportedData: "Supprimer les enregistrements importÃ©s",
        delta: "Delta",
        description: "Description",
        disconnect: "DÃ©connecter",
        discount: "Remise",
        discover: "DÃ©couvrir",
        dispense: "Doser",
        dispensing: "Dosage en cours",
        doNotShowAgain: "Ne plus afficher ce message",
        downloadingFile: "Fichiers de tÃ©lÃ©chargement",
        edit: "Editer",
        email: "Email",
        enabled: "AutorisÃ©",
        error: "Erreur",
        expandAll: "DÃ©velopper tout",
        exportData: "Exporter des donnÃ©es",
        exportPdf: "Exporter le PDF",
        fan: "Nuancier",
        fandeck: "Nuancier ",
        fandeckCode: "Fandeck code",
        fandeckName: "Nom du nuancier",
        fandecks: "Nuanciers",
        favorite: "Favori",
        fileTransfer: "Transfert de fichier",
        filling: "Remplissage",
        fillingDate: "Date de remplissage",
        find: "Trouver",
        finish: "Finition",
        finishedCorrection: "Finished correction",
        formula: "Formule",
        formulas: "Formulas",
        frontdesk: "Bureau dâaccueil",
        getQrCode: "Obtenir QR code",
        gravimetric: "GravimÃ©trique",
        historical: "Historical",
        history: "Historique",
        hours: "Hou.",
        id: "ID Canister",
        images: "Images",
        in: "Dedans",
        index: "Indice",
        insertBarcode: "InsÃ©rer code barre svp",
        install: "Installation",
        installed: "InstallÃ©",
        instructions: "Instructions",
        internalNote: "Note interne",
        interval: "Intervalle",
        ip: "Adresse IP",
        itemNumber: "Pas d'item",
        itemXOfY: "Item %{x}/%{y}",
        itemsCount: "Nombre de lignes ",
        later: "Later",
        limit: "Limite",
        load: "Chargement",
        loadFormula: "Charger la formule",
        localVersion: "Version locale",
        machine: "Machine",
        manualCorrection: "Correction manuelle",
        manually: "Ã la main",
        margin: "Marge",
        markup: "Markup uniquement",
        matching: "Formulation spectro",
        matchingFormula: "Matching formula",
        maxLevel: "Niveau maximum",
        maxValue: "Valeur max",
        maximum: "Maximum",
        mayTakeAWhile: "This may take a while",
        measured: "Measured",
        metamarism: "MÃ©tamÃ©risme",
        minimum: "Minimum",
        minutes: "Min.",
        missingItem: "Article manquant",
        missingRequiredItems: "Tous les Ã©lÃ©ments marquÃ©s q'un asterisk doivent Ãªtre renseignÃ©s",
        modified: "Modified",
        modifiedAutomaticCorrection: "Target color correction",
        modifiedCustomFormula: "Modified custom formula",
        modifiedStandardFormula: "Modified standard formula",
        moduleChange: "Changement de module",
        more: "Plus",
        moreInfo: "Plus d'information",
        moveDown: "Baisser",
        moveUp: "Monter",
        myOrders: "Mes commandes",
        name: "Nom",
        nameTitle: "Nom",
        new: "Nouveau",
        next: "Suivant",
        no: "Non",
        noColorantsAvailable: "Aucun colorant disponible",
        noFormulas: "Aucune formule pour l'instant",
        noPricesAvailable: "Aucun prix disponible",
        nominalAmount: "QuantitÃ© nominale",
        notAvailable: "Non disponible",
        note: "Notes",
        numberOfCanisters: "Nombre de canisters",
        numberOfItemCount: "Number of '%{item}': %{count}",
        numberOfLabels: "Nombre d'Ã©tiquettes",
        numberOfPackages: "Nombre de bidons",
        off: "OFF",
        ok: "Ok",
        on: "En marche",
        onFocus: "Sur la mise au point",
        open: "Ouvrir",
        operator: "OpÃ©rateur",
        options: "Options",
        order: "Order",
        other: "Autre",
        otherError: "Autre erreur",
        out: "Dehors",
        overwrite: "Overwrite",
        package: "Emballage",
        packagePreview: "PrÃ©visualisation emballage",
        partialUpdates: "Partial updates",
        phone: "TÃ©lÃ©phone",
        pleaseWait: "Veuillez patienter",
        previous: "Previous",
        price: "Prix",
        priceGroup: "Groupe de prix",
        print: "Imprimer",
        printTask: "TÃ¢che d'impression",
        processingStep: "Processing %{step}",
        product: "Produit",
        productCode: "Code produit",
        productName: "Nom du produit",
        products: "Produits",
        pump1: "Pomper 1",
        pump2: "Pomper 2",
        purchasePrice: "Prix d'achat",
        purge: "Purger",
        qualityControl: "ContrÃ´le qualitÃ©",
        quantity: "QuantitÃ©",
        quantityQty: "QTY",
        quickTint: "Teinte Rapide",
        rccIsNotAvailable: "RCC n'est pas disponible",
        rccIsNotConnected: "Le RCC n'est pas connectÃ©",
        rccNotLicensed: "Licence RCC non activÃ©e",
        reconnect: "Reconnecter",
        refill: "Remplir durant le dosage",
        refillManualLevelCorrection: "Manual correction",
        reformulation: "Reformulation",
        reloadTab: "Reload Tab",
        reset: "RÃ©initialiser ",
        restart: "RedÃ©marrer ",
        restore: "Restaurer",
        retint: "Doser Ã  nouveau",
        revision: "RÃ©vision",
        safetySheet: "Fiche de sÃ©curitÃ©",
        save: "Sauvegarder",
        saveAs: "Sauvegarder en tant que",
        saveToDispensingHistory: "Sauvegarder vers historique",
        searchResult: "RÃ©sultat de la recherche",
        searching: "Searching",
        seconds: "Sec.",
        select: "Select",
        selectAll: "SÃ©lectionner tout ",
        selectChannels: "Selectionner les circuits",
        selectColumns: "Select columns to work with",
        selectXFirst: "Select %{item} first",
        sellPrice: "Prix de vente",
        settings: "ParamÃ¨tres",
        shelf: "Support de pot",
        showItem: "Show %{item}",
        showOptions: "Show another options",
        size: "Taille",
        skip: "Passer",
        smartPurge: "Purge intelligente",
        softwareRestartInSeconds: "%{software} will be automatically restarted in %{seconds} seconds",
        sortResults: "Sort results",
        spectro: "Couleur proche spectro",
        standardFormula: "Formule standard",
        status: "Statut",
        street: "Rue",
        sum: "Sum",
        summary: "RÃ©capitulatif ",
        sync: "Synchroniser",
        technicalSheet: "Fiche technique",
        templates: "ModÃ¨les",
        threshold: "Threshold",
        ticketing: "Contretypage",
        tintometricSystem: "Tintometric system",
        toDispenseOrders: "A doser",
        top: "Haut",
        total: "Total",
        totalAmount: "Montant total",
        totalBaseAmount: "Montant total de base",
        totalColorantAmount: "QuantitÃ© totale de colorants",
        type: "Type",
        ufiCode: "Code UFI",
        ufiThreshold: "Seuil UFI",
        unableToSynchronize: "Unable to synchronize",
        undefined: "Undefined",
        unit: "UnitÃ©",
        units: "UnitÃ©s",
        unknown: "Unknown",
        update: "Mises Ã  jour",
        updated: "Mis Ã  jour",
        user: "Utilisateur",
        value: "Valeur",
        vat: "TVA",
        verified: "VerifiÃ©e",
        version: "Version",
        versionId: "Version de l'ID",
        versionStructure: "Version de la structure",
        volumetric: "VolumÃ©trique",
        warning: "Avertissement",
        warningLevel: "Alerte de niveau",
        withoutName: "(sans nom)",
        workingProperly: "Working properly",
        yes: "Oui",
        zoom: "Zoom"
    },
    help: {
        autotasks: {
            brushMaintenance:
                "DÃ©finissez cette tÃ¢che automatique pour que %{name} demande l'action de nettoyage automatique du conteneur de brosse Ã  l'heure dÃ©finie. L'opÃ©rateur du distributeur doit retirer, nettoyer et // ensuite renvoyer le rÃ©servoir de brosse manuellement.",
            capMaintenance:
                "DÃ©finissez cette tÃ¢che automatique pour que %{name} demande l'action de nettoyage automatique de l'autocap Ã  l'heure dÃ©finie. L'opÃ©rateur du distributeur doit nettoyer manuellement l'autocap aprÃ¨s son ouverture.",
            cleanAll:
                "RÃ©glez cette tÃ¢che automatique pour que le distributeur exÃ©cute l'action de nettoyage automatique de tous les canisters Ã  l'heure dÃ©finie.",
            cleanChannels:
                "DÃ©finissez cette tÃ¢che automatique pour que le distributeur exÃ©cute automatiquement l'action de nettoyage des canisters spÃ©cifiques Ã  l'heure dÃ©finie.",
            computerReboot:
                "DÃ©finissez cette tÃ¢che automatique pour que l'ordinateur redÃ©marre automatiquement Ã  l'heure dÃ©finie.",
            computerShutdown:
                "DÃ©finissez cette tÃ¢che automatique pour que l'ordinateur s'Ã©teigne automatiquement Ã  l'heure dÃ©finie.",
            dispenserCleaning:
                "DÃ©finissez cette tÃ¢che automatique pour que %{name} demande l'action de nettoyage automatique de la machine Ã  l'heure dÃ©finie. L'opÃ©rateur de la machine doit nettoyer la machine manuellement avec un chiffon.",
            humidifierWaterLevelMaintenance:
                "DÃ©finissez cette tÃ¢che automatique pour que %{name} demande l'action de remplissage automatique de l'humidificateur Ã  l'heure dÃ©finie. L'opÃ©rateur de la machine doit vÃ©rifier et remplir manuellement l'eau dans l'humidificateur.",
            purgeAll:
                "DÃ©finissez cette tÃ¢che automatique pour que la machine exÃ©cute l'action de purge automatique de tous les canisters Ã  l'heure dÃ©finie.",
            purgeChannels:
                "DÃ©finissez cette tÃ¢che automatique pour que la machine  exÃ©cute l'action de purge automatique des canisters spÃ©cifiques Ã  l'heure dÃ©finie.",
            recirculateAll:
                "DÃ©finissez cette tÃ¢che automatique pour que la machine exÃ©cute l'action de recirculation automatique de tous les canisters Ã  l'heure dÃ©finie.",
            recirculateChannels:
                "DÃ©finissez cette tÃ¢che automatique pour que la machine exÃ©cute automatiquement l'action de recirculation des canisters spÃ©cifiques Ã  l'heure dÃ©finie.",
            refillAll:
                "DÃ©finissez cette tÃ¢che automatique pour que %{name} demande lâaction de remplissage automatique de tous les canaux Ã  lâheure dÃ©finie. LâopÃ©rateur du distributeur doit recharger manuellement les colorants dans tous les rÃ©servoirs.",
            refillCanisters:
                "DÃ©finissez cette tÃ¢che automatique pour que %{name} demande lâaction de remplissage automatique des canaux spÃ©cifiques Ã  lâheure dÃ©finie. LâopÃ©rateur du distributeur doit recharger manuellement les colorants dans les rÃ©servoirs qui ne rÃ©pondent pas au critÃ¨re de recharge.",
            smartPurgeAll:
                "DÃ©finissez cette tÃ¢che automatique pour que la machine exÃ©cute l'action de purge intelligente de tous les canisters automatiquement Ã  l'heure dÃ©finie. La purge sera effectuÃ©e si les rÃ¨gles de purge intelligente ne soient mises.",
            smartPurgeChannels:
                "DÃ©finissez cette tÃ¢che automatique pour que la machine exÃ©cute l'action de purge intelligente des canisters spÃ©cifiques automatiquement Ã  l'heure dÃ©finie. La purge sera effectuÃ©e si les rÃ¨gles de purge intelligente ne soient mises.",
            stirAll:
                "DÃ©finissez cette tÃ¢che automatique pour que la machine exÃ©cute la demande d'action pour agiter automatiquement tous les canisters Ã  l'heure dÃ©finie.",
            stirCanisters:
                "DÃ©finissez cette tÃ¢che automatique pour que la machine exÃ©cute la demande d'action pour agiter automatiquement des canaux spÃ©cifiques Ã  l'heure dÃ©finie.",
            switchPlateMaintenance:
                "DÃ©finissez cette tÃ¢che automatique pour que %{name} demande l'action de nettoyage automatique de la plaque de commutation Ã  l'heure dÃ©finie. L'opÃ©rateur de la machine distributeur doit retirer, nettoyer, puis retourner la plaque d'interrupteur manuellement."
        },
        colorantBatchNumber: {
            batchNumberByPercentage:
                "The Batch number which prevails is used for printing considering its actual amount in the canister. Navigate to Canister settings to define the threshold for each canister.",
            batchNumberFromLastFilling:
                "The Batch from the last refill given by the operator is used for printing regardless the refilled amount.",
            enableBatchNumber: "With this setting on, refilled colorant batches are tracked."
        },
        connection: {
            add: "Permet d'ajouter un nouveau serveur manuellement s'il n'a pas pu Ãªtre dÃ©tectÃ© via la fonction DÃ©couvrir",
            clientIdentifier:
                "Le paramÃ¨tre permet d'identifier ce client s'il y a plusieurs clients connectÃ©s Ã  un serveur.",
            disconnect:
                "Informations sur le serveur actuellement utilisÃ©. Le bouton de dÃ©connexion permet de quitter ce serveur et de passer Ã  un autre si disponible",
            discover: "DÃ©couvre s'il existe d'autres serveurs disponibles sur le rÃ©seau.",
            dropServers: "Supprime tous les serveurs prÃ©cÃ©demment dÃ©tectÃ©s de la liste.",
            dropServersNotAvailable: "Aucun serveur disponible",
            edit: "Permet de modifier manuellement un serveur dÃ©jÃ  trouvÃ©.",
            editDisabled: "Aucun serveur sÃ©lectionnÃ©."
        },
        continue: "Voulez-vous vraiment continuerÂ ?",
        driverSettings: {
            alfaRestApi: {
                host: "Saisir dans l'ordinateur le nom d'hÃ´te ou l'adresse IP de l'ordianteur.",
                machineType: "Valide pour toutes les machines Alfa. Aussi bien Windows que Linux."
            },
            corobDsProxy: {
                machineType:
                    "Valide pour les gÃ©nÃ©rations Slave (D200, D600..), 4G (First One) et 5G (EvoFlx). DspProxy doit Ãªtre installÃ©. Windows seulement."
            },
            corobEvoDriver: {
                machineType:
                    "Valide pour la gÃ©nÃ©ration 5G (EvoFlx). EVOservice doit Ãªtre installÃ©. Aussi bien Windows que Linux."
            },
            corobFlex500LLD: {
                dispenserConfigurationFile:
                    "Selectionnez le fichier de configuration de la machine Ã  teinter. PrÃ©-rÃ©glage par dÃ©faut.",
                hldRootDir: "Selectionnez le dossier pricnipale du HLD. PrÃ©-rÃ©glage par dÃ©faut.",
                machineType:
                    "Valide pour Corob Flex (500, 520, 540) = ancien Lenteq. HLD doit Ãªtre installÃ©. Windows seulement."
            },
            corobNextDriver: {
                machineType:
                    "Valide pour les gÃ©nÃ©rations Slave (D200, D600..), 4G (First One) and 5G (EvoFlx). NextDriver doit Ãªtre installÃ©. Linux seulement."
            },
            dromontDDrv: {
                databasePath:
                    "Chemin d'accÃ¨s vers le fichier de base de donnÃ©es contenant les donnÃ©es calibrÃ©es. PrÃ©-rÃ©glage par dÃ©faut.",
                driverPath:
                    "Chemin d'accÃ¨s vers le fichier de base de donnÃ©es contenant les donnÃ©es calibrÃ©es. PrÃ©-rÃ©glage par dÃ©faut.",
                machineType:
                    "Communication indirecte de la machine via le chemin d'accÃ¨s dÃ©fini. Valide pour les gÃ©nÃ©rations V1 et V2.  D_SET doit Ãªtre installÃ©. Windows as well as Linux.",
                resultPath:
                    "Chemin vers le fichier de rÃ©sultat crÃ©Ã© aprÃ¨s que l'opÃ©ration soit terminÃ©e.PrÃ©-rÃ©glage par dÃ©faut.",
                serviceSoftwarePath: "Chemin vers le logiciel de service Dromont (D_SET.exe). PrÃ©-rÃ©glage par dÃ©faut."
            },
            dromontDirect: {
                machineType:
                    "Communication directe de la machine Ã  teinter. Valide pour les fÃ©nÃ©rations V1 et V2. D_SET doit Ãªtre installÃ©. Aussi bien Windows que Linux.",
                rootDir: "Selectionnez le dossier principal Dromont"
            },
            dromontMisura: {
                driverPath:
                    "Chemin vers le driver (MisuraRetail.exe) doit changer en fonction de la version Misura Retail. PrÃ©-rÃ©glage par dÃ©faut.",
                extensionPath: "Chemin vers le fichier de communication pour les actions de service.",
                formulaPath: "Chemin vers le fichier de communication pour le dosage.",
                machineType: "Valide pour la gÃ©nÃ©ration V3. Dromont Misura doit Ãªtre installÃ©. Windows seulement."
            },
            fastAndFluidIDD: {
                machineType: "Valide pour toutes les machines F&F. Windows seulement.",
                path: "Les versions supportÃ©es sont les IDD2 (HA 450, HA 650, X-smart, etc.), IDD3 (HP 500, etc.), IDD4 (HA 180, HA 480, HA 680, Xprotint, etc.) doivent Ãªtre licensÃ©es. Seule la IDD2 requiere une licence F&F."
            },
            fastAndFluidUIDD: {
                host: "Type in the computer host name or computer IP address.",
                machineType: "Valide pour toutes les machines F&F. Aussi bien Windows que Linux.",
                password: "Type in the user password.",
                port: "Select the port number.",
                user: "Type in the user name."
            },
            heroPCPDriver: {
                machineType: "Valide pour toutes les machines Hero. Windows seulement."
            },
            italtinto: {
                machineType:
                    "Valide pour toutes les machines Italtinto. Wcal ou ItaltinCal doit Ãªtre installÃ©. Windows seulement.",
                path: "Chemin vers le fichier configuration Italtinto ajustÃ©."
            },
            manualAdvanced: {
                machineType:
                    "Valide pour tous les manuels de machine, support de canister inclus. Aussi bien Windows que Linux.",
                path: "Chemin vers le fichier de configuration contenant les donnÃ©es de la machine et des canisters."
            },
            manualSimple: {
                machineType: "Valide pour tous les manuels de machine. Aussi bien Windows que Linux.",
                path: "Chemin vers le fichier de configuration contenant les donnÃ©es de la machine."
            },
            none: {
                machineType: "Aucun pilote machine n'est sÃ©lectionnÃ©."
            },
            santintColorLink3: {
                machineType: "Valide pour toutes les machines Santint. Windows seulement."
            },
            simulation: {
                machineType:
                    "Valide pour le simulateur de machine Ã  teinter s'il n'y a pas de machine connectÃ©e Ã  l'ordinateur.",
                path: "Chemin vers le fichier de configuration du simulateur de machine qui doit Ãªtre en accrod avec la base de donnÃ©es inserÃ©e."
            },
            udcp: {
                machineType: "Distributeur UDCP"
            }
        },
        environment: {
            activeServerPlugins: "AperÃ§u des plugins logiciels supplÃ©mentaires.",
            allowAutoCloseTab:
                "Lorsque le rÃ©glage est activÃ©, chaque onglet de formule sera fermÃ© automatiquement une fois le processus de distribution terminÃ©.",
            allowAutomaticClientStart:
                "Avec ce paramÃ©trage, %{name} demarrera automatiquement aprÃ¨s le demarrage de l'ordinateur.",
            allowAutomaticPrint:
                "L'Ã©tiquette sera imprimÃ©e automatiquement. Un paramÃ¨trage impression supplÃ©mentaire est nÃ©cessaire avant et/ou aprÃ¨s dosage.",
            allowBuildingSitePanel: "On Formula Panel, building site panel will be available.",
            allowCustomers: "Sur le panneau de formulation, la section client sera accessible",
            allowDispensing:
                "Sur le panneau de formulation, le bouton Doser sera activÃ© ainsi que les options de dosage dans les paramÃ¨tres machine.",
            allowFileTransfer:
                "Si ce paramÃ¨tre est activÃ©, lâimportation et lâexportation automatiques de donnÃ©es par transfert de fichiers sont disponibles.",
            allowFormulaModificationPanel: "On Formula Panel, Modification panel will be activated.",
            allowFormulaStatusPanel: "Sur le Panneau Formule, le Panneau Statut sera activÃ©.",
            allowLight: "%{name} will be accessible..",
            allowOrdering: "Sur le panneau de formulation, le bouton de commande sera actif",
            allowPricing:
                "Sur l'Ã©cran de formule, les prix peuvent Ãªtre utilisÃ©s. La visibilitÃ© des prix est parametrÃ©e dans Tarifs Disponibles",
            allowProductPreviewImage: "Une photo du produit apparaitra au moment du dosage",
            allowQualityControl: "Quality control will be activated.",
            allowSearchCheaperColors:
                "Sur le Panneau Formule, la fonction de recherche de couleurs moins chÃ¨res sera disponible.",
            allowSoundNotification: "Une notification sonore sera jouÃ©e quand une commande sera reÃ§ue",
            allowSpectro: "La section Spectro sera accessible",
            allowTabs: "Avec ce paramÃ¨tre activÃ©, il est possible de travailler avec plusieurs onglets simultanÃ©ment",
            applyZoom:
                "Le zoon Ã©largit ou rÃ©duit la rÃ©solution. Les raccourcis clavier CTRL + et CTRL - sont aussi applicable",
            automaticLogout: "DÃ©finissez aprÃ¨s combien de minutes la dÃ©connexion automatique doit Ãªtre activÃ©e.",
            availableDatabases:
                "Les paramÃ¨tres permettent de changer de base de donnÃ©es s'il y en a plus d'une de disponible.",
            backupLocalDB:
                "Exporte la base de donnÃ©es locale. Le fichier exportÃ© peut Ãªtre utilisÃ© comme sauvegarde de la base de donnÃ©es.",
            barcodeTesting:
                "L'environnement test de code barre permet de vÃ©rifier l'exactitude des codes barrre scannÃ©s en les comparant avec les codes barre inserÃ©s dans la base de donnÃ©es.",
            customBanner: "ParamÃ©trez votre propre logo ou banniÃ¨re et sa position.",
            customCurrencyFormat:
                "Le format de devise personnalisÃ© peut remplacer le format de devise par dÃ©faut en fonction de la langue sÃ©lectionnÃ©e. ",
            customDateFormat:
                "Le format de date personnalisÃ© peut remplacer le format de date par dÃ©faut en fonction de la langue sÃ©lectionnÃ©e.",
            customNumberFormat:
                "Le format numÃ©rique personnalisÃ© peut remplacer le format numÃ©rique par dÃ©faut en fonction de la langue sÃ©lectionnÃ©e.",
            customTimeFormat:
                "Le format dâheure personnalisÃ© peut remplacer le format dâheure par dÃ©faut en fonction de la langue sÃ©lectionnÃ©e.",
            defaultPrinter:
                "L'imprimante sÃ©lectionnÃ©e sera utilisÃ©e quand l'imprimante Ã©tiqueteuse sauf si des modifications ont lieu dans les paramÃ¨tres d'impression Windows",
            defaultTemplate:
                "Le modÃ¨le sÃ©lectionnÃ© sera utilisÃ© lors des impressions d'Ã©tiquettes saud si des changements sont effectuÃ©s dans les options d'impression Wndows",
            deleteImportedData:
                "Efface les donnÃ©es personnelles importÃ©es prÃ©cÃ©demment. Les donnÃ©es peuvent Ãªtre importÃ©e de nouveau aprÃ¨s effacement.",
            diskSpaceNotification: "VÃ©rifie lâespace disque disponible et notifie en cas dâespace insuffisant.",
            dispensingNotes: "Sur le panneau de formulation, la section Notes Dosage sera accessible",
            downloadListEmpty: "No downloads in progress",
            enableVirtualKeyboard: "Dans %{name}, le clavoer virtuel sera disponible.",
            exportLocalSettings: "Exports the local settings of this computer.",
            exportStaticSql:
                "Exporte les paramÃ¨tres locaux de cet ordinateur. Le fichier exportÃ© peut Ãªtre utilisÃ© pour crÃ©er une base de donnÃ©es avec cette configuration.",
            exportTranslationKeys:
                "Exporter les derniÃ¨res traductions et aprÃ¨s traduction, les envoyer par e-mail Ã  votre fournisseur de logiciels pour les faire importer",
            favoriteButton: "Cliquez pour ajouter la formule comme favori",
            formulaNotes: "Sur le panneau de formulation, la section Notes Formules sera accessible",
            helpSettings: "L'information est visible dans la section aide du panneau d'accÃ©s rapide",
            importCustomData: "Importe les donnÃ©es personnalisÃ©es locales basÃ©es sur le format selectionnÃ©.",
            importExcelFile: "Importer le fichier Excel contenant les donnÃ©es Ã  ajouter Ã  la base de donnÃ©es.",
            importsLocalSettings: "Imports the local settings of this computer.",
            internalNote: "Sur le panneau Formule, la section des notes internes sera accessible.",
            lockComputer:
                "Le paramÃ©trage assure que l'environnement %{name} ne peut pas Ãªtre retirÃ© - cela permet une experience en mode Kiosk incomparable. Seulement applicable sur Windows",
            maxNumberTabs:
                "Table de limites dÃ©finissant le nombre d'onglets de formule pouvant Ãªtre ouvets simultanÃ©ment.",
            memoryTabs: "Autoriser la rÃ©ouverture des onglets rÃ©cemment ouverts aprÃ¨s le dÃ©marrage du logiciel.",
            printAfterDispensing:
                "Ce paramÃ¨trage requiert l'information du nombre d'Ã©tiquettes a imprimÃ© aprÃ¨s le dosage",
            printAsImage:
                "Imprimer en tant qu'image aide Ã  solutionner les difficultÃ©s d'impression quand l'impression standard Ã©choue. Ne pas utiliser cette option quand l'impression standard fonctionne",
            printBeforeDispensing:
                "Ce paramÃ¨trage requiert l'information du nombre d'Ã©tiquettes a imprimÃ© avant le dosage",
            printEnabled:
                "Ce paramÃ¨tre permet d'utiliser l'imprimante avec le logiciel. Des paramÃ¨tres supplÃ©mentaires se trouvent dans les paramÃ¨tres d'impression.",
            printOnRequest: "Sur le panneau de formulation, le bouton Imprimer sera actif",
            printTaskVariable:
                "La tÃ¢che dâimpression est traitÃ©e uniquement si la variable dâimpression donnÃ©e est disponible dans les donnÃ©es dâimpression.",
            quickTintTemplate: "Le modÃ¨le sÃ©lectionnÃ© sera utilisÃ© lors de l'impression rapide d'Ã©tiquettes",
            restoreLocalSettings: "Restores the local settings of this computer.",
            runLightAtStartUp: "%{light} sera dÃ©marrÃ© Ã  la place de %{name}.",
            screenSaverTimeout: "DÃ©finissez aprÃ¨s combien de minutes, l'Ã©conomiseur d'Ã©cran doit Ãªtre activÃ©.",
            selectCustomDataFormat:
                "Selectionnez le format des donnÃ©es originales Ã  importer. Chaque format peut nÃ©cessiter diffÃ©rents fichiers et paramÃ¨tres additionnels.",
            setCustomHomeButton: "Le boutton d'accueil dans %{name} vous redirigera vers l'Ã©cran sectionnÃ©.",
            setFts: "La recherche de texte intÃ©gral permet la recherche de nom complet de formule (aussi Ã  partir d'une partie du mot, etc.).",
            setKeyboardShortcuts: "Il n'est pas possible d'utiliser le meme raccourci clavier ",
            setNumberOfDecimalPlaces:
                "L'arrondi dÃ©finit le nombre de dÃ©cimales qui seront affichÃ©es sur les colorants utilisÃ©s dans la formule.",
            setOrderSearchParameters:
                "La recherche de commandes dÃ©finit les paramÃ¨tres qui sont utilisÃ©s lors de la recherche parmi les commandes. Uniquement accessible en %{name}.",
            setOverwriteLastTab:
                "Lorsque vous choisissez une nouvelle formule via la recherche globale alors que la limite de tabulation de formule est atteinte, le dernier onglet de formule chargÃ© sera Ã©crasÃ© par la nouvelle sÃ©lection de formule.",
            setSearchPanel:
                "ParamÃ©trez votre propre affichage et l'ordre des Ã©lÃ©ments utilisÃ©s lors d'une recherche d'une nouvelle formule.",
            setVisibilityAndOrder:
                "L'icone de navigation sÃ©lectionnÃ© sera visible dans le panneau d'accÃ©s rapide. La position la plus haute devra etre placÃ©e le plus Ã  gauche. Le nombre maximum d'icones de navigation affichable est 6",
            setYourLanguage: "Le changement de langue nÃ©cessite de redÃ©marrer le logiciel",
            settingsSearch: "Rechercher divers paramÃ¨tres si vous ne savez pas oÃ¹ les trouver.",
            showNewOrderNotifications:
                "Les notifications de commande sont des pop-up annoncant qu'une nouvelle commande a Ã©tÃ© reÃ§ue",
            sorting:
                "Le module Teinte Rapide peut ordonnÃ© les canisters par le nom des colorants ou par l'identifiant de chaque canister",
            turnOnKioskMode: "Le mode Kiosk cache la barre des taches",
            windowClosingRules:
                "Le paramÃ¨trage dÃ©termine si le module Teinte Rapide se ferme avant ou aprÃ¨s le dÃ©but du dosage"
        },
        formulaSettings: {
            additionalFormulaTab:
                "Le paramÃ¨tre dÃ©cide quel panneau sera affichÃ© lors de l'ouverture d'un nouvel onglet de formule.",
            allowCustomFormulas: "La crÃ©ation et la recherche de formules personnalisÃ©e sera activÃ©",
            allowCustomPackageSize:
                "Sur le panneau de formulation, l'option Taille d'emballage dÃ©finie par l'utilisateur sera activÃ©e",
            allowEditingColorants:
                "Sur le panneau de formulation, le bouton Editer Colorat sera activÃ© (visible aprÃ¨s la sÃ©lection d'une couleur)",
            alternativeFormulasPosition: "DÃ©finit comment accÃ©der aux formules alternatives.",
            basePanelSize: "DÃ©finir la taille de la base sur le panneau Formule",
            bippPanelSize: "DÃ©finir la taille de la base dans lâemballage du produit sur le panneau Formule",
            blendColorNameAndCode:
                "The setting joins together the search fields for Color name and code to create one search field only.",
            color: "Sur le panneau de formulation, la prÃ©visualisation couleur sera la seule information visible",
            colorCodePrimary: "Le code couleur sera affichÃ© en premier dans le champ de recherche.",
            colorPreviewAsImage: "Sur le panneau Formule, lâaperÃ§u des couleurs sera reprÃ©sentÃ© par une image.",
            colorPreviewResizable: "Permet de redimensionner le panneau dâaperÃ§u des couleurs.",
            colorantPanelLimit:
                "The settings sets the number of colorants that will be always visible before it hides under scroll bar.",
            colorantPanelOrderBy:
                "Le panneau Formule peut afficher les colorants classÃ©s en fonction de leur nom ou de leur quantitÃ©.",
            customCanOption:
                "Choisissez les unitÃ©s de mesure qui peuvent Ãªtre utilisÃ©es pour la taille de lâemballage personnalisÃ© sur le panneau Formule.",
            customCanSettingsUnit:
                "Choisissez lâunitÃ© de mesure utilisÃ©e par dÃ©faut pour les paramÃ¨tres des paquets personnalisÃ©s sur le panneau Formule.",
            customFormulaForMasterProduct:
                "Defines whether the option âFormula for master productâ is displayed when saving custom formula",
            customFormulaForMasterProductDefault:
                "Defines whether the option âFormula for master productâ is checked by default",
            deleteConfirmation:
                "L'activation de ce paramÃ¨tre entraÃ®nera l'apparition de fenÃªtres contextuelles pour confirmer la suppression d'un Ã©lÃ©ment.",
            dropDownCalculate:
                "The drop-down menu to select the formula you are looking for will extend to the bottom of the window.",
            fandeckGroups: "The setting enables hierarchy with fandeck groups if available in the database.",
            fandeckPanelSize: "DÃ©finir la taille du nuancier sur le panneau Formule",
            favoriteFormulasInitial: "En demarrant %{name}, l'Ã©cran des favoris apparaitra.",
            formulaAutomaticNaming:
                "Une formule Ã©ditÃ©e sera nommÃ©e automatiquemet suivant les modifications effectuÃ©es sur le colorant en question.",
            formulaPanel: "A l'ouverture d'un nouvel onglet, la panneau de formulation apparaitra",
            formulaPanelInitial: "En dÃ©marrant %{name}, l'Ã©cran de formule apparaitra.",
            formulaPanelSize: "DÃ©finir la taille de la formule dans le panneau Formule",
            formulaPropertiesPosition: "DÃ©finit comment accÃ©der aux propriÃ©tÃ©s des formules.",
            generateColorPreview:
                "Si ce paramÃ¨tre est activÃ©, lâaperÃ§u des couleurs sera gÃ©nÃ©rÃ© automatiquement. LâaperÃ§u obtenu est inexact.",
            historicalFormulasPosition: "DÃ©finit comment accÃ©der aux formules  de l'historique.",
            image: "Sur le panneau de formulation, l'image du produit sera visible Ã  cootÃ© de la prÃ©visualisation couleur avec la possibilitÃ© d'ouvrir le panneau avec plus d'information",
            images: "Ce paramÃ¨tre dÃ©finit la source des fichiers image.",
            infoPanelResizable: "Permet de redimensionner le panneau dâinformations supplÃ©mentaires.",
            initialFormulaTab: "Le paramÃ¨tre dÃ©cide quelle fenÃªtre sera affichÃ©e aprÃ¨s le dÃ©marrage de %{0}.",
            moreInfo:
                "Sur le panneau de formulation, le panneau d'information sera visible Ã  cotÃ© de la prÃ©visualisation et Ã  cotÃ© de l''image du produit",
            orderByDistance: "With this setting on, the result of color search is ordered by special distance metric.",
            productCode:
                "Le paramÃ¨tre permet d'utiliser les codes produit avec les noms de produit s'ils sont disponibles dans la base de donnÃ©es.",
            productFiles:
                "Ce paramÃ¨tre dÃ©finit la source des fichiers de produits qui sont disponibles sur le panneau Formule.",
            productGroups:
                "Ce paramÃ¨tre permet dâactiver la hiÃ©rarchie avec les groupes de produits sâils sont disponibles dans la base de donnÃ©es.",
            productPanelSize: "DÃ©finir la taille du produit sur le panneau Formule",
            searchNewFormula:
                "A l'ouverture d'un nouvel onglet, la recherche d'une nouvelle formule apparaitre (contient des informations Ã  propos de la derniÃ¨re formule dosÃ©e et au sujet des formules favorites",
            searchNewFormulaInitial:
                "En dÃ©marrant %{name}, la recherche de nouvelle formule apparaitra (contient les informations sur les formules dosÃ©es et les formules favorites ).",
            searchPanelFormulaItems: "Au moins un des Ã©lÃ©ments de la formule doit Ãªtre sÃ©lectionnÃ©.",
            searchPanelProductItems: "Un seul des articles du produit peut Ãªtre sÃ©lectionnÃ©.",
            searchPanelQuickSelect:
                "No need to press the load formula button. You will be redirected directly to main formula tab just after formula selection.",
            setCompetitiveColorSearch:
                "With this setting on, the feature of competitive color search in Color Palette and Formula panel (only for not available formulas) is available.",
            setFormulaInfoInPreview:
                "Dans le panneau Formule, le type de donnÃ©es sÃ©lectionnÃ© sera toujours visible dans l'aperÃ§u des couleurs.",
            setFormulaPreview:
                "Le paramÃ¨tre modifie la position et l'affichage de l'aperÃ§u des couleurs, de l'image du package et des informations sur la couleur.",
            setFormulaRGBPreviewVisibleInformation:
                "Sur le panneau de formulation, le type de donnÃ©es sÃ©lectionnÃ©es sera toujours visible dans la prÃ©visualisation couleur",
            setFormulaUnit:
                "Sur le panneau de formulation, ce paramÃ¨tre dÃ©termine quel unitÃ© de colorant s'ouvre en premier aprÃ¨s avoir selectionnÃ© une couleur. Cela s'applique aussi pour la partie Teinte Rapide",
            setFormulaVisibilityAndOrder:
                "Sur la panneau de formulation, la donnÃ©e sÃ©lectionnÃ©e sera visible dan la section Plus d'informations (seulement applicable si paramÃ¨tre plus d'information ou image sont activÃ©s)",
            setMaxToleranceForCompetitiveColors:
                "Set the maximal Delta E (CIA 2000) tolerance for competitive color search.",
            setNumberOfCompetitiveColors:
                "DÃ©finissez le nombre de couleurs de rÃ©fÃ©rence concurrentes qui doivent Ãªtre proposÃ©es aprÃ¨s la recherche. Le nombre dÃ©fini ne correspond pas au nombre de rÃ©sultats.",
            setVisibleUnit:
                "Sur le panneau de formulation, ce paramÃ¨tre dÃ©termine quel le unitÃ© de colorant sera visible aprÃ¨s selection d'une couleur. S'applique aussi pour Teinte Rapide",
            showColorPreview:
                "Sur le panneau de formulation, montre une petite prÃ©visualisation couleur Ã  cotÃ© du nom de la couleur ",
            showSiblingProducts:
                "Defines whether the option âShow sibling productsâ is displayed when saving custom formula",
            useColorCode: "On Formula panel, shows the information about color code."
        },
        formulaValidation: {
            batchNumberInvalid: "Le bidon (%{colorants}) est rempli d'un lot de colorant dÃ©fectueux.",
            batchNumberWarning: "Le colorant (%{colorants}) portant ce numÃ©ro de lot peut Ãªtre endommagÃ©.",
            bellowBaseLimit: "La somme des quantitÃ©s de colorants est infÃ©rieure Ã  la limite de base.",
            checkColorantBaseRules: "The setting checks if used colorants and base can be used in this combination.",
            checkMinDosableAmount:
                "La quantitÃ© minimale colorable est la plus petite quantitÃ© de colorant qui peut Ãªtre distribuÃ©e selon les recommandations du laboratoire.",
            checkOverfill:
                "Le rÃ©glage vÃ©rifie sâil y a suffisamment dâespace dans la boÃ®te pour les colorants immÃ©diatement aprÃ¨s la dÃ©finition des quantitÃ©s.",
            checkTotalCntAmounts:
                "The setting checks if the limits for the minimal and maximal colorant amounts in product base package have been exceeted. These limits are defined in the database.",
            colorantBaseRules: "Colorant is not valid for selected base.",
            colorantMinAmount: "La quantitÃ© de colorant est infÃ©rieure Ã  la quantitÃ© minimale colorable.",
            dispensingWithErrorsEnabled:
                "Si elle est autorisÃ©e, un message dâavertissement apparaÃ®tra en cas de violation de la validation, mais il sera possible de procÃ©der Ã  la distribution malgrÃ© tout.",
            invalidBatchNumber: "Colorant has invalid or defective batch number",
            overBaseLimit: "La somme des quantitÃ©s de colorants est supÃ©rieure Ã  la quantitÃ© maximale colorable.",
            overfill: "Une surcharge a Ã©tÃ© dÃ©tectÃ©e.",
            unifyColorantBatchForMultipleCans:
                "Si cela est autorisÃ©, une fenÃªtre modale d'information sur le remplissage maximal s'affiche lorsque la quantitÃ© de colorant est supÃ©rieure Ã  la quantitÃ© maximale du bidon et que le bidon n'est pas rempli au niveau maximal.",
            warningConfirmBtn: "Je connais les risques, continuez"
        },
        help: "Aide",
        helpLink: "Help center",
        helper: {
            automaticallyCheckForUpdates:
                "Cela sera automatiquement vÃ©rifiÃ© s'il n'y a aucune mise Ã  jour de disponible pour %{name} ou aucune base de donnÃ©es dÃ©livrÃ©e dans l'intervalle de temps donnÃ©.",
            automaticallyDownloadUpdates:
                "Si une mise Ã  jour est disponible, elle sera automatiquement tÃ©lÃ©chargÃ©e sans avoir de confirmation.",
            automaticallyInstallNewDatabases:
                "Si une BDD jusqu'ici absente est envoyÃ©e, elle sera installÃ©e comme nouvelle BDD. Ensuite, la BDD peut Ãªtre utilisÃ©e.",
            automaticallyInstallUpdates:
                "Si une mise Ã  jour a Ã©tÃ© tÃ©lÃ©chargÃ©e, elle sera automatiquement installÃ©e sans demande de confirmation.",
            canBrowseChangeLog:
                "Lorsque le logiciel est mis Ã  jour, le %{name} journal officiel des changements sera disponible en lecture.",
            forceInstall: "La mise Ã  jour sera installÃ©e de force.",
            installDuringNight: "La mise Ã  jour sera installÃ©e pendant la nuit si l'ordinateur est en fonctionnement."
        },
        licensing: {
            collect:
                "Les fichiers journaux seront tÃ©lÃ©chargÃ©s Ã  l'emplacement sÃ©lectionnÃ©. Les fichiers journaux sont requis par le logiciel fourni pour l'analyse des bogues.",
            company: "L'entreprise qui a fourni la licence.",
            computerID:
                "Identification de la licence pour aider le fournisseur de logiciels en cas d'assistance requise.",
            email: "L'adresse e-mail du titulaire de la licence.",
            licenseUuid:
                "Identification de la licence pour aider le fournisseur du logiciel en cas d'assistance requise.",
            name: "Le nom du titulaire de la licence.",
            openBugreport:
                "S'il vous plaÃ®t, laissez-nous savoir s'il y a un bug dans le logiciel et envoyez-nous un rapport avec la description du bogue.",
            posInfoContactperson: "Informations POS sur le propriÃ©taire Ã  imprimer sur l'Ã©tiquette.",
            posInfoMachineInformation:
                "Informations POS sur le distributeur Ã  imprimer sur l'Ã©tiquette ou Ã  reconnaÃ®tre dans le rÃ©seau.",
            posInfoPos: "Informations de point de vente sur l'emplacement Ã  imprimer sur l'Ã©tiquette.",
            reactivation: "RÃ©activation ou modification de la licence actuelle.",
            refresh: "TÃ©lÃ©charger les derniÃ¨res informations sur les licences.",
            refreshUnavailable: "L'actualisation de la licence n'est pas disponible car vous Ãªtes hors ligne.",
            registrationContactperson: "Informations d'enregistrement pour identifier le propriÃ©taire de la licence.",
            registrationMachineInformation:
                "Informations d'enregistrement pour identifier le distributeur de la licence.",
            registrationPos: "Informations d'enregistrement pour identifier l'emplacement de la licence.",
            versionScope: "Limites d'expiration du logiciel.",
            versionType: "Le type de produit logiciel."
        },
        machineIsBusy: "Les erreurs ne peuvent pas Ãªtre effacÃ©es car la machine est occupÃ©e.",
        machineSettings: {
            allowManualColorantAddition:
                "Si la quantitÃ© de colorant requise dÃ©passe la quantitÃ© maximum dosable, ce paramÃ¨tre autorise l'ajout manuel aprÃ¨s dosage",
            autotasks:
                "les taches automatiques sont des opÃ©rations de maintenance de la machine ou du PC opÃ©rÃ©s Ã  des heures particuliÃ¨res ou Ã  des intervalles de temps particuliers",
            barcodeRefillValidation: "The setting turns on barcode validation on refill.",
            barcodeRefillValidationBaseAndColorant:
                "Le contrÃ´le du code-barres est effectuÃ© lors du remplissage des bidons et des emballages de colorants.",
            barcodeRefillValidationColorant:
                "Le contrÃ´le du code-barres est effectuÃ© lors du remplissage de l'emballage du colorant.",
            canisterBarcode:
                "Le code-barres est attribuÃ© au canister dans lequel le colorant est contenu. Le code-barres est nÃ©cessaire pour garantir un remplissage correct du colorant.",
            checkCanBeforeDispense: "Le rÃ©glage n'est valable que pour la simulation Fast & Fluid.",
            checkOverfill: "Ce paramÃ¨tre vÃ©rifie si il y a assez de place dans la boite pour le colorant avant dosage",
            currentlySelectedMachine: "Fournit des informations sur la machine actuellement sÃ©lectionnÃ©e.",
            dispenseInvalidColorants:
                "Le rÃ©glage permet de doser les colorants qui ne sont pas dÃ©finis dans la configuration de la machine en demandant l'ajout manuel de colorant.",
            dispenserConfigurationBackup:
                "TÃ©lÃ©chargez et enregistrez la configuration actuelle de la machine pour conserver une sauvegarde.",
            dispensingLogic:
                "Les diffÃ©rents types de dosage peuvent garantir un comportement diffÃ©rent pour chaque canister lorsqu'il y a plus de colorant Ã  distribuer que ce qui est autorisÃ© ou souhaitÃ©. Un comportement supplÃ©mentaire est dÃ©fini dans les paramÃ¨tres de distribution.",
            enableTmc: "Ce paramÃ¨tre autorise l'envoi de donnÃ©es vers TMC",
            enableUserIdentification: "L'utilisateur doit se connecter avant que la distribution ne soit autorisÃ©e.",
            machineUnit: "L'unitÃ© de machine dÃ©finit l'unitÃ© de mesure des colorants dans les canisters.",
            minDispensedAmount:
                "La quantitÃ© mininimum distribuÃ©e dÃ©finit la quantitÃ© de colorant qui a dÃ» Ãªtre distribuÃ©e afin de prendre en compte la purge effectuÃ©e (pour Ã©viter une purge supplÃ©mentaire).",
            minimalDispenseAmount:
                "La quantitÃ© de distribution minimale est la plus petite quantitÃ© de colorant recommandÃ©e pouvant Ãªtre distribuÃ©e. En cas de violation, un message apparaÃ®t (la distribution est toujours possible).",
            missingAutotaskCanisters: "Il faut sÃ©lectionner au moins un canister.",
            missingAutotaskChannels: "Il faut sÃ©lectionner au moins un canal.",
            missingAutotaskChannelsValue: "Le volume de tous les canaux selectionnÃ©s doit Ãªtre renseignÃ©",
            missingAutotaskCleanTime: "Le temps de nettoyage doit Ãªtre renseignÃ©",
            missingAutotaskName: "Le nom de la tÃ¢che automatique doit Ãªtre renseignÃ©",
            missingAutotaskRecirculation: "Le temps et la vitesse de recirculation doivent Ãªtr renseignÃ©s",
            missingAutotaskStirring: "Le temps et la vitesse de mÃ©lange doivent Ãªtre renseignÃ©s",
            missingAutotaskVolume: "Le volume de purge doit Ãªtre renseignÃ©",
            placeCanSensor:
                "Le paramÃ¨tre active le capteur de dÃ©tection de pot - le dosage ne commencera que si la boite a bien Ã©tÃ© placÃ©e.",
            placeCanSensorDelay:
                "RÃ©glage recommandÃ© liÃ© au detecteur de pÃ´t. Il garantit que la distribution ne commence qu'aprÃ¨s la pÃ©riode de temps dÃ©finie pendant laquelle la boÃ®te a Ã©tÃ© correctement placÃ©e.",
            purgeVolume: "Le volume de purge dÃ©finit la quantitÃ© de colorant Ã  purger lors de la purge intelligente.",
            rccUrl: "Le Redlike Control Center (RCC) est responsable de la communication avec le distributeur.",
            refillThreshold:
                "Si la quantitÃ© de colorant dans le bidon avec le numÃ©ro d'UFI ou de lot donnÃ© tombe en dessous de cette limite, cet UFI ou ce numÃ©ro de lot sera mis au rebut.",
            refillThresholdBatch:
                "Si la quantitÃ© de colorant dans le bidon portant le numÃ©ro de lot donnÃ© tombe en dessous de cette limite, ce numÃ©ro de lot sera Ã©liminÃ©.",
            refillThresholdUfi:
                "Si la quantitÃ© de colorant dans le bidon avec l'UFI donnÃ© tombe en dessous de cette limite, cet UFI sera mis au rebut.",
            removeCanSensor:
                "Le rÃ©glage active le capteur pour le retrait de la boÃ®te - la distribution n'est considÃ©rÃ©e comme effectuÃ©e que si la boÃ®te a Ã©tÃ© retirÃ©e.",
            removeCanSensorDelay:
                "RÃ©glage recommandÃ© liÃ© au capteur de retrait de boite. Il garantit que la distribution n'est terminÃ©e qu'aprÃ¨s la pÃ©riode de temps dÃ©finie durant laquelle la boÃ®te a Ã©tÃ© retirÃ©e",
            skipPlaceCanDialog:
                "Lorsque ce paramÃ¨tre est activÃ©, la machine Ã  teinter n'attendra pas lors du placement d'une boite que le bouton OK soit pressÃ©, mais dÃ©marrera automatiquement le processus de distribution.",
            skipRemoveCanDialog:
                "Lorsque ce paramÃ¨tre est activÃ©, le distributeur n'attendra pas lors du retrait d'une boÃ®te que le bouton OK soit pressÃ©, mais considÃ©rera automatiquement que le processus de distribution est terminÃ©.",
            smartPurgeType:
                "Le type de purge peut soit considÃ©rer le dosage seulement ou le dosage plus d'autres Ã©venements de purge lors de la validation si la purge intelligente est necessaire.",
            splitFormula:
                "Si la quantitÃ© de colorant necessaire excÃ¨de la quantitÃ© de distribution maximale, le rÃ©glage permet de doser une partie du colorant, de remplir le canister, puis de continuer Ã  doser le reste.",
            tintometricSystem:
                "Tintometric system (set of available colorants) defines what colorants and formulas will be available in the application and application settings.",
            validateBarcodeBaseCan:
                "La base doit Ãªtre validÃ©e par code barre avant que le dosage soit autorisÃ©. Le rÃ©glage ganrantit que la base utilisÃ©e est correcte.",
            validateColorantsDuringInit:
                "La configuration machine sera comparÃ©e sur la base de donnÃ©es Ã  chaque fois que la RCC est redÃ©marrÃ©e. En cas d'incohÃ©rence, une notification apparaitra"
        },
        matchingSettings: {
            matchingInformation: "On matching result panel, %{item} will be available.",
            matchingOptionsColorants: "On matching options panel, colorants panel will be available.",
            matchingOptionsColorfile: "On matching options panel, colorfile selectbox will be available.",
            matchingOptionsSortResults: "On matching options panel, sort results selectbox will be available.",
            matchingRowCount: "DÃ©finit le nombre de rÃ©sultats Ã  proposer la teinte contretypÃ©e"
        },
        navigation: {
            barcodeScan: "Ouvre une fenÃªtre avec la possibilitÃ© de saisir le code-barres manuellement.",
            canisterBarcodes:
                "Ouvre une fenÃªtre avec un aperÃ§u du code barre du canister et la possibilitÃ© de paramÃ©trer le code barre du canister.",
            canisterLevel:
                "Ouvre une fenÃªtre avec un aperÃ§u du niveau de remplissage des canisters et la possibilitÃ© de rÃ©gler le niveau des canisters.",
            canisters:
                "Ouvre un Ã©cran avec un aperÃ§u du niveau de remplissage des canisters et la possibilitÃ© de rÃ©gler le niveau des canisters.",
            clean: "Open a window with the possibility to clean machine channels",
            colorPanel:
                "Ouvre un Ã©cran avec la possibilitÃ© de chercher une nouvelle formule dans le nuancier Ã©lÃ©ctronique.",
            colorSearchTab: "Opens a panel with possibility to search all colors in all fandecks.",
            colorantRefillHistory:
                "Ouvre une fenetre avec un aperÃ§u des remplissages de canister qui ont Ã©tÃ© effectuÃ©s.",
            customFormula: "Ouvre un Ã©cran avec la possibilitÃ© de crÃ©er une nouvelle formule personnalisÃ©e.",
            customers:
                "Ouvre un Ã©cran avec un aperÃ§u des clients et avec la possibilitÃ© de les ajouter/Ã©diter/effacer.",
            dispensingHistory: "Ouvre un Ã©cran avec un aperÃ§u des dosages effectuÃ©s.",
            favorites: "Ouvre un Ã©cran avec la possbilitÃ© de selectionner un formule favorite.",
            help: "Ouvre une fenetre contenant les informations de service du client si cela a Ã©tÃ© mis Ã  disposition par le fournisseur.",
            hideItems:
                "Ouvre une fenÃªtre avec la possibilitÃ© de marquer les produits et les nuanciers comme Ã©tant cachÃ©s.",
            historyOfOrders: "Valide pour %{name} exclusivement, ouvre un Ã©cran avec un aperÃ§u des commandes dosÃ©es.",
            machineReset: "Demarre la rÃ©initialisation de la machne Ã  teinter.",
            matching: "Opens a panel with the possibility to match new color with a spectro.",
            myOrders: "Orders which were sent from this computer",
            purge: "Ouvre une fenetre donnant la possibilitÃ© de paramÃ©trer la purge du canister.",
            quickTint: "Ouvre une fenetre donnant la possibilitÃ© de rÃ©aliser un dosage manuel.",
            searchFormula: "Ouvre un Ã©cran donnant la possibilitÃ© de chercher une nouvelle formule.",
            spectro: "Ouvre un Ã©cran donnant la possibilitÃ© de mesurer avec un spectro.",
            stir: "Ouvre une fenetre donnant la possibilitÃ© de rÃ©gler l'agitation des canisters.",
            ticketing: "Ouvrir l'Ã©cran des demandes de contretypage",
            toDispense: "Orders which were received by this computer"
        },
        noHelpForLicense:
            "Il n'y a pas d'aide disponible pour votre licence, veuillez demander Ã  votre fournisseur de l'ajouter.",
        posInfo: {
            sync: "Synchronse les donnÃ©es avec la section Enregistrement"
        },
        poweredByDeso: "ElaborÃ© par %{name}",
        priceSettings: {
            VatPrice: "Valeur de TVA pour les colorants, en %",
            VatPriceProduct: "La TVA du produit gÃ©nÃ©rique sera la mÃªme pour chaque colorant. S'installer %.",
            basePurchase: "Prix d'achat pour la base (base uniquement)",
            basePurchasePriceProduct:
                "Prix d'achat pour le package de la base donnÃ©e. DÃ©fini dans la devise sÃ©lectionnÃ©e.",
            baseSell: "Le prix de vente uniquement par base (base + margin/markup)",
            baseSellFull: "Sell full price for base.",
            cntName: "DÃ©finit Ã  quel colorant le prix est liÃ©.",
            cntPurchase: "Prix d'achat pour les colorants (colorants uniquement)",
            cntPurchaseByName: "Prix d'achat des colorants calculÃ©s individuellement (colorants uniquement)",
            cntPurchasePricePerLiter: "Prix d'achat des colorants par litre (sans marge et/ou markup)",
            cntSell: "Prix de vente des colorants (en incluant marge et/ou markup)",
            cntSellByName:
                "Prix de ventes de tous les colorants sur une base de calcul colorant par colorant (marge et/ou markup inclus)",
            cntSellFull: "Sell full price for colorants.",
            cntSellFullByName: "Sell full price for colorants by name.",
            cntSellPricePerLiter:
                "Le prix de vente du colorant par litre (incluant exclusivement le colorant). DÃ©fini dans la devise sÃ©lectionnÃ©e.",
            cntVat: "Valeur TVA du colorant dÃ©finie en %.",
            colorants:
                "Le prix des colorants sera le meme pour tous les colorants. Cette fonctionnalitÃ© est trÃ¨s pratique pour la TVA.",
            colorantsPosCoeficient: "The generic colorant coeficient for POS.",
            colorantsSellPrice:
                "The generic colorant prices will be the same for every colorant. Sell price is recommended to by modified by discount. Set in selected currency.",
            currencyCodeNew: "Le code monÃ©taire doit se constituer de trois lettres, par exemple EUR",
            currencyNameNew: "Le nom de la monnaie, par exemple l'Euro",
            currencyRateNew:
                "Le taux de conversation vers la monnaie dÃ©finit .Par exemple vous souhaitez convertir de la couronne TchÃ©que vers l'Euro. Il faut 25,855 CZK pour 1 â¬, Le taux doit etre mis Ã  jour rÃ©guliÃ¨rement",
            currencyRoundingNew:
                "Permet de dÃ©finir le plus petit montant payable dans une monnaie donnÃ©e. Exemple: en Euro, le plus montant payable est 0,01EURO",
            currencySymbolNew: "Le symbole offiiciel de la monnaie, par exemple le symbole â¬ pour l'Euro.",
            defaultPrice: "Prix des colorants tel que dÃ©finit dans la base de donnÃ©es (sans TVA)",
            defaultPriceGroup:
                "Prix des colorants tel que dÃ©finit par groupes de prix dans la base de donnÃ©es sÃ©lectionnÃ©es (sans TVA)",
            defaultVatPrice: "Niveau de TVA dÃ©finit pour les colorants dans la base de donnÃ©es",
            discountHeader: "La remise soustrait la valeur dÃ©finie du prix d'achat du colorant. S'installer %",
            discountHeaderProduct:
                "La remise soustrait la valeur dÃ©finie du prix du colorant du produit. S'installer %.",
            export: "Exportez un fichier avec les prix actuellement insÃ©rÃ©s. Il peut Ãªtre rÃ©importÃ© aprÃ¨s avoir modifiÃ© les prix.",
            import: "Importez un fichier correctement formatÃ© (exportÃ©) pour insÃ©rer ou modifier les prix.",
            localPrices:
                "Local prices change suggested prices from the main database and are present solely locally on this particular computer.",
            margin: "Choisissez le calcul de prix Ã  utiliser pour la dÃ©finition du prix final disponible. La marge s'additionne alors que la remise soustrait du prix de vente donnÃ©.",
            marginAll: "Le montant de la marge/markup pour plusieurs emballages",
            marginHeader: "La marge ajoute la valeur dÃ©finie au prix d'achat du colorant. S'installer %.",
            marginHeaderProduct: "La marge ajoute la valeur dÃ©finie au prix d'achat du produit. S'installer %.",
            marginPerPkg: "Le montant de la marge/markup pour un emballage",
            markupHeader: "Le markup ajoute la valeur dÃ©finie au prix d'achat du colorant. S'installer %.",
            markupHeaderProduct: "Le markup ajoute la valeur dÃ©finie au prix d'achat du produit. S'installer %.",
            packagePricing: "SurpondÃ©ration additionnelle paramÃ©trer individuellement pour chaque taille d'emballage",
            packageSurcharge: "Le cout d'emballage sera le meme pour tous les emballages",
            priceDefinition: "Ce paramÃ¨tre dÃ©finit les types de prix utilisÃ©s pour le calcul des prix finaux.",
            priceGroupNumber:
                "Ce paramÃ¨tre dÃ©finit le nombre de groupes de prix qui seront utilisÃ©s. La fourchette pour les groupes de prix individuels peut Ãªtre dÃ©finie dans Valeurs par dÃ©faut.",
            priceGroupPricePerLiter: "Le prix de colorant utilisÃ© pour le calcul des prix par catÃ©gories de prix",
            priceGroups:
                "Les groupes de prix affichent le numÃ©ro du groupes de prix pertinent (les limites sont dÃ©finies dans la base de donnÃ©es ou dans la tarification gÃ©nÃ©rique)",
            priceGroupsEnabled:
                "Ce paramÃ¨tre vous permet de travailler avec des groupes de prix. DÃ©finissez la gamme dans Valeurs par dÃ©faut et les prix individuels dans Prix des colorants.",
            priceGroupsGeneric:
                "Les groupes de prix sont des intervalles de prix de la peinture finale basÃ©s sur les prix des colorants dans la formule.",
            productBasePackageSellPrice:
                "Prix de vente pour lâemballage de la base donnÃ©e. DÃ©fini dans la devise sÃ©lectionnÃ©e.",
            productBaseSellPrice:
                "Prix de vente de la base calculÃ© par litre ( incluant exclusivement la base). DÃ©fini dans la devise sÃ©lectionnÃ©e.",
            productBaseVat: "Valeur de TVA de base du produit pour le package donnÃ© dÃ©finie en %.",
            productName: "DÃ©finit Ã  quelle base de produits le prix est liÃ©.",
            productPosCoeficient: "The generic product coeficient for POS.",
            productPricing:
                "Le prix d'achat de tous les emballages est utilisÃ© lors du dosage d'emballages personnalisÃ©s",
            productSize: "DÃ©finit Ã  quel package de la base de produits donnÃ©e le prix est liÃ©.",
            productVat: "Valeur de TVA de base du produit dÃ©finie en %.",
            products:
                "Le prix de vente du produit sera le meme pour tous les produits. Cette fonction est particuliÃ¨rement utile pour le paramÃ¨trage de la TVA",
            productsSellPrice:
                "The generic product prices will be the same for every colorant. Sell price is recommended to by modified by discount. Set in selected currency.",
            sellPriceAll:
                "Le prix de vente de plusieurs emballage (en incluant base, colorants, surpondÃ©ration et marge/markup)",
            sellPricePerKg:
                "Le prix de vente du produit par kilo (en incluant base, colorants, surpondÃ©ration et marge/markup)",
            sellPricePerL:
                "Le prix de vente du produit par litre (en incluant base, colorants, surpondÃ©ration et marge/markup)",
            sellPricePerPkg:
                "Le prix de vente d'un emballage (en incluant base, colorants, surpondÃ©ration et marge/markup)",
            setPriceTypesVisibilityAndOrder:
                "Dans l'ecran Formule, les prix sÃ©lectionnÃ©s seront visibles dans la section des prix. La position la plus Ã©levÃ©e dÃ©finit ici la position la plus Ã  gauche dans la section.",
            surchargeAll:
                "Le prix d'un surcout supplÃ©mentaire pour plusieurs emballage (n'inclut que la surpondÃ©ration)",
            surchargePerPkg: "Le prix d'un surcout supplÃ©mentaire pour un emballage (n'inclut que la surpondÃ©ration)",
            tintPurchaseAll:
                "Le prix d'achat pour l'ensemble du processus de coloration de plusieurs emballages (y compris les colorants et les frais supplÃ©mentaires)",
            tintPurchasePerPkg:
                "Le prix d'achat pour l'ensemble du processus de coloration d'un emballage (y compris les colorants et les frais supplÃ©mentaires).",
            tintSellFullAll: "Tint sell full price for all packages.",
            tintlSellFullAllPerPackage: "Tint sell full price per package.",
            totalPurchaseAll:
                "Le prix d'achat total du produit pour plusieurs emballages (y compris la base et les colorants).",
            totalPurchasePerKg: "Le prix d'achat total du produit par kilogramme (base et colorants inclus).",
            totalPurchasePerL: "Le prix d'achat total du produit par litre (base et colorants inclus).",
            totalPurchasePerPkg: "Le prix d'achat total du produit pour un emballage (base et colorants inclus).",
            totalSellFullAll: "Total sell full price for all packages.",
            totalSellFullPerKg: "Total sell full price per kilogram.",
            totalSellFullPerLiter: "Total sell full price per liter.",
            totalSellFullPerPackage: "Total sell full price per package.",
            withAndWithoutVat:
                "Sur l'Ã©cran Formule, le prix sera visible dans les deux variantes, avec et sans TVA, simultanÃ©ment.",
            withVat: "Sur l'Ã©cran Formule, tous les prix ne seront visibles qu'avec la TVA incluse.",
            withoutVat: "Sur l'Ã©cran Formule, tous les prix ne seront visibles qu'avec la TVA exclue."
        },
        qualityControlSettings: {
            colorDifference: "ModÃ¨le d'Ã©cart de couleur pour le contrÃ´le de la qualitÃ©.",
            deltaA: "DÃ©finit la limite de tolÃ©rance pour le delta A dans le contrÃ´le de la qualitÃ©.",
            deltaB: "DÃ©finit la limite de tolÃ©rance pour le delta B dans le contrÃ´le de qualitÃ©.",
            deltaE: "DÃ©finit la limite de tolÃ©rance pour le delta E dans le contrÃ´le de qualitÃ©.",
            deltaL: "DÃ©finit la limite de tolÃ©rance pour le delta L dans le contrÃ´le de qualitÃ©.",
            deltaMetamerism:
                "DÃ©finit la limite de tolÃ©rance pour le  delta mÃ©tamÃ©risme  dans le contrÃ´le de la qualitÃ©."
        },
        registration: {
            sync: "Synchronise les donnÃ©es avec la section Info POS"
        },
        searchingPleaseWait: "Veuillez patienter, la meilleure correspondance est recherchÃ©e",
        setupSteps: {
            customData: "DonnÃ©es personnalisÃ©es",
            machineType: "Type de machine",
            userPreferences: "PrÃ©fÃ©rences de l'utilisateur"
        },
        spectroSettings: {
            ColorixNanoUseProfiledValues:
                "Lors de l'utilisation de valeurs profilÃ©es, les rÃ©sultats mesurÃ©s sont recalculÃ©s pour supprimer l'effet de filtre. Autorisez cette option pour la mesure spectro universelle",
            XRiteModelRM400: "Aucun pilote requis.",
            datacolorDiagnosticTile: "Datacolor utilise la plaquette de diagnostic",
            datacolorSilent: "Datacolor silencieux",
            measureModes: "SÃ©lectionnez les niveaux de brillance pris en charge.",
            model: "ModÃ¨le",
            simulationPath: "Chemin vers le fichier de simulation. PrÃ©rÃ©glage par dÃ©faut.",
            spectroType: "Le pilote spectro officiel doit Ãªtre installÃ©. Windows seulement.",
            spectroTypeCom:
                "Le pilote spectro officiel doit Ãªtre installÃ©. MÃ©fiez-vous du port COM utilisÃ©. Windows ainsi que Linux.",
            spectroTypeDataColorReader:
                "L'ordinateur doit avoir une connexion Bluetooth. Le spectro doit Ãªtre appareillÃ© avec l'ordinateur. Windows 10 avec mise Ã  jour d'automne 2018 requise.",
            spectroTypeMinolta2XXXd:
                "Le pilote spectro officiel doit Ãªtre installÃ©. MÃ©fiez-vous du port COM utilisÃ©. Windows ainsi que Linux.",
            spectroTypeNotSelected: "SÃ©lectionnez votre modÃ¨le spectro.",
            spectroTypeRM400: "Aucun pilote requis.",
            spectroTypeSimulation:
                "Valeurs Lab requises pour obtenir des rÃ©sultats de simulation. Windows ainsi que Linux.",
            spectroTypeXRite: "Windows seulement."
        },
        ufiCode: {
            baseUfiCodeValidation:
                "Le code UFI du pot de base doit Ãªtre validÃ© par code-barres avant que la distribution ne soit autorisÃ©e.",
            enableUfiCodes:
                "Les codes UFI sont utilisÃ©s dans l'UE et fournissent des informations sur le degrÃ© de dangerositÃ© d'un produit pour l'environnement.",
            invalidUfi: "Invalid UFI code",
            printUfiCode:
                "Si un colorant dans une formule dÃ©passe la limite donnÃ©e, son code UFI sera imprimÃ© sur l'Ã©tiquette d'impression.",
            printUfiCodePercentage:
                "Si un colorant dans une formule dÃ©passe la limite donnÃ©e, son code UFI sera imprimÃ© sur l'Ã©tiquette d'impression avec sa reprÃ©sentation en pourcentage.",
            ufiCodesByPercentage:
                "Le code UFI qui prÃ©vaut est utilisÃ© pour l'impression compte tenu de son niveau rÃ©el dans le canister. AccÃ©dez aux paramÃ¨tres du canister pour dÃ©finir le seuil de chaque canister.",
            ufiCodesFromDatabase:
                "Le code UFI de la base de donnÃ©es principale fourni par l'administrateur de la base de donnÃ©es est utilisÃ© pour l'impression.",
            ufiCodesFromLastFilling: "Le markup ajoute la valeur dÃ©finie au prix d'achat du colorant. S'installer %."
        },
        userManagement: {
            add: "Le paramÃ¨tre ajoute un nouvel utilisateur qui peut se connecter au logiciel. L'utilisateur peut avoir un code-barres attribuÃ© et peut Ãªtre configurÃ© pour se connecter automatiquement aprÃ¨s le dÃ©marrage du logiciel.",
            assignedGroups:
                "Cela dÃ©finit les groupes d'utilisateurs auxquels appartient l'utilisateur. DiffÃ©rents privilÃ¨ges peuvent Ãªtre associÃ©s aux diffÃ©rents groupes.",
            availableGroups:
                "Cela dÃ©finit les groupes d'utilisateurs disponibles pour l'utilisateur. DiffÃ©rents privilÃ¨ges peuvent Ãªtre associÃ©s aux diffÃ©rents groupes.",
            loggedUserDelete: "L'utilisateur actuellement connectÃ© ne peut pas Ãªtre supprimÃ©."
        },
        visit: "Ou visiter",
        visitNoLicense: "Pour plus d'information, svp visiter"
    },
    helpSettings: {
        customHelpLink: "lien vers help center",
        helpSettings: "paramÃ¨tres d'aide",
        message: "Message"
    },
    helper: {
        automaticallyCheckForUpdates: "VÃ©rifier la disponibilitÃ© de mises Ã  jour",
        automaticallyDownloadUpdates: "TÃ©lÃ©charger les mises Ã  jour automatiquement",
        automaticallyInstallNewDatabases: "Installer automatiquement les nouvelles bases de donnÃ©es",
        automaticallyInstallUpdates: "Installer automatiquement les nouvelles mises Ã  jour",
        bugReport: "Signaler les erreurs",
        canBrowseChangeLog: "Show online %{name} changelog.",
        collect: "Collecter",
        collectLogFiles: "Collecter fichiers Log",
        component: "Composants",
        content: "Contenu",
        contentSize: "Taille du contenu",
        download: "TÃ©lÃ©charger",
        downloadLogFiles: "TÃ©lÃ©charger Log file",
        downloadingData: "TÃ©lÃ©charger donnÃ©es",
        everyHours: "Toules les %{interval} heures.",
        forceInstall: "Forcer la mise Ã  jour",
        installDuringNight: "Pendant la nuit (%{start} - %{end}) toutes les %{interval} heures",
        newVersion: "Nouvelle version",
        notConnected: "La rubrique d'aide n'est pas connectÃ©e",
        openBugReport: "Ouvrir le rapport d'erreur",
        packageSize: "Taille d'emballage",
        pleaseWait: "Attendez svp, cl'opÃ©ration peut prendre un certain temps",
        send: "Envoyer",
        sendBugReportToCustomerService: "Envoyer rapport d'erreur au service client",
        sendingReport: "Envoi en cours",
        subject: "Sujet"
    },
    helperDialog: {
        1: "Vous pouvez consulter la disponibilitÃ© de mise Ã  jour logiciel ou mise Ã  jour de la base de donnÃ©es",
        2: "Continuer Ã  tÃ©lÃ©charger la mise Ã  jour?",
        3: "Continuer l'installation de la mise Ã  jour tÃ©lÃ©chargÃ©e?",
        10: "Recherche de mises Ã  jour logiciel ou base de donnÃ©es",
        11: "Il y a une mise Ã  jour disponible pour votre ordinateur. Voulez vous la tÃ©lÃ©charger?",
        12: "Il n'y a pas de mises Ã  jour disponible pour votre ordinateur.",
        14: "Une erreur s'est produite lors de la vÃ©rification des mises Ã  jour. %{0}",
        15: "Synchronisation de la base de donnÃ©es, patientez svp",
        20: "TÃ©lÃ©chargement en cours de la mise Ã  jour, patientez svp",
        21: "La mise Ã  jour qui a Ã©tÃ© tÃ©lÃ©chargÃ©e est en cours de vÃ©rification, patientez svp",
        22: "Le tÃ©lÃ©chargement de la mise Ã  jour a Ã©chouÃ©, voulez-vous rÃ©essayer?",
        23: "Le tÃ©lÃ©chargement de la mise Ã  jour a Ã©chouÃ©, (fichier mal renseignÃ©), voulez-vous rÃ©essayer?",
        24: "ProcÃ©der Ã  l'installation de la mise Ã  jour?",
        25: "L'installation de la mise Ã  jour automatique commencera dans %{0}",
        26: "Il y a une mise Ã  jour disponible pour votre ordinateur. Voulez vous la tÃ©lÃ©charger?",
        27: "ProcÃ©der Ã  l'installation de la mise Ã  jour?",
        40: "Interruption en cours des applications et services, patientez svp",
        41: "Copie des fichiers en cours, patientez svp",
        42: "DÃ©marrage des applications et services, patientez svp",
        43: "Cloture de la mise Ã  jour logiciel, patientez svp",
        44: "Votre logiciel a Ã©tÃ© mis Ã  jour avec succÃ©s",
        45: "Voulez vous retenter l'installation? Si vous dÃ©cidez de rÃ©essyer, assurez-vous que le logiciel n'est pas actuellement actif. Fermez toutes les fenetres du logiciel svp.",
        46: "Le redÃ©marrage du PC est requis pour appliquer les modifications, le redÃ©marrage se fera dans %{0}",
        999: "Une erreur interne s'est produite: %{0}",
        automaticInstallation: "Installation de la mise Ã  jour automatique",
        btnAbort: "ArrÃ©ter",
        btnCancel: "Annuler",
        btnCheckUpdate: "VÃ©rifier la disponibilitÃ© de mises Ã  jour",
        btnContinue: "Continuer",
        btnDownloadUpdate: "TÃ©lÃ©charger une mise Ã  jour",
        btnInstallUpdate: "Installer mise Ã  jour",
        btnOk: "OK",
        btnRetry: "RÃ©essayer",
        btnSkip: "Passer",
        checkingForUpdates: "Recherche de mises Ã  jour en cours",
        downloadingFailed: "Le tÃ©lÃ©chargement a Ã©chouÃ©",
        downloadingPackage: "TÃ©lÃ©chargement de la mise Ã  jour en cours, patientez svp",
        finishingUpdate: "Cloture de la mise Ã  jour ",
        installingUpdate: "Installation de la mise Ã  jour en cours",
        internalError: "Erreur interne",
        rebootRequired: "Le redÃ©marrage est requis",
        startingComponents: "DÃ©marrage en cours des composants logiciels",
        stoppingComponents: "Arret en cours des composants logiciels",
        synchronizingDatabases: "Synchronisation de la base de donnÃ©es de zone",
        updateAvailable: "Mise Ã  jour disponible, sÃ©lectionnez les composants Ã  mettre Ã  jour",
        updateDownloaded: "La mise Ã  jour a Ã©tÃ© tÃ©lÃ©chargÃ©e",
        updateFailed: "Le processus de mise Ã  jour a Ã©chouÃ©",
        updateInstalled: "La mise Ã  jour a Ã©tÃ© installÃ©e",
        verificationFailed: "La vÃ©rification de la mise Ã  jour a Ã©chouÃ©",
        verifyingPackage: "VÃ©rification des fichiers tÃ©lÃ©chargÃ©s",
        yourSoftwareIsUpToDate: "Votre logiciel est Ã  jour",
        yourSoftwareVersion: "La version de votre logiciel: %{0}"
    },
    importData: {
        abortImportingData: "Interrompre l'import",
        aborted: "L'importation a Ã©tÃ© abandonnÃ©e.",
        backupLocalDB: "Sauvegarde de la base de donnÃ©es locale",
        confirmRestore: "Voulez-vous vraiment restaurer tous les paramÃ¨tres locaux",
        dataMissing: "L'importation a Ã©chouÃ© car le fichier source ne contenait aucune donnÃ©e.",
        deleteImportedData: "Supprimer les donnÃ©es importÃ©es",
        encodingFile: "Encodage de fichier",
        exportLocalSettings: "Export Local Settings",
        exportStaticSql: "Export Static SQL",
        fileDamaged: "L'importation a Ã©chouÃ© car le fichier source semble Ãªtre endommagÃ©.",
        fileMissing: "L'importation a Ã©chouÃ© car le fichier source n'existe pas.",
        format: "Format",
        formatPath: "Chemin du format",
        headerMissing: "L'importation a Ã©chouÃ© car l'en-tÃªte des fichiers est manquant.",
        import: "Importer",
        importAborted: "Import interrompu",
        importAborting: "Interruption de l'import en cours",
        importFailed: "L'importation a Ã©chouÃ© en raison d'une erreur inattendue.",
        importLocalSettings: "Import Local Settings",
        importPrices: "Import des prix",
        imported: "ImportÃ© avec succÃ©s",
        importedWithErrors: "L'importation s'est terminÃ©e avec des erreurs. Les lignes d'erreur ont Ã©tÃ© ignorÃ©es.",
        importing: "Importation en cours",
        noFormatAvailable: "Pas de format disponible",
        processing: "Chargement",
        processingCustomFormulas: "Chargement des formules personnalisÃ©es",
        processingCustomers: "Chargement des clients",
        productsFile: "Fichier Produits",
        restoreLocalSettings: "Restore Local Settings",
        underProgress: "L'importation est en cours.",
        unknownFormat: "L'importation a Ã©chouÃ© car le fichier source est de format inconnu.",
        userFormulasFile: "Fichier des formules clients"
    },
    infoType: {
        baseDensity: "DensitÃ© de la base",
        baseMass: "DensitÃ© base",
        baseUfiCode: "Code UFI de base",
        baseVolume: "Volume de la base",
        batchNumbersTable: "Tableau des numÃ©ros de lots",
        bfsGrade: "Grade BFS",
        colorLab: "Couleur Lab",
        colorRgb: "Couleur au format RGB",
        colorRgbHex: "Couleur au format RGC Hex",
        colorXyz: "Couleur xyz",
        colorantBatchNumbers: "Colorant batch numbers",
        colorantMass: "DensitÃ© colorant",
        colorantUfiCodes: "Codes UFI des colorants",
        colorantVolume: "Volume colorant",
        formulaDate: "Date de la formule",
        formulaDatetime: "Date de la formule",
        formulaMoreInfo: "Formule plus dâinfos",
        formulaMoreInfoInternal: "Formule plus dâinfos internes",
        formulaMoreInfoPrint: "Formule plus dâinfos imprimer",
        hbw: "HBW",
        isPackageGravimetric: "Le package est-il gravimÃ©trique?",
        maxColorantMass: "Masse de colorant maximum autorisÃ©e",
        maxColorantVolume: "Volume de colorant maximum autorisÃ©",
        nominalMass: "Masse nominale de l'emballage",
        nominalVolume: "Volume nominal de l'emballage",
        overfillDetected: "Surremplissage dÃ©tectÃ©",
        totalPaintDensity: "Densite la base teintÃ©e",
        totalPaintMass: "DensitÃ© totale peinture",
        totalPaintVolume: "Volume totale peinture",
        ufiCodesTable: "Tableau codes UFI",
        verifiedFormula: "Formule vÃ©rifiÃ©e",
        yValue: "Valeur Y"
    },
    initialTab: {
        favoriteFormulas: "Formules favorites",
        lastDispensedFormulas: "DerniÃ¨res formules dosÃ©es",
        searchNewFormula: "Chercher une nouvelle formule"
    },
    invalidBatchNumbersModal: {
        header: "Check colorants Batch number",
        info: "Au moins un bidon est rempli d'un lot de colorant (probablement) dÃ©fectueux. N'utilisez pas ce lot. Vider le bidon Ã  l'aide de teinte rapide",
        unknownStatus: "Unknown Batch status"
    },
    keyWords: {
        action: "action",
        add: "ajouter",
        addition: "ajout",
        additional: "additionnel",
        address: "adresse",
        admin: "admin",
        advanced: "avancÃ©",
        after: "aprÃ¨s",
        afterDispensing: "aprÃ¨s dosage",
        alfa: "Alfa",
        all: "tout",
        allow: "autoriser",
        alphabetically: "alphabÃ©tiquement",
        amount: "quantitÃ©",
        api: "api",
        ask: "demander",
        autocap: "autocap",
        autotask: "tache automatique",
        availablePrice: "prix disponible",
        backup: "sauvegarde",
        banner: "banniÃ¨re",
        barcode: "code-barres",
        barcodes: "code-barres",
        base: "base",
        before: "avant",
        begin: "dÃ©but",
        bfs: "bfs",
        bottom: "bas",
        brand: "marque",
        brush: "brosse",
        bug: "bug",
        button: "boutton",
        buy: "acheter",
        cC3: "CC3",
        cM: "CM",
        calibration: "calibrage",
        can: "pÃ´t",
        canHandling: "manipulation du pÃ´t",
        canister: "canister",
        canisterFilling: "remplissage de canister",
        canisterLevels: "niveaux de canister",
        canisters: "canisters",
        cap: "bouchon",
        center: "Centrer",
        centre: "Centre",
        change: "Changer",
        changelog: "journal de changement",
        channels: "canaux",
        check: "vÃ©rifier",
        chunk: "morceau",
        chunks: "morceaux",
        city: "ville",
        clean: "propre",
        cleaning: "nettoyer",
        clientIdentifier: "identificateur de client",
        close: "proche",
        closest: "le plus proche",
        code: "code",
        collect: "collecter",
        color: "couleur",
        colorLink3: "ColorLink3",
        colorPanel: "palette de couleurs",
        colorReader: "ColorReader",
        colorant: "colorant",
        colorantConsumption: "consommation de colorant",
        colorantPrice: "prix colorant",
        colorants: "colorants",
        colorix: "Colorix",
        colour: "couleur",
        communication: "communication",
        compare: "comparer",
        competitive: "compÃ©titif",
        computer: "ordinateur",
        config: "config",
        configuration: "configuration",
        confirm: "confirmer",
        confirmation: "confirmation",
        connection: "connexion",
        contactPerson: "contact",
        control: "ContrÃ´le",
        copies: "copies",
        corob: "Corob",
        cost: "coÃ»t",
        country: "pays",
        create: "crÃ©er",
        currency: "devise",
        current: "courant",
        custom: "personnalisÃ©",
        customers: "client",
        daily: "quotidien",
        dark: "Dark",
        data: "donnÃ©e",
        database: "base de donnÃ©es",
        datacolor: "Datacolor",
        date: "date",
        decimals: "dÃ©cimales",
        default: "dÃ©faut",
        delay: "retard",
        delete: "effacer",
        deletion: "effacement",
        deltaE: "delta e",
        device: "appareil",
        devices: "appareils",
        diagnosticTile: "plaque de diagnostique",
        dialog: "dialogue",
        direct: "direct",
        disconnect: "deconnecter",
        discount: "remise",
        dispense: "doser",
        dispenser: "machine Ã  teinter",
        dispensing: "dosage",
        down: "bas",
        download: "tÃ©lÃ©charger",
        driver: "pilote",
        dromont: "Dromont",
        dspProxy: "DspProxy",
        edit: "Ã©diter",
        editor: "Ã©diteur",
        email: "email",
        error: "erreur",
        evoDriver: "EvoDriver",
        evoService: "EvoService",
        excel: "excel",
        expiration: "expiration",
        export: "exportation",
        eyeOne: "Eye-One",
        fF: "F&F",
        fandeck: "nuancier",
        fastFluid: "Fast & Fluid",
        file: "fichier",
        fill: "remplir",
        fillToMax: "remplir au maximum",
        find: "trouver",
        first: "premier",
        flex: "Flex",
        folder: "dossier",
        formula: "formule",
        formulas: "formules",
        from: "de",
        fts5: "fts5",
        fullScreen: "plein Ã©cran",
        fullText: "text intÃ©gral",
        fulltext: "text intÃ©gral",
        g: "g",
        genericPricing: "tarification gÃ©nÃ©rique",
        hLD: "HLD",
        hard: "dur",
        hbw: "hbw",
        help: "aide",
        helpCenter: "centre d'aide",
        hero: "Hero",
        history: "historique",
        home: "maison",
        host: "hÃ´te",
        humidifier: "humidifiant",
        iDD: "IDD",
        identification: "identification",
        image: "image",
        impGallon: "imp. gallon",
        impQuart: "imp. quart",
        import: "importer",
        individually: "individuellement",
        info: "info",
        information: "information",
        initial: "initiale",
        initialization: "initialisation",
        initialize: "initialiser",
        insert: "insÃ©rer",
        install: "installer",
        intellyPurge: "purge intelligente",
        invalid: "invalide",
        ipAddress: "adresse ip",
        italtinto: "Italtinto",
        items: "articles",
        keyboard: "clavier",
        kg: "kg",
        kiosk: "kiosque",
        kioskMode: "mode kisoque",
        l: "I",
        lLD: "LLD",
        lab: "lab",
        label: "Ã©tiquette",
        labels: "Ã©tiquettes",
        language: "langue",
        largo: "largo",
        last: "dernier",
        lenteq: "Lenteq",
        levels: "niveaux",
        license: "licence",
        light: "LumiÃ¨re",
        limit: "limite",
        link: "lien",
        linux: "Linux",
        load: "charger",
        lock: "verrouiller",
        logFiles: "fichiers journaux",
        logic: "logique",
        logo: "logo",
        lower: "infÃ©rieur",
        machine: "machine",
        machineConfiguration: "configuration de la machine",
        machineManagement: "gestion de la machine",
        machineName: "nom de la machine",
        main: "principal",
        maintenance: "entretien",
        manual: "manuel",
        manualAddition: "ajout manuel",
        manualDispensing: "dosage manuel",
        manualScan: "scan manuel",
        margins: "marges",
        markups: "annotations",
        mass: "masse",
        match: "correspondre",
        measure: "mesure",
        measurement: "mesure",
        measurementUnits: "unitÃ©s de mesure",
        melody: "mÃ©lodie",
        message: "message",
        minimal: "minimum",
        minolta: "Minolta",
        minus: "moins",
        minutes: "minutes",
        misura: "Misura",
        ml: "ml",
        mode: "mode",
        model: "modÃ¨le",
        modification: "modification",
        modify: "modifier",
        monthly: "mensuel",
        moreInfo: "plus d'info",
        movableTable: "plateau mobil",
        move: "bouger",
        music: "musique",
        myOrders: "mes commandes",
        name: "nom",
        naming: "appellation",
        nano: "Nano",
        navigation: "navigation",
        new: "nouveau",
        nextDriver: "Driver suivant",
        night: "nuit",
        nixPro: "Nix Pro",
        notes: "notes",
        notification: "notification",
        number: "numÃ©ro",
        off: "Ã©teint",
        open: "ouvert",
        order: "commander",
        ordering: "commande",
        overfill: "dÃ©border",
        overview: "aperÃ§u",
        overwrite: "Ã©craser",
        own: "possÃ©der",
        pCPDriver: "PCPDriver",
        package: "emballage",
        packagePrice: "prix emballage",
        packages: "emballages",
        panels: "panneaux",
        parameter: "paramÃ¨tre",
        path: "chemin",
        pc: "pc",
        phone: "tÃ©lÃ©phone",
        phoneNumber: "numÃ©ro de tÃ©lÃ©phone",
        picture: "image",
        place: "placer",
        placement: "placement",
        plug: "plug",
        plugger: "plugger",
        plugging: "branchement",
        plugin: "plugin",
        plus: "plus",
        pointOfSale: "point de vente",
        popUp: "pop-up",
        pos: "pos",
        present: "prÃ©sent",
        preview: "aperÃ§u",
        price: "tarif",
        priceExport: "tarif export",
        priceGroup: "groupe de tarif",
        priceImport: "tarif import",
        prices: "tarifs",
        pricing: "tarification",
        primaryCurrency: "devise principale",
        print: "imprimer",
        printer: "imprimante",
        printing: "impression",
        problem: "problÃ¨me",
        product: "produit",
        productPrice: "tarif produit",
        profiledValues: "valeurs profilÃ©es",
        punch: "perforer",
        puncher: "perforateur",
        punching: "perforation",
        purge: "purger",
        purgeType: "type de purge",
        purgeVolume: "volume de purge",
        quality: "qualitÃ©",
        quick: "rapide",
        quickTint: "teinte rapide",
        rM: "RM",
        raise: "hausee",
        rcc: "rcc",
        reader: "lecteur",
        reboot: "redÃ©marrer",
        receive: "recevoir",
        recirculate: "recirculer",
        recirculation: "Recirculation",
        redlike: "Redlike",
        refill: "recharge",
        registration: "enregistrement",
        regular: "normal",
        removal: "suppression",
        remove: "retirer",
        report: "rapport",
        reset: "rÃ©initialiser",
        resolution: "rÃ©solution",
        restart: "redÃ©marrer",
        rgb: "rvb",
        rights: "droits",
        rounding: "arrondi",
        rules: "rÃ¨gles",
        sanTint: "SanTint",
        save: "sauvegarder",
        scale: "Ã©chelle",
        scan: "analyse",
        scope: "portÃ©e",
        screen: "Ã©cran",
        screensaver: "Ã©conomiseur d'Ã©cran",
        search: "chercher",
        secondaryCurrency: "devise secondaire",
        select: "selectionner",
        selectedFormula: "Formule sÃ©lectionnÃ©e",
        sell: "vendre",
        sensor: "capteur",
        serialNumber: "numÃ©ro de sÃ©rie",
        server: "serveur",
        servers: "serveurs",
        service: "service",
        serviceAction: "action de service",
        serviceActions: "actions de service",
        serviceSoftware: "logiciel de service",
        serviceWindow: "FenÃªtre de service",
        settings: "paramÃ¨tres",
        shelf: "plateau",
        shortcuts: "raccourcis",
        shot: "un tir",
        show: "montrer",
        shutDown: "fermer",
        shutdown: "fermer",
        silent: "silencieuse",
        simple: "simple",
        simulation: "simulation",
        size: "taille",
        skip: "passer",
        smartPurge: "purge intelligente",
        software: "logiciel",
        softwareSupplier: "fournisseur de logiciel",
        sort: "trier",
        sound: "sond",
        spectro: "spectro",
        spectrophotometer: "spectrophotomÃ¨tre",
        speed: "vitesse",
        split: "diviser",
        start: "dÃ©marrer",
        startup: "dÃ©marrage",
        statistics: "statistiques",
        status: "statut",
        stir: "agiter",
        stirring: "agitation",
        street: "rue",
        support: "support",
        surcharge: "surtaxe",
        tab: "onglet",
        tabs: "onglets",
        task: "tÃ¢che",
        template: "modÃ¨le",
        testing: "essai",
        time: "temps",
        tintingManagementCenter: "centre tinting management ",
        to: "pour",
        toDispense: "pour doser",
        tolerance: "tolÃ©rance",
        top: "haut",
        total: "total",
        translation: "traduction",
        turnOff: "Ã©teindre",
        turntable: "plaque tournante",
        type: "type",
        uIDD: "UIDD",
        uSGallon: "gallon amÃ©ricain",
        uSQuart: "quart amÃ©ricain",
        unit: "unitÃ©",
        up: "haut",
        update: "mis Ã  jour",
        url: "url",
        user: "utilisateur",
        userGroups: "groupes d'utilisateur",
        v1: "v1",
        v2: "v2",
        v3: "v3",
        vAT: "TVA",
        validate: "valider",
        validation: "validation",
        version: "version",
        virtual: "virtuel",
        volume: "volume",
        weekly: "hebdomadaire",
        window: "fenÃªtre",
        windows: "Windows",
        with: "avec",
        without: "sans",
        xRite: "X-Rite",
        xrite: "Xrite",
        yValue: "valeur y",
        zipCode: "code postal",
        zoom: "zoom"
    },
    languages: {
        bg: "Ð±ÑÌÐ»Ð³Ð°ÑÑÐºÐ¸",
        cs: "ÄeÅ¡tina",
        da: "Danois",
        de: "Allemand",
        el: "ÎÎ»Î»Î·Î½Î¹ÎºÎ¬",
        en: "Anglais",
        es: "Espagnol",
        fr: "FranÃ§ais",
        hr: "Hrvatski",
        hu: "Magyar",
        id: "Bahasa IndonÃ©sie",
        is: "Island",
        it: "Italien",
        lt: "Lituanienne",
        lv: "Letton",
        ms: "Melayu",
        nl: "Pays Bas",
        no: "NorvÃ¨ge",
        pl: "Polski",
        pt: "PortuguÃªs",
        ro: "Romana",
        ru: "Ð ÑÑÑÐºÐ¸Ð¹",
        sk: "SlovenÄina",
        sr: "Srpski",
        sv: "Sverige",
        zh: "Chinoise"
    },
    license: {
        activateLicense: "Activer licence",
        activateNewLicense: "Activer nouvelle licence",
        checkLicenseKey: "VÃ©rifier clÃ© licence",
        companyId: "ID sociÃ©tÃ©",
        contactPerson: "Contact principal",
        copy: "Copier",
        country: "Pays",
        emptyCity: "La ville est une information obligatoire",
        emptyCountry: "Le pays est une information obligatoire",
        emptyName: "Le nom du magasin est une information obligatoire",
        enterIdentificationKeys: "Saisissez clÃ© d'identification",
        expirationDate: "Date d'expiration %{dateTime}",
        fillRegistration: "Entrez vos donnÃ©es d'enregistrement (dÃ©rouler vers le bas pour voir plus)",
        insertLicense: "InsÃ©rer la clÃ© gÃ©nÃ©rÃ©e pour la validation hors-ligne",
        invalidEmail: "L'entrÃ©e e-mail n'est pas valide",
        invalidPhone: "L'entrÃ©e tÃ©lÃ©phone n'est pas valide",
        itemsMarkedasterisk: "(les lignes marquÃ©es d'une Ã©toile doivent etre impÃ©rativement renseignÃ©es)",
        lastUpdate: "DerniÃ¨re modification %{dateTime}",
        leasedLicense: "Licence louÃ©e",
        licenseActivated: "Licence dÃ©jÃ  activÃ©e",
        licenseStatus: "Statut de la licence",
        licenseWillExpire: "Votre licence expire dans jours %{dayCount}",
        licenseWillExpireOneDay: "Votre licence expire dans %{dayCount} jours.",
        machineInformation: "Information machine",
        noLicenseAvailable: "Pas de licence disponible ",
        noProductsForKey: "Aucun produit n'est disponible pour les clÃ©s d'identification indiquÃ©es.",
        pointOfSale: "Point de vente",
        producer: "Producteur",
        reactivate: "RÃ©activer",
        reactivateLicense: "Reactivate license",
        region: "RÃ©gion",
        registerLicense: "SVP prenez une copi de la activation et naviguez vers:",
        registrationForm: "Enregistrement",
        selectProduct: "SÃ©lectionner produit",
        serialNumber: "numÃ©ro de sÃ©rie",
        skipNewLicense: "Si vous souhaitez activer une nouvelle licence plus tard, vous pouvez cliquer sur Ignorer",
        unlimitedLicense: "Licence illimitÃ©e",
        userId: "ID utilisation",
        uuid: "Licence UUID",
        versionDetails: "DÃ©tails de la version",
        versionScope: "PortÃ©e de la version",
        versionType: "Type de version",
        zip: "Code Postal"
    },
    login: {
        authenticate: "Authentifier",
        logIn: "Se connecter",
        loginAs: "Se connecter sous un autre profil",
        messages: {
            incorrectUsername: "L'identifiant ou le mot de passe sont incorrects"
        },
        password: "Mot de passe",
        username: "Nom d'utilisateur"
    },
    machineActionHistory: {
        actionHistory: "Historique des actions"
    },
    machineErrors: {
        channel: "Circuit",
        code: "Code Postal",
        machineErrors: "Erreurs machine",
        noMachineErrors: "Il n'y a actuellement aucune erreur machine",
        resetErrors: "RÃ©initialiser erreurs"
    },
    machineSettings: {
        action: "Action",
        addAutotask: "Ajouter tache automatique",
        autoCanisterIn: "Canister automatique activÃ©",
        autoCanisterOut: "Canister automatique dÃ©sactivÃ© ",
        automaticRefill: "Remplissage automatique",
        autotaskSettings: "ParamÃ¨tres des taches automatiques",
        backupConfiguration: "Configuration de la sauvegarde des donnÃ©es machine",
        brushMaintenance: "Maintenance de la brosse",
        capMaintenance: "Maintenance de l'autocap",
        checkCanisterBeforeDispense: "VÃ©rifier les canisters avant dosage",
        checkColorantBaseRules: "Check colorant base rules",
        checkMinDosableAmount: "VÃ©rifier la quantitÃ© minimale de colorants pouvant Ãªtre mise en teinte",
        checkOverfill: "VÃ©rifier le dÃ©bordement de la boÃ®te",
        checkTotalCntAmounts: "VÃ©rifier la quantitÃ© totale de colorants pour la peinture de base",
        cleanAll: "Nettoyer tout",
        computerReboot: "RedÃ©marrage PC",
        computerShutdown: "Extinction PC",
        connectMachine: "Connecter machine",
        days: "Jours",
        daysOfMonth: "Jours du mois",
        devices: "Appareils",
        disabled: "DÃ©sactivÃ©",
        dispenseAndPurge: "Doser et purger",
        dispenseOnly: "Doser uniquement",
        dispenserCleaning: "Nettoyage machine",
        dispensingWithErrorsEnabled: "Autoriser la distribution malgrÃ© les erreurs de validation",
        editAutotask: "Editer paramÃ¨trage de taches automatiques",
        firstRun: "Premier passage",
        hours: "Heures",
        humidifier: "Humidifieur",
        humidifierWaterLevelMaintenance: "Gestion du niveau d'humidifieur",
        machineConfigurationNoCanisters: "La configuration de la machine ne contient pas de canisters",
        machineName: "Nom de la machine",
        machineSettings: "ParamÃ¨tres machine",
        manualPuncher: "PerÃ§age automatique",
        minDispensedAmount: "quantitÃ© minumum dosÃ©e",
        minutes: "Minutes",
        nextRun: "Prochaine exÃ©cution",
        noAutotasksSet: "Aucunes tÃ¢ches automatiques paramÃ©trÃ©es",
        noDataAvailable: "Pas de donnÃ©es disponibles",
        noMachine: "Pas de machine connectÃ©",
        onStart: "Sur dÃ©marrer",
        plugger: "Tampon",
        postpone: "Postpone",
        puncher: "Couteau perforateur",
        purgeAll: "Tout purger",
        purgeOnly: "Purge seulement",
        recirculateAll: "Tout recirculer",
        recirculateChannels: "Recirculer les circuits",
        recirculationSpeed: "Vitesse de recirculation",
        recirculationTime: "DurÃ©e de recirculation",
        refillAll: "Tout remplir",
        refillCanisters: "Remplir canisters",
        runAt: "Quotidiennement Ã  ",
        runDefinedDaysAt: "jours dÃ©fninis Ã ",
        runEvery: "Mettre en Åuvre chaque",
        runInDays: "effectuer chaque",
        serialNum: "NumÃ©ro de sÃ©rie",
        settingsMachine: "ParamÃ¨tres machine",
        smartPurgeAll: "Purge intelligente pour tous les circuits",
        smartPurgeChannels: "purge intelligente des circuits sÃ©lectionnÃ©s",
        smartPurgeRules: "ParamÃ¨trage de la purge intelligente",
        startType: "Type de dÃ©part",
        stirAll: "Agiter tout",
        stirCanisters: "Agiter canisters",
        stirringSpeed: "Vitesse d'agitation",
        stirringTime: "DurÃ©e d'agitation ",
        switchPlateMaintenance: "Maintenance de laplaque d'interrupteur",
        theCurrentlySelectedMachine: "La machine actuellement sÃ©lectionnÃ©e",
        threshold: "Seuil",
        turntable: "Carroussel",
        unifyColorantBatchForMultipleCans: "Unify colorant batch for multiple cans dispensings",
        volume: "Volume",
        weekdays: "Jours de la semaine"
    },
    mainTab: {
        acceptedFormula: "Formule acceptÃ©e",
        addBuildingSite: "Ajouter un chantier",
        addToFavorites: "Ajouter aux favoris",
        alternativeFormulas: "Formule alternative",
        alternativeValidFormulas: "Formules alternatives",
        buildingSiteSpecification: "SpÃ©cification du chantier",
        colorantsAreInvalid: "Un ou plusieurs colorants ne sont pas valides",
        dispensedPackages: "Bidons dÃ©ja teintÃ©s",
        dispensingInProgress: "Dosage en cours",
        dispensingIsAborted: "Le dosage a Ã©tÃ© interrompu",
        dispensingIsNotAvailable: "Le dosage n'est pas disponible",
        dispensingProgress: "%{done} de %{all}",
        editColorant: "Editer colorant",
        editNote: "Editer note",
        findCompetitiveColor: "Essayez de trouver une couleur correspondante dans la base de donnÃ©es",
        forceDispensing: "Forcer le dosage",
        formulaInvalidColorants: "La formule contient des colorants non valables: %{colorants}",
        formulaOutOfDate: "Formula may be out of date",
        formulaProperties: "PropriÃ©tÃ©s de la formule",
        hiddenFandecks: "Nuanciers cachÃ©s",
        hiddenProducts: "Produits cachÃ©s",
        historicalFormulas: "Formules historiques",
        lowerDeltaNumber: "Un nombre de deltas infÃ©rieur correspond Ã  une correspondance plus prÃ©cise",
        machineError: "Erreur machine",
        machineIsBusy: "La machine est occupÃ©e",
        machineNotConnected: "La machine n'est pas connectÃ©e",
        manualColorantAddition: "Ajout manuel de colorant",
        modifiedFormula: "La formule est modifiÃ©e",
        modifiedFormulaInLab: "Formula modified in laboratory",
        newColorAfterScaling: "Nouvelle couleur aprÃ¨s mise Ã  lâÃ©chelle",
        newRgbNotAccuratelyMeasured: "Le nouveau RVB nâest pas mesurÃ© avec prÃ©cision, il nâest quâindicatif.",
        noBaseAvailable: "Aucune base n'est disponible",
        noBuildingSiteAvailable: "Chantier :",
        noColorantForCorrection: "Aucun colorant supplÃ©mentaire pour la correction sÃ©lectionnÃ©e",
        noColorants: "Pas de colorants",
        noCustomer: "Client :",
        noCustomers: "Pas de clients disponibles",
        noDispenseNotesAvailable: "Notes indisponibles",
        noFormulaAvailable: "Non rÃ©alisable!",
        noFormulaSelected: "Pas de formule sÃ©lectionnÃ©e",
        noInternalNotesAvailable: "Commentaires :",
        noNotesAvailable: "Aucune note disponible",
        noPackageAvailable: "No package is available",
        noPackageSelected: "Aucun emballage n'est selectionnÃ©",
        noProductAvailable: "No product is available",
        noResultsFound: "Aucun rÃ©sultat trouvÃ©",
        openLocalFile: "Ouvrir Ã  partir dâune base de donnÃ©es locale",
        openOnlineFile: "Ouvrir Ã  partir de lâInternet",
        order: "Commande",
        orderingIsNotAvailable: "Les options de commande ne sont pas disponibles",
        originalColor: "Couleur originale",
        overAvailableLevel: "Au-delÃ  du niveau maximum disponible",
        package: "Emballage",
        packageIsRequired: "Emballage requis",
        packaging: "Emballage",
        partialUpdateReload: "Partial updates may have affected this formula. Reload this tab to see an updated data.",
        printIsNotAvailable: "L'impression n'est pas disponible",
        productFiles: "Fichiers produit",
        productFilesViewer: "Visualisation des fiches produits",
        productNotAvailable: "Product '%{productName}' is not available.",
        properties: "Properties",
        regularPrice: "Prix standard",
        resetFormulaData: "Nouvelle formule",
        rgbOnlyIndicative: "RVB seulement Ã  titre indicatifÂ !",
        saveAsCustom: "Sauvegarder en tant que",
        saveToStatsIsNotAvailable: "L'enregistrement dans l'historique n'est pas disponible",
        searchForCheaper: "Rechercher formule moins coÃ»teuse",
        selectFromCompetitive: "Vous pouvez sÃ©lectionner une couleur parmi les couleurs compÃ©titives.",
        specialPrice: "Prix special",
        specialPriceVip: "Prix special VIP",
        splitFormula: "Formule fractionnÃ©e",
        withVAT: "Avec TVA",
        withoutVAT: "sans TVA"
    },
    marginSettings: {
        allBases: "Toutes les bases",
        allProducts: "Tous les produits",
        editMargin: "Editer marge",
        marginAndDiscountWarning:
            "Vous devez dÃ©finir lâoption de calcul des prix pour utiliser les marges et les remises.",
        marginSettings: "ParamÃ¨tre de marge",
        marginsFor: "Marges pour",
        markupColorants: "Markup pour les colorants",
        sizeOfPackage: "taille de l'emballage",
        valueBase: "Valeur de base",
        valueColorant: "Valeur de colorant"
    },
    matching: {
        actualColor: "Actual color",
        allCorrections: "All corrections",
        allTillItems: "Tous",
        auto: "Auto",
        autoSelectAll: "Auto all",
        canStartCorrection: "Puis vous pourrez dÃ©marrer la correction.",
        canStartMatching: "Puis vous pourrez dÃ©marrer la formulation.",
        cannotBeUsed: "Matching cannot be used.",
        changeProductAndColorants: "Essayer en changeant de produit ou de colorant",
        checkConfig: "Please check the matching configuration.",
        colorCorrection: "Correction",
        colorIsIndicative: "L'aperÃ§u des couleurs n'est qu'indicatif.",
        colorNotAccurate:
            "La couleur peut ne pas Ãªtre affichÃ©e avec prÃ©cision, cela dÃ©pend toujours des paramÃ¨tres de votre moniteur.",
        colorantInDispensedFormula: "Colorants dans la formule distribuÃ©e",
        confirmDispensing: "Confirm dispensing",
        connectionProblem: "ProblÃ¨me de connexion",
        correctionHistory: "Correction history",
        correctionRunning: "Correction is running",
        draftFormula: "Draft formula",
        exclude: "Exclude",
        excludeAll: "Exclude all",
        include: "Include",
        includeAll: "Include all",
        invalidProduct: "Il n'est pas possible d'effectuer la correspondance pour le produit %{productName}",
        itemOnly: "Item seulement",
        manualColorCorrection: "Manual color correction",
        matchFormula: "Formulation",
        matchingInformation: "Matching information",
        matchingResult: "RÃ©sultat de la formulation",
        matchingRunning: "Formulation en cours !",
        matchingSearchOptions: "Options de formulation",
        measurement: "Couleur",
        noCorrection: "No correction found",
        noSpectralCurveProvided:
            "The connected device cannot be used for matching because it doesn't provide spectral curve",
        notAvailableForMatching: "Not available for matching",
        originalFormula: "Original formula",
        reformulate: "Reformulate",
        reformulationRunning: "Reformulation is running",
        resultColor: "Result color",
        saveAsCustomFormula: "Enregistrer en tant que formule locale",
        searchInProgress: "Veuillez patienter.",
        selectColorfile: "Please select colorfile.",
        selectRequiredItems: "Veuillez sÃ©lectionner un produit, une base, des colorants et un boÃ®tage.",
        selectedResult: "Selected result",
        spectralDataNotAvailable: "Spectral data is not available",
        startCorrection: "Start correction",
        startMatching: "Lancement formulation",
        targetColor: "Target color",
        unsavedDraft: "Unsaved draft",
        unsavedDraftWarning: "Once you are satisfied with formula â do not forget to save your result.",
        usedForMatching: "Used for matching"
    },
    modal: {
        changeColorantUnit: "Changer d'unitÃ© de colorant",
        payAttention: "Faites attention !"
    },
    module: {
        productGroups: "Product groups"
    },
    navigation: {
        globalSearch: {
            fandeckFilter: "Filtre nuancier",
            formulasOverLimit: "Environ %{count} rÃ©sultats.  Saisir plus de caractÃ¨res.",
            foundFormulas: "%{count} formules trouvÃ©es",
            help: "Aide",
            helpText:
                "Tapez par exemple '%{filter}' pour rechercher des formules commenÃ§ant par '%{formula}', un produit commenÃ§ant par '%{product}' et un nom de nuancier contenant '%{fandeck}'.",
            productFilter: "Filtre produit",
            searchInFormulas: "Recherche de formules",
            typeMore: "Ajouter des caractÃ¨res svp"
        },
        menu: {
            actionHistory: "Historique des actions",
            additionalFormulaTab: "Onglet Formule supplÃ©mentaire",
            advancedSettings: "ParamÃ¨tres avancÃ©s",
            autotaskSettings: "ParamÃ¨tres des taches automatiques",
            availableDatabases: "Bases de donnÃ©es disponibles",
            availablePrices: "Tarifs disponibles",
            bugReport: "Rapport d'erreur",
            canisterBarcodes: "Code barre des canisters",
            canisterDispensingLogic: "Logique de dosage",
            canisterFilling: "Remplissage des canisters",
            canisterSettings: "ParamÃ¨tre des canisters",
            clientServerSettings: "Connection client/serveur",
            closing: "Fermeture",
            color: "Couleur",
            colorModification: "Modification de couleur",
            colorPanel: "ParamÃ¨tres de la palette de couleurs",
            colorRepresentation: "Representation & DonnÃ©es couleur",
            colorSearch: "Recherche formule",
            colorant: "Colorant",
            colorantConsumption: "Consommation de colorant",
            colorantPricing: "Tarification des colorants",
            colorantRefillHistory: "Historique de remplissage des colorants",
            competitiveSearch: "Recherche d'une teinte approchante",
            connections: "Connexions",
            currency: "ParamÃ¨tres monÃ©taires",
            customData: "DonnÃ©es personnalisÃ©es",
            database: "Base de donnÃ©es",
            databaseCheck: "VÃ©rification base de donnÃ©es",
            databaseConnection: "Connection base de donnÃ©es",
            defaultValues: "Valeurs par dÃ©faur",
            devices: "Appareils",
            dispensingHistory: "Historique",
            dispensingSettings: "ParamÃ¨tres de dosage",
            driverSettings: "ParamÃ¨tres Driver ",
            environment: "Environnement",
            environmentConfiguration: "ParamÃ¨tres d'environnement",
            environmentalSettings: "ParamÃ¨tres d'environnement",
            favorites: "Favoris",
            fileTransfer: "Transfert de fichier DESO",
            formatting: "Formatage",
            formula: "Formula",
            formulaData: "DonnÃ©es",
            formulaModification: "Modification de la formule",
            formulaPanels: "Ecran Formule",
            formulaSettings: "ParamÃ¨tres formule",
            formulaUnit: "UnitÃ© de formule",
            generalSearch: "Recherche gÃ©nÃ©rale",
            globalSettingsSearch: "Recherche paramÃ¨tres globaux",
            helpItems: "ParamÃ¨tres d'aide",
            importAndExport: "Import et export",
            importAndExportData: "Importer les donnÃ©es personnalisÃ©es",
            importCustomData: "Importer les donnÃ©es ",
            initialFormulaTab: "Onglet Formule initiale",
            interfaceSettings: "ParamÃ¨tres d'interface",
            keyboardShortcuts: "Raccourcis clavier",
            language: "Langue",
            languageSettings: "ParamÃ¨tres de langue",
            layout: "Disposition",
            license: "Licence",
            licenseData: "DonnÃ©es de licence",
            licenseIdentification: "Identification de licence",
            licenseStatus: "Statut de la licence",
            licenseSupplier: "Fournisseur de licence",
            licenseVersion: "Version de licence",
            localData: "DonnÃ©es locales",
            machine: "Information machine",
            machineActions: "Actions de la machine",
            machineAndDevices: "Machine & Appareils",
            machineManagement: "Gestion des machines",
            machineSettings: "ParamÃ¨tres de la machine",
            mainSettings: "RÃ©glages principaux",
            maintenance: "Entretien",
            marginAndDiscount: "Marge et remise",
            matchingSearchResult: "Matching search result",
            matchingSettings: "Matching Settings",
            navigationItems: "Icones de navigation",
            newFormulaWindow: "Formule",
            orderSearch: "Recherche de commande",
            orderSettings: "ParamÃ¨tres de commande",
            packageSurcharge: "SupplÃ©ment forfaitaire",
            popUps: "Notifications",
            posInfo: "Information point de vente",
            price: "ParamÃ¨tres de prix",
            priceManagement: "Management des prix",
            priceSettings: "ParamÃ¨tres des prix",
            pricingOptions: "Options de tarification",
            printSettings: "paramÃ¨tres d'impression",
            productPricing: "Tarification produit",
            qualityControlSettings: "Quality Control Settings",
            quickTint: "Teinte Rapide",
            rccConfig: "ParamÃ¨tres RCC",
            rccConnection: "Connection RCC",
            rccSettings: "ParamÃ¨tres RCC",
            refillSettings: "Refill Settings",
            refillingLogic: "Logique de remplissage",
            registration: "Inscription",
            searchSettings: "ParamÃ¨tres de recherche",
            serverPlugins: "Plugins serveur",
            serviceActions: "Actions de service",
            settings: "ParamÃ¨tres",
            simplifiers: "Simplificateurs",
            singleActions: "Actions simples",
            smartPurgeRules: "RÃ©gle de la Purge Intelligente",
            softwareOptions: "Options logiciel",
            spectroSettings: "ParamÃ¨tres Spectro",
            statistics: "Statistiques ",
            switchToFrontdesk: "Basculer vers bureau",
            switchToFullRedlike: "Passer Ã  %{name}",
            switchToLight: "Passer Ã  %{name}",
            switchToMachine: "Basculer vers machine",
            tabs: "Onglets & Notifications",
            testBarcodes: "Test des codes barres",
            updateOptions: "Options de mise Ã  jour",
            userManagemenet: "Gestion des utilisateurs",
            visibleUnits: "UnitÃ©s visibles"
        },
        navBar: {
            barcode: "Code barre ",
            help: "Aide Cromology",
            hideItems: "Cacher les produits / nuanciers"
        },
        notificationPanel: {
            noNotifications: "Pas de nouvelles notifications"
        },
        tabBar: {
            closeActive: "Fermer fenetres actives",
            closeAll: "Fermer tout",
            closeAllExceptActive: "Fermer toutes les fenetres sauf la fenetre active",
            customFormula: "Custom Formula",
            dispensingHistory: "Historique",
            favorites: "Favoris",
            formulaSearch: "Autre recherche formule",
            rewriteSettings: "Re-write local settings"
        }
    },
    ordering: {
        assign: "Assigner",
        assignment: "Assignation",
        createdDate: "Date de crÃ©ation",
        finishDispensing: "Cloture du dosage",
        foundInOrders: "TrouvÃ© dans les commandes",
        inactiveDatabase: "La formule provient d'une base inactive ou inconnue  %{0}",
        inactiveUnknownDatabase: "La formule vient d'une base de donnÃ©e inactive ou inconnue",
        newOrderReceived: "Vous avez reÃ§u une nouvelle commande",
        noOrderSelected: "Pas de commande sÃ©lectionnÃ©e",
        release: "Version",
        status: {
            accepted: "AcceptÃ©",
            canceled: "AnnulÃ©",
            created: "CrÃ©Ã©",
            done: "EffectuÃ© ",
            partlyDone: "Partiellement effectuÃ©",
            preparing: "PrÃ©paration en cours",
            unknown: "Inconnu"
        }
    },
    partialUpdates: {
        applying: "Applying partial updates",
        cantBeUsedForYourDbVersion: "Updates can't be used for this database. Please update via Helper.",
        newVersionWillBeInstalled:
            "Il installera la nouvelle version, y compris toutes les mises Ã  jour partielles disponibles.",
        noPartialUpdatesAvailable: "No partial updates available",
        outOfDate: "out of date!",
        partialUpdates: "Partial updates",
        partialUpdatesArePreparing: "Partial updates are preparing",
        partialUpdatesAvailable: "Partial updates available!",
        preparedUpdatesMessage: "The following partial updates are prepared to be applied",
        remindMeLater: "Remind me later (after %{time} minutes)",
        swOutOfDate: "The current version of the software is",
        updateAutomatically: "i vous ne rÃ©pondez pas, la mise Ã  jour commencera automatiquement dans : %{time} s",
        updateToNewVersion: "Update to the newest version",
        updateWillTakeMoreTime: "The update will take more time.",
        updatesApplied: "Partial updates were successfully applied.",
        updating: "Updating"
    },
    posInfo: {
        address: "Adresse",
        contactName: "Nom du contact",
        contactPerson: "Nom du contact",
        identification: "Identification",
        machineInformation: "Information machine",
        pos: "Point de vente",
        secondAddress: "Seconde adresse",
        shopIdentification: "Identification magasin",
        shopName: "Nom Magasin",
        url: "URL",
        zipCode: "Code postal"
    },
    priceTypeList: {
        priceBasePurchase: "Cout de la base",
        priceBaseSell: "Prix de vente de la base",
        priceBaseSellFull: "Vendre le plein tarif pour la base",
        priceCntPurchase: "Cout du colorant",
        priceCntPurchaseByColorantName: "Prix de revient du colorant %{0}",
        priceCntPurchaseByName: "Cout du colorant par noms",
        priceCntSell: "Prix de vente des colorants ",
        priceCntSellByColorantName: "Prix de vente du colorant %{0}",
        priceCntSellByName: "Prix de vente des colorants par noms",
        priceCntSellFull: "Vendre le plein tarif pour les colorants",
        priceCntSellFullByColorantName: "Vendre le plein tarif pour le colorant %{0}",
        priceCntSellFullByName: "Vendre le pelin tarif des colorants par nom",
        priceGroupBarcode: "Code-barres du groupe de prix",
        priceMarginAll: "Marge pour tous les emballages",
        priceMarginPerPkg: "Marge pour un emballage",
        priceSellPriceAll: "Prix de vente de tous les emballages",
        priceSellPricePerKg: "Prix de vente en kilo",
        priceSellPricePerL: "Prix de vente en litre",
        priceSellPricePerPkg: "Prix de vente pour un emballage",
        priceSurchargeAll: "SurpondÃ©ration pour tous les emballages",
        priceSurchargePerPkg: "SurpondÃ©ration pour un emballage",
        priceTintPurchaseAll: "Cout d'une teinte pour tous les emballages",
        priceTintPurchasePerPkg: "Cout d'une teinte pour un emballage",
        priceTintSellFullAll: "Teinte vend le plein tarif pour tous les forfaits",
        priceTintSellFullAllPerPackage: "Teinte vend le plein tarif pour par forfait",
        priceTotalPurchaseAll: "Cout total pour tous les emballages",
        priceTotalPurchasePerKg: "Cout total en kilo",
        priceTotalPurchasePerL: "Cout total en litre",
        priceTotalPurchasePerPkg: "Cout total pour un emballage",
        priceTotalSellFullAll: "Total vendre le plein tarif pour tous les forfaits",
        priceTotalSellFullPerKg: "Total vendre le plein tarif par kilogramme",
        priceTotalSellFullPerLiter: "Total vendre le plein tarif par litre",
        priceTotalSellFullPerPackage: "Total vendre le plein tarif par forfait"
    },
    pricing: {
        allBases: "Toutes les bases",
        allPackages: "Tous les emballages",
        backup: "Backup",
        basesOfProduct: "Bases de %{productName}",
        colorantPricing: "Tarification colorant",
        export: "Exporter",
        import: "Importer",
        packagePricing: "Kit tarification",
        packageSurcharge: "Kit surpondÃ©ration",
        packages: "Bidons dÃ©ja teintÃ©s",
        packagesOfProduct: "Packages de %{productName}",
        posCoeficient: "POS coeficient",
        priceGroupPricePerLiter: "Prix par groupe exprimÃ©s en prix au litre",
        priceGroups: "Groupes de prix",
        pricePerLiter: "Prix par litre",
        productPricing: "Tarification produit",
        purchasePrice: "Prix d'achat",
        purchasePricePerLiter: "Prix d'achat en litre",
        sellPrice: "Prix de vente",
        surcharge: "SurpondÃ©ration"
    },
    print: {
        adminRightsRequired: "Les droits d'administrateur sont requis pour modifier ou crÃ©er un nouveau modÃ¨le.",
        allowAutomaticPrint: "Autoriser impression automatique",
        allowPrintAfterDispensing: "Autoriser impression aprÃ¨s dosage",
        allowPrintBeforeDispensing: "Autoriser impression avant dosage",
        automaticPrint: "Imprimer automatiquement",
        choosePrinter: "Imprimante",
        chooseSettings: "Editer les paramÃ¨tres",
        chooseTemplate: "ModÃ¨le",
        copies: "Copies",
        createTemplate: "CrÃ©er un modÃ¨le",
        createTemplateHint:
            "CrÃ©ez un nouveau modÃ¨le Ã  partir de zÃ©ro. Enregistrez-le dans le dossier des modÃ¨les et redÃ©marrez RCC.",
        defaultPrinter: "Imprimante",
        defaultSettings: "ParamÃ¨tres par dÃ©faut",
        defaultTemplate: "ModÃ¨le par dÃ©faut",
        editTemplate: "Modifier le modÃ¨le",
        editTemplateHint: "Modifiez %{name}. Les modifications seront visibles aprÃ¨s le redÃ©marrage du RCC.",
        noEditTemplate: "Aucun modÃ¨le Ã  modifier",
        noPrinterSelected: "Aucune imprimante n'est sÃ©lectionnÃ©e",
        noPrintersAvailable: "Pas d'imprimantes disponibles",
        noTemplateSelected: "Aucun modÃ¨le n'est sÃ©lectionnÃ©",
        noTemplatesAvailable: "Pas d'imprimantes disponibles",
        numberOfCopies: "Nombre de copies",
        openTemplateEditor: "Ouvrir Ã©diteur de modÃ¨le ",
        printAfterDispensing: "Imprimer aprÃ¨s dosage",
        printAsImage: "Imprimer en tant qu'image",
        printBeforeDispensing: "Imprimer avant dosage",
        printOnRequest: "Imprimer sur demande",
        printOptions: "Options d'imprimante",
        printPagesAfterDispensing: "Nombre de copies Ã  imprimer aprÃ¨s dosage ",
        printPagesBeforeDispensing: "Nombre de copies Ã  imprimer avant dosage ",
        printPreview: "AperÃ§u d'impression",
        printSettings: "ParamÃ¨tres d'impression",
        printTaskLinkVariable: "Lien vers une variable",
        printVariable: "Imprimer la variable",
        printerName: "Nom de l'imprimante",
        printerOptions: "Options d'imprimante",
        printerSettings: "ParamÃ¨tres d'impression",
        quickTintTemplate: "ModÃ¨le Teinte Rapide",
        setDefaultPrinter: "DÃ©terminer imprimante par dÃ©faut",
        setDefaultTemplate: "DÃ©terminer modÃ¨le par dÃ©faut",
        setQuickTintTemplate: "DÃ©terminer le modÃ¨le de Teinte Rapide",
        showPreviewDialogBeforePrint: "Afficher la boÃ®te de dialogue d'aperÃ§u avant l'impression",
        template: "ModÃ¨le",
        templateName: "Nom du modÃ¨le",
        templateSettings: "ParamÃ¨tres du modÃ¨le"
    },
    printTemplate: {
        baseCode: "Code de la base",
        baseName: "Nom de la base",
        bfs: "BSF",
        colorantType: "Colorant type",
        customerCity: "Ville du client",
        customerEmail: "Email du client",
        customerName: "Nom du client",
        customerPhone: "TÃ©lÃ©phone du client",
        customerStreet: "Rue du client",
        customerZipCode: "Code postal du client",
        destinationOfUse: "Destination de l'utilisation",
        infoBfsGrade: "Grade BSF",
        orderQrCode: "Code QR",
        packageOrderCount: "Nombre d'emballage commandÃ©",
        posAddress: "Adresse du point de vente",
        posAddressSecond: "Adresse du point de vente 2",
        posCity: "Ville du point de vente",
        posContact: "Contact point de vente",
        posEmail: "Email point de vente",
        posPhone: "TÃ©lÃ©phone point de vente",
        posUrl: "URL du point de vente",
        posZipCode: "Code postal point de vente",
        priceBasePurchaseWithTax: "Cout d'achat base avec TVA",
        priceBaseSellWithTax: "Prix de vente de la base avec TVA",
        priceCntPurchaseWithTax: "Cout d'acht des colorants avec TVA",
        priceCntTotalSellWithTax: "Prix de vente des colorants avec TVA",
        priceMarginAllWithTax: "Marge pour tous les emballages avec TVA",
        priceMarginPerPkgWithTax: "Marge pour un emballage avec TVA",
        priceSellPriceAllWithTax: "Prix de vente pour tous les emballages avec TVA",
        priceSellPricePerKgWithTax: "Prix de vente en Kilo avec TVA",
        priceSellPricePerLWithTax: "Prix de vente au litre avec TVA",
        priceSellPricePerPkgWithTax: "Prix de vente pour un emballage avec TVA",
        priceSurchargeAllWithTax: "SurpomdÃ©ration pour tous les emballages avec TVA",
        priceSurchargePerPkgWithTax: "SurpondÃ©ration pour un emballage avec TVA",
        priceTintPurchaseAllWithTax: "Cout par teinte pour tous les emballages avec TVA",
        priceTintPurchasePerPkgWithTax: "Cout par teinte our un emballage avec TVA",
        priceTotalPurchaseAllWithTax: "Cout total pour tous les emballages avec TVA",
        priceTotalPurchasePerKgWithTax: "Cout total au kilo avec TVA",
        priceTotalPurchasePerLWithTax: "Cout total au litre avec TVA",
        priceTotalPurchasePerPkgWithTax: "Cout total pour un emballage avec TVA",
        productAltName: "Produit",
        recipeInline: "Recette"
    },
    products: {
        bases: "Bases",
        numberOfProducts: "Nombre de produits",
        packagesFor: "Emballages pour ",
        sizeOfPackage: "Taille de l'emballage"
    },
    purgeModal: {
        purgeAll: "Purger tout",
        purgeAllChannels: "Purge des canaux",
        purgeVolume: "Volume de purge",
        startPurge: "Commencer la purge"
    },
    qualityControl: {
        darker: "Darker",
        dispensedMeasuredFormula: "Formule dÃ©livrÃ©e (mesurÃ©e)",
        lighter: "Lighter",
        measureDispensedFormula: "Mesure de la formule distribuÃ©e pour calculer le delta E",
        moreBlue: "More blue",
        moreGreen: "More green",
        moreRed: "More red",
        moreYellow: "More yellow",
        pleaseContinueToFormulaCorrection: "Please continue to formula correction",
        qualityControlFailed: "Quality control failed!",
        qualityControlPassed: "Quality control passed"
    },
    quickTint: {
        dispensingInProgress: "Dosage en cours",
        dispensingIsNotAvailable: "Le dosage n'est pas disponible",
        machineNotConnected: "La machine n'est pas connectÃ©e",
        noColorantsSelected: "Aucun colorant sÃ©lectionnÃ©",
        noPrinterAvailable: "L'impression ne peut pas Ãªtre effectuÃ©e car aucune imprimante n'est disponible.",
        noTemplateAvailable: "L'impression ne peut pas Ãªtre effectuÃ©e car aucun modÃ¨le n'est disponible.",
        overMaxCanisterSize: "Un ou plusieurs niveaux de colorants ne sont pas valides"
    },
    quickTintSettings: {
        alphabetically: "Par ordre alphabÃ©tique",
        byCanister: "Par canisters",
        closeAfterDispensing: "Fermer aprÃ¨s dosage",
        closeBeforeDispensing: "Fermer avant dosage",
        quickTintSettings: "ParamÃ¨tres Teinte Rapide",
        sorting: "Tri en cours",
        windowClosingRules: "RÃ©gles de fermeture des fenetres d'action"
    },
    rccButtons: {
        abort: "Annuler",
        all: "Tout",
        cancel: "Annuler",
        continue: "Continuer",
        help: "Aide",
        ignore: "Ignorer",
        no: "Non",
        noToAll: "Non Ã  tout",
        ok: "OK",
        postpone: "Remettre Ã  plus tard",
        resume: "Reprendre",
        retry: "RÃ©essayer",
        skip: "Passer",
        yes: "Oui",
        yesToAll: "Oui Ã  tout"
    },
    rccDialog: {
        98: "ContrÃ´ler la base %{0} moyennant le code-barres",
        99: "Placer base %{0} et confirmer (cliquer sur OK)",
        100: "La machine est en erreur, la rÃ©initialiser?",
        101: "La machine est en erreur, l'opÃ©ration ne peut pas continuer",
        102: "Echec de la rÃ©initialisation, ne peut pas continuer",
        103: "La formule contient un colorant non valable: %{0}",
        104: "La formule contient des colorants non valables: %{0}",
        105: "Colorant: %{0} sous le niveau dâalerte",
        106: "Colorants: %{0} sous le niveau dâalerte",
        107: "Colorant: %{0} sous le niveau critique",
        108: "Colorants: %{0} sous le niveau critique",
        109: "Positionner la boite",
        110: "Placer la base: %{0} pour la formule: %{1}",
        111: "Retirer la boÃ®te",
        112: "Percer le bidon ?",
        113: "RÃ©initialisation des messages d'erreurs en cours, patientez svp",
        114: "DÃ©placement du plateau Ã©lÃ©vateur en cours, patientez svp",
        115: "PerÃ§age en cours, patientez svp",
        116: "Dosage de la formule %{0}. Merci de patienter|Conditionnement: %{1}/%{2}|Produit: %{3}|Base: %{4}|Cdt: %{5}",
        117: "Dosage de la formule %{0}. Merci de patienter|Conditionnement: %{1}/%{2}|Produit: %{3}|Base: %{4}|Cdt: %{5}",
        118: "Dosage, merci de patienter|Conditionnement: %{0} sur %{1}",
        119: "Dosage, merci de patienter|Conditionnement: %{0} sur %{1}",
        120: "Annulation dosage en cours, patientez svp",
        121: "Valider boite code barre",
        122: "Scanner le code-barres du pot de la base|Produit: %{0}|Base: %{1}|Conditionnement: %{2}",
        123: "Le processus de dosage a Ã©tÃ© interrompu, voulez-vous reprendre le dosage?",
        124: "Message dâerreur machine Ã¡ teinter %{0} : %{1}. Voulez-vous poursuivre le processus de dosage?",
        125: "Assurez-vous que la boite prÃ©cÃ©demment utilisÃ©e est bien positionnÃ©e.",
        126: "Assure-vous d'utiliser une nouvelle boite car le processur de dosage va reprendre de 0",
        127: "Colorant: %{0} est sous la quantitÃ© de dosage minimum. Voulez-vous poursuivre le processus malgrÃ© lâavertissement?",
        128: "Colorants: %{0} sont sous la quantitÃ© de dosage minimum. Voulez-vous poursuivre le processus malgrÃ© lâavertissement?",
        129: "La formule sÃ©lectionnÃ©e nâest pas conforme Ã¡ la rÃ¨gle de dÃ©bordement, quantitÃ© totale de colorants: %{0} %{1}, quantitÃ© maximale admise de colorants: %{2} %{3}. Voulez-vous poursuivre le processus malgrÃ© lâavertissement?",
        130: "La machine est en erreur, rÃ©initialiser les erreurs?",
        131: "La machine est en erreur, l'opÃ©ration ne peut pas continuer",
        132: "La rÃ©initialisation a Ã©chouÃ©, l'opÃ©ration ne peut pas continuer",
        133: "La formule de purge est vide, l'opÃ©ration ne peut pas continuer",
        134: "La formule de purge contient un certain nombre d'artciles qui ne peuvent pas etre purgÃ©s, voulez-vous continuez?",
        135: "Placer le pot pour la purge",
        136: "Retirer le pot de purge",
        137: "RÃ©initialisation des messages d'erreurs en cours, patientez svp",
        138: "DÃ©placement du plateau Ã©lÃ©vateur en cours, patientez svp",
        139: "Purge en cours, patientez svp",
        140: "Purge en cours, patientez svp",
        141: "Annulation purge en cours, patientez svp",
        142: "Le pot de purge est manquant, vÃ©rifier qu'il est bien positionnÃ©",
        143: "La formule de purge contient un certain nombre d'artciles qui ne peuvent pas etre purgÃ©s, voulez-vous continuez?",
        144: "Placer le pot pour la purge",
        145: "PrÃ©paration en cours, patientez svp",
        146: "Cloture en cours, patientez svp",
        150: "Nettoyage en cours, patientez svp",
        151: "Nettoyage en cours, patientez svp",
        152: "Annulation en cours, patientez svp",
        160: "Recirculation en cours, patientez svp",
        161: "Recirculation en cours, patientez svp",
        162: "Annulation de la recirculation en cours, patientez svp",
        170: "Agitation en cours, patientez svp",
        171: "Agitation en cours, patientez svp",
        172: "Annulation de l'agitation en cours, patientez svp",
        180: "Initialisation de la connection Ã  la machine en cours, patientez svp",
        181: "Connexion Ã¡ la machine Ã¡ teinter impossible %{0}: %{1}",
        182: "La connection Ã  la machine ne peut pas etre Ã©tablie. Voir fichier log pour plus d'info",
        183: "Le colorant suivant prÃ©sent votre base de donnÃ©es mais manquant dans votre machine Ã  teinter: %{0} ",
        184: "Les colorants suivants prÃ©sents dans votre base de donnÃ©es mais manquants dans votre machine Ã  teinter: %{0} ",
        185: "Fermeture connection Ã  la machine, attendez svp",
        190: "Fermer la fenetre de service pour continuer",
        200: "RÃ©demarrage en cours, patientez svp",
        201: "Hard reset en cours, patientez svp",
        202: "Initialisation en cours, patientez svp",
        203: "RÃ©initialisation des erreurs en cours, patientez svp",
        205: "L'autocap s'ouvre, patientez svp",
        206: "L'autocar se ferme, patientez svp",
        207: "L'autocap bouge, patientez svp",
        210: "PerÃ§age en cours, patientez svp",
        211: "Connection en cours, patientez svp",
        215: "ElÃ©vation du plateau en cours, patientez svp",
        216: "Descente du plateau en cours, patientez svp",
        217: "Plateau Ã©lÃ©vateur en mouvement, patientez svp",
        220: "DÃ©placer le support rotatif en position de remplissage: %{0}, merci de patienter",
        221: "DÃ©placer le support rotatif en position de base, merci de patienter",
        222: "DÃ©placer le support rotatif, merci de patienter",
        230: "Machine occupÃ©e, patientez svp",
        240: "Remplir le canister  %{0}",
        241: "Veuillez remplir le canister %{0}",
        242: "Positionnement du canister : %{0} (%{1}) en position de remplissage",
        243: "Veuillez remplir le canister %{0} en utilisant le code barre",
        244: "Veuillez remplir le canister %{0} en utilisant le code barre",
        250: "Retirer la brosse et son boitier, les nettoyer et remplir le boitier en accord avec les instructions d'entretien de la machine",
        251: "Replacer la brosse dans son rÃ©ceptable",
        254: "Ouverture de l'autocap",
        255: "Nettoyager l'autocap en accord avec les instructions de maintenance",
        256: "Confirmer quand le nettoyage est fini et que l'autocap est en place",
        257: "Fermeture autocap",
        260: "Retirez la plaque d'interrupteur et nettoyez la",
        261: "Remettez la plaque d'interrupteur en place",
        265: "Nettoyer la machine avec un tissu et retirer les taches de colorants ou autres liquides",
        266: "Confirmer quand l'opÃ©ration est terminÃ©e",
        270: "Remplir le boitier humidifieur et confirmer quand l'opÃ©ration est terminÃ©e",
        271: "Remplir le boitier humidifieur et confirmer quand l'opÃ©ration est terminÃ©e",
        272: "Le niveau d'eau est toujours bas, vÃ©rifiez de nouveau svp",
        273: "Le niveau d'eau est toujours bas, vÃ©rifiez de nouveau svp",
        274: "VÃ©rifier le niveau d'eau prÃ©sent dans le boitier et remplissez le boitier si nÃ©cessaire",
        275: "Attendez svp",
        280: "RÃ©dÃ©marrage du PC en cours",
        281: "Arret du PC en cours",
        300: "Base absente, vÃ©rifiez que la boite est correctement positionnÃ©e",
        301: "PrÃ©paration en cours... Veuillez patienter !",
        302: "Cloture en cours, patientez svp",
        303: "La formule ne peut pas Ãªtre dosÃ©e car elle contient du colorant : %{0} dont la quantitÃ© dÃ©passe la valeure de distribution maximale dÃ©finie pour son canister",
        304: "La formule ne peut pas Ãªtre dosÃ©e car elle contient les colorants : %{0} dont la quantitÃ©s dÃ©passet la valeures de distribution maximales dÃ©finies pour leurs canisters",
        305: "Le colorant: %{0} ne peut pas Ãªtre distribuÃ© en une seule fois, voulez-vous diviser la formule?",
        306: "Les colorants: %{0} ne peuventt pas Ãªtre distribuÃ©s en une seule fois, voulez-vous diviser la formule?",
        307: "Le colorant: %{0} ne sera pas distribuÃ© par la machine, voulez-vous continuer et l'ajouter manuellement?",
        308: "Les colorants: %{0} ne seront pas distribuÃ©s par la machine, voulez-vous continuer et les ajouter manuellement ?",
        309: "La formule sÃ©lectionnÃ©e est vide, utiliser la base en l'Ã©tat",
        310: "Aucun colorant ne sera distribuÃ©, prÃ©parez la base pour l'ajout manuel de colorant.",
        311: "Retirez la base et prÃ©parez-la pour l'ajout manuel de colorant",
        312: "Ajoutez manuellement %{0} %{1} de colorant: %{2}, confirmez lorsque c'est fait",
        313: "Doser la formule manuelle",
        314: "La formule sÃ©lectionnÃ©e enfreint la rÃ¨gle de remplissage, la quantitÃ© totale de colorants: %{0} %{1},  quantitÃ©s maximales autorisÃ©es de colorants: %{2} %{3}. Voulez-vous continuer malgrÃ© cet avertissement?",
        315: "Scanner ou taper le code UFI de la boÃ®te de base",
        316: "Scanner ou saisir le code UFI de la boÃ®te de base | Produit: %{0} | Base: %{1} | Taille de la boÃ®te: %{2}",
        317: "Prepare colorant: %{0} for manual addition, confirm when done",
        318: "Prepare colorants: %{0} for manual addition, confirm when done",
        319: "Ajouter manuellement le colorant : %{0}, confirmer lorsque c'est fait",
        320: "Ajouter manuellement des colorants : %{0}, confirmer lorsque c'est fait",
        400: "La purge automatique va commencer",
        401: "La purge automatique va commencer",
        405: "La brosse et son boitier ont besoin d'une maintenance",
        406: "La brosse et son boitier ont besoin d'une maintenance",
        410: "La maintenance automatique de l'autocap va commencer",
        411: "La maintenance automatique de l'autocap va commencer",
        415: "La plaque d'interrupteur doit Ãªtre nettoyÃ©e",
        416: "La plaque d'interrupteur doit Ãªtre nettoyÃ©e",
        420: "La machine doit etre nettoyÃ©e",
        421: "La machine doit etre nettoyÃ©e",
        425: "Le remplissage des canisters va commencer",
        426: "Le remplissage des canisters va commercer",
        430: "Le redÃ©marrage du PC a Ã©tÃ© planifiÃ©",
        431: "Le redÃ©marrage du PC a Ã©tÃ© planifiÃ©",
        435: "L'arret du PC a Ã©tÃ© planifiÃ©",
        436: "L'arret du PC a Ã©tÃ© planifiÃ©",
        440: "Le nettoyage de la machine a Ã©tÃ© planifiÃ©",
        441: "Le nettoyage de la machine a Ã©tÃ© planifiÃ©",
        445: "La recirculation de la machine a Ã©tÃ© planifiÃ©e",
        446: "La recirculation de la machine a Ã©tÃ© planifiÃ©e",
        450: "L'agitation de la machine a Ã©tÃ© planifiÃ©e",
        451: "L'agitation de la machine a Ã©tÃ© planifiÃ©e",
        990: "Message dâerreur machine Ã¡ teinter %{0} : %{1}. Voulez-vous rÃ©essayer?",
        991: "Message dâerreur interne: %{0}",
        200000001: "Positionner la boite",
        200000002: "Retirer la boite",
        200000003:
            "La quantitÃ© de '%{0}' est sous le dosage minimum. Souhaitez-vous poursuivre Ã¡ vos propres risques et pÃ©rils?",
        200000004: "Faire lâappoint de '%{0}'"
    },
    rccDriverSettings: {
        databasePath: "Chemin vers base de donnÃ©es ",
        dispenser: "Machine Ã  teinter",
        dispenserConfigurationFile: "Fichier config machine Ã  teinter",
        driverPath: "Chemin vers le driver",
        extensionPath: "Extension du chemin",
        folder: "Dossier",
        formulaPath: "Chemin vers formule",
        host: "Hote",
        iddPath: "Fichier de configuration IDD",
        italtintoPath: "Ficher de configuration Italtinto",
        lldPath: "Chemin LLD",
        machineType: "Type de machine",
        noMachineAvailable: "Aucune machine n'est disponible",
        protocolVersion: "Version du protocole",
        rccDriverSettings: "ParamÃ¨tres de Driver",
        resultPath: "Chemin de rÃ©sultat",
        save: "Sauvegarder les paramÃ¨tres",
        saveSettingsWarning:
            "Attention! Les changements dans cette section pourrait causer le dysfonctionnement de la machine Ã  teinter",
        serviceSwPath: "Chemin vers logiciel de service",
        simulationPath: "Chemin vers simulation"
    },
    rccMachineSettings: {
        allowManualColorantAddition: "Autoriser ajout manuel de colorant",
        ask: "Demander",
        canHandlingOptions: "Options de reconnaissance de pot",
        checkCanBeforeDispense: "VÃ©rifier boite avant dosage",
        checkOverfill: "VÃ©rifier si surremplissage",
        colorantBatchNumbers: "Colorant batch numbers",
        colorantPackageValidation: "Validation de l'emballage de colorant uniquement",
        disable: "DÃ©sactivÃ©",
        dispenseInvalidColorants: "Dosage de colorants invalides",
        dispensingOptions: "options de dosage",
        enable: "ActivÃ©",
        enableUserIdentification: "Identification de l'utilisateur",
        fullValidation: "Validation complÃ¨te",
        machineAccuracyWarning: "Alerte de prÃ©cision machine",
        machineOptions: "Options machine",
        machineUnit: "UnitÃ© machine",
        minimalDispenseAmount: "QuantitÃ© minimum dosable",
        placeCanSensor: "Positionner le dÃ©tecteur de boites",
        placeCanSensorDelay: "Capteur de retard âPot placÃ©â",
        rccMachineSettings: "ParamÃ¨tres machine",
        refillBarcodeValidation: "Refill barcode validation",
        refillBarcodeValidationCanisterAndColorant: "Validate Canister and Colorant package",
        refillBarcodeValidationColorant: "Validate only colorant package",
        refillSettings: "Refill settings",
        removeCanSensor: "Retirer le capteur de boite",
        removeCanSensorDelay: "Capteur de retard âPot retirÃ©â",
        save: "Sauvergarder paramÃ¨tres",
        sec: "sec.",
        skipPlaceCanDialog: "Ignorer le message de positionnement de la boite",
        skipRemoveCanDialog: "Ignorer le message de retrait de la boite",
        splitFormula: "Split Formula",
        tmcEnabled: "ActivÃ© TMC",
        ufiCode: "UFI code",
        validateBarcodeBaseCan: "Valider le code barre de la base de peinture",
        validateBarcodeRefill: "Valider le code barre avant remplissage",
        validateColorantsDuringInit: "Valider colorants pendant l'initialisation"
    },
    rccPanel: {
        actionsRunningOnDispenser: "Il y a des actions en cours sur la machine",
        addLevel: "Niveau ADD",
        addManually: "Ajouter manuellement",
        barcodeNotSet: "Le canister %{colorantName} (%{canisterName}) n'a pas de code-barres attribuÃ©.",
        cancel: "Annuler",
        dispenseFormula: "Doser formule",
        dispenserIdle: "La machine est inactive",
        dispenserIsBusy: "La machine est occupÃ©e",
        dispenserIsIdle: "La machine est inactive",
        dispenserIsReady: "La machine est prete pour les taches suivantes",
        dispensingFormula: "Dosage de la formule",
        errorCode: "Code erreur",
        explanation: "Explication",
        fillToMax: "Remplir au max",
        finished: "TerminÃ©",
        inProgress: "En cours",
        machineIsReady: "La machine est prete ",
        moveToFill: "DÃ©placer pour remplir",
        noMachineDialog: "Pas de machine connectÃ©",
        of: "de",
        packageSize: "Taille de l'emballage",
        placeBaseCan: "Positionner base",
        pleaseCheckYourMachineConnection: "VÃ©rifier votre connection machine",
        pleaseRefill: "Remplissez svp",
        solution: "Solution",
        subErrors: "Sous-erreurs",
        timeToEnd: "Temps restant",
        tintingFormula: "Formule de teinte",
        tintingPleaseWait: "Dosage en cours, patientez svp",
        validateBaseCan: "Valider le pot de base",
        waiting: "En attente"
    },
    rccSettigns: {
        rccSettigns: "Connection RCC",
        rccUrl: "URL du RCC"
    },
    rccSpectroDialog: {
        100: "Connection de votre instrumet en Bluetooth. Assurez vous que le Bluetooth est activÃ© et que votre instrument est allumÃ©.",
        101: "L'instrument n'a pas Ã©tÃ© dÃ©tectÃ©. Voulez-vous rÃ©essayer?",
        110: "Assurez vous que Nano est bien connectÃ© et pressez le bouton pour dÃ©marrer l'initialisation",
        111: "Nano n'a pas Ã©tÃ© dÃ©tectÃ©. Voulez-vous recommencer?",
        112: "DÃ©connectez Nano, attendez 10 secondes, connectez le de nouveau et continuez",
        120: "Connection de l'instrument, patientez svp",
        121: "L'instrument a Ã©tÃ© dÃ©tectÃ©. Voulez-vous rÃ©essayer?",
        200: "Placez le piÃ¨ge Ã  lumiÃ¨re sur le spectro et continuez",
        201: "Placez l'Ã©talon noir et continuez",
        202: "Placez l'Ã©talon noir et continuez",
        205: "Placez l'Ã©talon blanc et continuez",
        206: "Placez l'Ã©talon blanc et continuez",
        207: "Placez l'Ã©talon blanc et continuez",
        210: "Placez l'instrument sur la cible et continuez ou pressez le bouton ",
        211: "Placez l'instrument sur la cible et continuez",
        212: "Placez l'instrument sur la cible et presser sur le bouton de l'instrument pour continuer",
        215: "Fermer le couvercle de lâappareil et poursuivre ou appuyer sur le bouton de lâappareil",
        216: "Fermer le couvercle de lâappareil et poursuivre",
        217: "Fermer le couvercle de lâappareil et appuyer sur le bouton de lâappareil",
        220: "Placer lâappareil sur la case zÃ©ro et poursuivre ou appuyer sur le bouton de lâappareil",
        221: "Placer lâappareil sur la case zÃ©ro et poursuivre",
        222: "Placer lâappareil sur la case zÃ©ro et appuyer sur le bouton de lâappareil",
        224: "Placez lâinstrument sur le tampon de calibrage et continuez ou appuyez sur le bouton de lâinstrument.",
        225: "Placez lâinstrument sur le tampon de calibrage et continuez",
        226: "Placez lâinstrument sur le tampon de calibrage et appuyez sur le bouton de lâinstrument",
        227: "Placez lâinstrument sur le tampon de calibrage et appuyez sur le bouton de lâinstrument",
        295: "Finir la calibration dans le fenetre de connection",
        296: "Lâinstrument nâest pas connectÃ©, voulez-vous ouvrir la connexion Ã  celui-ciÂ ?",
        297: "PrÃ©paration des Ã©tapes de calibration, patientez svp",
        298: "Calibration en cours, patientez svp",
        299: "Cloture de la calibration, patientez svp",
        300: "Placez l'instrument sur l'Ã©chantillon et continuez ou appuyez sur l'appareil",
        301: "Placez l'Ã©chantillon sur le spectro et continuez.",
        302: "Placez l'instrument sur l'Ã©chantillon et appuyez sur le bouton",
        303: "Lâinstrument nâest pas calibrÃ©, voulez-vous procÃ©der au calibrageÂ ?",
        304: "Lâinstrument nâest pas connectÃ©, voulez-vous ouvrir la connexion Ã  celui-ciÂ ?",
        390: "SÃ©lectionner le mode de mesure",
        395: "Finissez de mesurer dans la fenetre de connection",
        397: "PrÃ©paration Ã  la mesure, patientez svp",
        398: "Mesure en cours, patientez svp",
        399: "Cloture de la mesure, patientez svp",
        498: "TÃ©lÃ©chargement de la mesure, patientez svp",
        499: "TÃ©lÃ©chargement de toutes les mesures, patientez svp",
        900: "Message dâerreur appareil %{0} : %{1}. Voulez-vous rÃ©essayer?",
        901: "Message dâerreur interne: %{0}"
    },
    rccSpectroSettings: {
        DatacolorColorReader:
            "L'ordinateur doit avoir une connexion Bluetooth. Le spectro doit Ãªtre couplÃ© avec l'ordinateur. Windows 10 avec mise Ã  jour d'automne 2018 requise.",
        DatacolorSilent:
            "Lorsque vous utilisez le mode silencieux, les fenÃªtres Datacolor sont affichÃ©es directement dans %{name}. Dans ces fenÃªtres, les paramÃ¨tres spectro ne peuvent pas Ãªtre modifiÃ©s.",
        DatacolorUseDiagnosticTile: "L'utilisation de la plaque de diagnostic amÃ©liore la qualitÃ© de la mesure.",
        comPort: "Port Com",
        diagnosticTile: "Utiliser la case diagnostic Datacolor",
        measureModes: "Modes de mesure",
        measureModesOrder: "Commande des modes de mesure",
        model: "ModÃ¨le",
        noSpectroAvailable: "Aucun spectro n'est disponible.",
        rccSpectroSettings: "ParamÃ¨tres spectro",
        save: "Sauvegarder les paramÃ¨tres",
        silent: "Datacolor est en veille",
        simulationPath: "Chemin vers simulation",
        spectroType: "Type de spectro",
        useProfiledValues: "Utiliser les valeurs dÃ©finies"
    },
    recirculateChannels: {
        recirculateAllChannels: "Recirculer tous les circuits ",
        recirculateChannels: "Recirculer circuits",
        recirculatingSpeed: "Vitesse de recirculation",
        recirculatingTime: "Temps de recirculation",
        startRecirculating: "DÃ©marrer la recirculation"
    },
    redlikeLight: {
        finishPreviousSteps: "Cloturez les Ã©tapes prÃ©cÃ©dentes svp",
        searchBySpectro: "Recherche par Spectro",
        searchFormula: "Rechercher une formule",
        selectBase: "SÃ©lectionnez la base",
        selectColor: "SÃ©lectionner couleur",
        selectCustomer: "SÃ©lectionner client",
        selectFandeck: "SÃ©lectionner nuancier",
        selectPackage: "SÃ©lectionner emballage",
        selectProduct: "SÃ©lectionner produit",
        startSelectFandeck: "Commencer par la sÃ©lection du nuancier",
        startSelectProduct: "Commender par la sÃ©lection du produit",
        stepByStepProgress: "Vous pouvez progresser Ã©tape par Ã©tape",
        typeHereToSearch: "Tapez ici pour lancer une recherche",
        typeToFilter: "Tapez pour filtrer "
    },
    restartModal: {
        computerNeedsRestart: "L'ordinateur doit redÃ©marrer!",
        notCompletelyTranslated:
            "Le changement de langue nÃ©cessite de redÃ©marrer le logiciel. Il se pourrait que certains Ã©lÃ©ments demeurent non traduits.",
        restartIsRequired: "Un redÃ©marrage du logiciel est nÃ©cessaire une fois les modifications effectuÃ©es",
        softwareNeedsRestart: "%{name} needs restart!"
    },
    searchPanel: {
        basePlaceholder: "ou tapez un nom de base",
        baseStartPlaceholder: "Commencez par taper un nom de base",
        colorCodeNamePlaceholder: "ou tappez un code/nom formule",
        colorCodeNameStartPlaceholder: "Commencez en saisissant un code/nom formule",
        colorCodePlaceholder: "ou saisir un code couleur",
        colorCodeStartPlaceholder: "Commencer par taper un code de formule",
        colorNameCodePlaceholder: "ou saisir un nom de couleur",
        colorNameCodeStartPlaceholder: "Commencez en saisissant un nom/code formule",
        colorNamePlaceholder: "ou saisir un nom de couleur",
        colorNameStartPlaceholder: "Saisir la rÃ©fÃ©rence de la teinte",
        colorPreviewIsNotAvailable:
            "L'aperÃ§u des couleurs n'est pas disponible. SÃ©lectionnez un fandeck pour obtenir un aperÃ§u des couleurs.",
        fandeckPlaceholder: "ou saisir un nom de nuancier",
        fandeckStartPlaceholder: "Saisir la rÃ©fÃ©rence du nuancier",
        formulaByColor: "Formule par couleur",
        noResultsFound: "Aucun rÃ©sultat trouvÃ©",
        packagePlaceholder: "ou tapez un nom dâemballage",
        packageStartPlaceholder: "Commencez par taper un nom dâemballage",
        productPlaceholder: "ou saisir un nom de produit",
        productStartPlaceholder: "Commencer par taper un nom de produit",
        standard: "AccÃ¨s formules locales",
        typeFandeckToFilter: "Choisir un nuancier",
        typeProductToFilter: "Choisir un produit"
    },
    sendOrderModal: {
        customNote: "Notes personnalisÃ©es",
        noCompatibleServers: "Pas de serveur compatible disponible sur votre serveur",
        orderOverview: "RÃ©capitulatif de la commande",
        selectTargetMachine: "SÃ©lectionner la machine cible",
        sendOrder: "Envoyer commande",
        sendOrderTo: "Votre commande sera envoyÃ©e Ã  %{serverName}",
        targetMachine: "Machine cible"
    },
    server: {
        computerId: "Identifiant PC",
        ip: "IP",
        selectServer: "SÃ©lectionnez un des serveurs disponibles svp",
        server: "Serveur"
    },
    serverDialog: {
        1: "There is an error in the brand definition for your license. Please check with your provider.",
        2: "Impossible de traiter les donnÃ©es pour %{0} : %{1}",
        3: "Chemin d'accÃ¨s au rÃ©seau non valide.",
        4: "Type de chemin non valide (seuls les types %{0} et %{1} sont pris en charge)",
        5: "Erreur d'Ã©criture du fichier de teinte",
        6: "Tinting file was created successfully.",
        7: "Impossible de trouver le colorant portant le nom '%{0}' sur la ligne '%{1}'.",
        8: "Impossible de trouver un paquet portant le nom '%{0}' sur la ligne '%{1}'.",
        9: "Impossible de trouver une base dans un produit dont le nom est '%{0}' et le nom de la base '%{1}' sur la ligne '%{2}'.",
        10: "Impossible de trouver une base dans le paquet de produits avec le nom du produit : '%{0}', le nom de la base : '%{1}' et le nom du paquet : '%{2}' sur la ligne '%{3}'.",
        11: "Impossible d'analyser la valeur du prix : '%{0}' sur la ligne '%{1}' dans la feuille '%{2}'.",
        12: "Preparing bases data, please wait",
        13: "Preparing bases in products data, please wait",
        14: "Preparing base packages data, please wait",
        15: "Preparing colors data, please wait",
        16: "Preparing colors in fandecks data, please wait",
        17: "Preparing fandecks data, please wait",
        18: "Preparing data for global search, please wait",
        19: "Preparing products data, please wait",
        30: "Partial updates can't be applied on database '%{0}'. Update your software to the latest version. Minimal required version is '%{1}'.",
        31: "Partial updates can't be applied on database '%{0}'. Database versions doesn't match. Contact your technical support.",
        32: "Partial updates can't be applied on database '%{0}'. Database structure version doesn't match. Contact your technical support.",
        33: "Partial updates can't be applied on database '%{0}'. The update is corrupted. Contact your technical support.",
        34: "Unknown error occurred during partial update. If this error repeats contact your technical support.",
        35: "No partial updates available. Please check your internet connection or contact your technical support.",
        36: "Prepared partial updates for database '%{0}' are for newer version of Redlike. Update your Redlike to the latest version. Minimal required version is '%{1}'.",
        37: "Partial updates can't be prepared. There is not enough space on the drive. Minimal required space is 20 GB.",
        38: "Partial updates can't be applied on database '%{0}'. The update is invalid. Contact your technical support.",
        39: "Partial updates can't be applied on database '%{0}'. The update can't be downloaded. Contact your technical support.",
        40: "Partial updates can't be applied on database '%{0}'. Downloaded file is corrupted. Contact your technical support."
    },
    serverPlugins: {
        activeServerPlugins: "Activer les plugings de serveur",
        currentlyActive: "Les plugins actuellement actifs",
        plugin: "Brancher",
        pluginName: "Nom de plugin",
        statusActive: "Actif",
        statusInactive: "Inactif"
    },
    serviceActionsSettings: {
        canisterLevel: "Niveau canister",
        capClose: "Fermer",
        capMiddle: "Milieux",
        capOpen: "Ouvrir",
        cleanAllChannels: "Nettoyer tous les circuits",
        cleanChannels: "Nettoyer circuits",
        computer: "Ordinateur",
        computerReboot: "RedÃ©marrage de l'ordinateur",
        computerShutdown: "ArrÃªt de l'ordinateur",
        connectMachine: "Connecter la machine",
        general: "GÃ©nÃ©ral",
        initialize: "Initialiser",
        noMachineIsConnected: "Aucune machine n'est connectÃ©",
        plug: "Brancher",
        plugger: "Dispositif de rebouchage",
        punch: "Percer",
        puncher: "PerÃ§age",
        purgeChannels: "Purger circuits",
        recirculate: "Recirculer",
        recirculateAllChannels: "Recirculer tous les circuits ",
        recirculateChannels: "Recirculer circuits",
        serviceActions: "Actions service",
        setCanisterLevel: "DÃ©finir niveau canister",
        shelfDown: "Abaisser plateau",
        shelfUp: "Monter plateau",
        showServiceWindow: "Montrer fenetre de service",
        smartPurgeAllChannels: "Purge intelligente de tous les canaux",
        smartPurgeChannels: "Pure intelligente des canaux",
        startErrorReset: "Commencer la rÃ©initialisation des erreurs",
        startHardReset: "Commencer la rÃ©initialisation forcÃ©e",
        startReset: "Commencer la rÃ©initialisation",
        stirAllCanisters: "Agiter tous les canisters",
        stirCanisters: "Agiter les canisters",
        stirCanistersMore: "Agiter les canisters"
    },
    spectroMode: {
        eggshell: "Coquille dâÅuf",
        flat: "Plat",
        gloss: "Brillant",
        matt: "Mat",
        matte: "mat",
        pearl: "Perle",
        satin: "Satin",
        selectGlossLevel:
            "Comparez l'Ã©chantillon de couleur Ã  l'Ã©chelle de brillance et sÃ©lectionnez le niveau de brillance",
        semiGloss: "Semi-brillant"
    },
    spectroTab: {
        bestMatch: "The best match",
        calibrate: "Calibrer",
        calibrateInstrument: "Calibrer lâinstrument",
        connectDevice: "Connecter l'instrument",
        connectedTo: "Connecter Ã  ",
        connectingDevice: "Connecter votre instrument",
        deselectAll: "DÃ©sÃ©lectionner tout ",
        deviceCalibrated: "Your device has been calibrated and you can start measuring",
        deviceIsNotCalibrated: "Votre instrument n'est pas connectÃ©",
        eraseResult: "Effacer le rÃ©sultat",
        filter: "Filtrer",
        foundInFormulas: "TrouvÃ© dans les formules",
        inactiveSpectro: "The Spectro function is inactive for selected brand.",
        instrumentCalibration: "Votre instrument a besoin dâÃªtre calibrÃ©.",
        manualInput: "EntrÃ©e manuelle",
        measure: "Mesure",
        measurementResult: "RÃ©sultat de la mesure",
        noFilters: "Pas de filtres disponibles",
        noFormulas: "Pas de formules trouvÃ©es",
        noSelectedSpectro: "Pas de spectro sÃ©lectionnÃ©",
        notSelected: "Pas sÃ©lectionnÃ©",
        pressConnectButton: "Assurez-vous que l'appareil est connectÃ© et pressÃ© sur le bouton connectÃ©",
        searchFormulas: "Chercher formules",
        selectSpectro: "SÃ©lectionner spectro",
        showDetails: "Montrer dÃ©tails",
        skipCalibration: "Sauter le calibrage",
        spectroIsConnected: "Spectro est connectÃ©",
        spectroIsReady: "Le spectro est prÃªt",
        spectroReady: "L'instrument est prÃªt pour de nouvelles taches",
        startCalibrateNow: "Commencer le calibrage",
        startMeasureText: "Votre instrument a Ã©tÃ© calibrÃ© et vous pouvez commencer Ã  effectuer des mesures",
        tolerance: "Delta E (CIE 2000)",
        toleranceOfDevitation: "TolÃ©rance Delta E (CIE 2000)"
    },
    statisticsTab: {
        allRecords: "All records",
        customPackageName: "SpÃ©cial %{1} %{2}",
        deleteSelectedRecords: "Supprimer l'enregistrement selectionnÃ©",
        exportHistory: "Historique d'exportation",
        finishFormula: "Finir formule",
        foundInFormulas: "TrouvÃ© dans les formules",
        hideHiddenRecords: "Ne pas afficher les enregistrements cachÃ©s",
        hideSelectedRecord: "Masquer l'enregistrement sÃ©lectionnÃ©",
        historicalFormula: "Formule historique",
        onlyFiltered: "Only filtered",
        restoreSelectedRecord: "Restaurer l'enregistrement sÃ©lectionnÃ©",
        showAllRecords: "Montrer tous les enregistrements",
        standardFormula: "Standard formula",
        unknownFormula: "Formule inconnue"
    },
    stirCanisters: {
        selectCanisters: "SÃ©lectionner canisters",
        startStirring: "Commencer l'agitation",
        stirAllCanisters: "Agiter tous les canisters",
        stirCanisters: "Agiter canisters",
        stirringSpeed: "Vitesse d'agitation",
        stirringTime: "DurÃ©e d'agitation "
    },
    stock: {
        addColorant: "Add colorant...",
        addColorantPackagesToStock: "Ajouter des paquets de colorants au stock",
        addPackagesToStock: "Ajouter  au stock",
        addedToStock: "AjoutÃ© au stock",
        allDatabases: "All databases",
        checkStockPackageInventory:
            "Si vous avez utilisÃ© un bidon du stock, veuillez vÃ©rifier que votre stock est valide.",
        clearAllItems: "Effacer tous les Ã©lÃ©ments",
        colorantInventory: "Inventaire des colorants",
        colorantsStockInventory: "Colorants stock inventory",
        confirmSendingOrder: "Confirm sending order",
        consumptionPrediction: "PrÃ©vision de consommation pour les %{weeks} semaines Ã  venir",
        createOrder: "CrÃ©er la commande (%{sum})",
        expirationDate: "Date d'expiration ",
        inDelivery: "In delivery",
        manualOrder: "Manual order",
        manualOrderProgress: "Step %{step}/%{total}",
        noPackagesFoundInStockForColorant: "There are no packages in stock for this colorant.",
        onStock: "In stock",
        orderSummary: "Order summary",
        prediction: "Prediction",
        removePackageFromStock: "Remove %{colorantName} package from stock",
        removePackageNameFromStock: "Would you like to remove one %{packageName} package from stock?",
        scanBarcodeOrSelectColorant: "Scan barcode from package or select colorant",
        selectPackageToRemove: "Select package to remove",
        sendConfirmed: "Send confirmed",
        setAmountsByPrediction: "Set amounts by prediction",
        sortByColorantName: "Sort by colorant name",
        sortByOrderNeed: "Sort by need to order",
        sortByStockLevel: "Sort by stock level",
        toOrder: "To order"
    },
    testBarcode: {
        noItemAssigned: "Aucun Ã©lÃ©ment n'est attribuÃ© au code-barre %{code}",
        pleaseScanBarcode: "Scannez le code barre de la base, produit, emballage ou autre Ã©lÃ©ment",
        testBarcodes: "Code barre test"
    },
    ticketing: {
        answer: "Commentaire rÃ©ponse",
        answered: "RÃ©pondu",
        chooseType: "Choisir un type",
        closeRequest: "Fermer demande",
        comment: "Commentaire demande",
        create: "CrÃ©er",
        createNewTicket: "CrÃ©er une demande",
        formulaAttached: "The requested formula is attached to the answer. Click the %{loadFormula} button to open it.",
        formulaClaim: "RÃ©clamation formule",
        formulaRequest: "Demande de formule",
        formulaUnrealizable: "The requested formula is unrealizable.",
        newTicket: "New ticket",
        noPosInfoFound: "Infos magasin (nom, ville) non trouvÃ©",
        noTicketSelected: "Pas de demande sÃ©lectionnÃ©e",
        openTicket: "Open ticket",
        posName: "Nom du dÃ©pÃ´t",
        posted: "EnvoyÃ©",
        request: "Demande",
        requestDate: "Date de la demande",
        requestId: "Request ID",
        resolvedBy: "RÃ©solu par",
        responseDate: "Date de la rÃ©ponse",
        saveToCustomFormula: "Sauver en tant que formule locale",
        sending: "Envoi en cours ...",
        service: "Service",
        successfulCreation: "Demande crÃ©Ã©e avec succÃ¨s. Envoi en cours...",
        ticketAnswered: "RÃ©ponse reÃ§ue.",
        ticketDelivered: "Une demande a Ã©tÃ© envoyÃ©e.",
        ticketId: "NÂ° de demande",
        ticketType: "Type de demande",
        waitingForAnswer: "En attente de rÃ©ponse"
    },
    tutorial: {
        last: "Dernier",
        next: "Suivant"
    },
    ufiCodeModal: {
        currentStatus: "Statut actuel",
        detailedInfoForColorant: "Informations dÃ©taillÃ©es sur le colorant %{colorantName}",
        userSetUfiCode: "Code UFI dÃ©fini par l'utilisateur, valeur actuelle"
    },
    ufiCodeSettings: {
        baseUfiCodeValidation: "Validation du code de base UFI",
        confirmColorantRefilling: "Confirmer le remplissage du colorant",
        enableUfiCodes: "Activer les codes UF",
        printUfiCode: "Imprimer si la quantitÃ© de colorant est dÃ©passÃ©e",
        printUfiCodePercentage: "Imprimer si le percentage de la quantitÃ© de colorant est supÃ©rieure",
        scanOrTypeUfiCode: "Scanner ou saisir le code UFI",
        scanOrTypeUfiCodeOfBase: "Scannez ou tapez le code UFI de la base",
        ufiCodesByPercentage: "Utiliser les codes UFI en pourcentage",
        ufiCodesFromDatabase: "Utiliser les codes UFI de la base de donnÃ©es",
        ufiCodesFromLastFilling: "Utiliser les codes UFI du dernier remplissage"
    },
    userSettings: {
        addUser: "Ajouter utilisateur",
        assignedUserGroups: "Groupe d'utilisateurs assignÃ©",
        availableUserGroups: "Groupes d'utilisateurs disponibles",
        barcode: "Code barre",
        confirmNewPassword: "Confirmer mot de passe",
        editPassword: "Editer mot de passe",
        editUser: "Editer utilisateur",
        enableAutoLogin: "Autoriser l'auto login",
        newPassword: "Nouveau mot de passe",
        noChange: "Il n'y a aucun changement Ã  sauvegarder",
        oldPassword: "Ancien mot de passe",
        password: "Mot de passe",
        passwordsDoNotMatch: "Les mots de passe ne correspondent pas",
        restoreUser: "Cet utilisateur a Ã©tÃ© supprimÃ©. Voulez-vous le restaurer?",
        userGroup: "User Group",
        userGroups: "Groupes d'utilisateurs",
        userManagement: "Gestion des utilisateurs",
        userSettings: "ParamÃ¨tres d'utilisateurs",
        username: "Nom d'utilisateur",
        usernameIsMissing: "Le nom d'utilisateur est manquant."
    },
    warningMissingDataModal: {
        continue: "Same data is missing, do you want continue?",
        notFoundBase:
            "This product base is not available. Confirm and be careful to get compatible product base from shelf or cancel this order.",
        notFoundProduct:
            "This product is not available. Confirm and be careful to get compatible product from shelf or cancel this order."
    },
    weekdays: {
        friday: "Vendredi",
        monday: "Lundi",
        saturday: "Samedi",
        sunday: "Dimanche",
        thursday: "Jeudi",
        tuesday: "Mardi",
        wednesday: "Mercredi"
    },
    welcome: {
        availableDatabase:
            "Le serveur ne peut pas se connecter Ã  la base de donnÃ©es. VÃ©rifiez la configuration de votre base de donnÃ©es svp",
        availableDatabaseLocalError:
            "Erreur durant la connection Ã  la base de donnÃ©es locale (mauvais fichier, mot de passe invalide)",
        availableDatabaseLocalMissing: "Le fichier de base de donnÃ©es locale est manquant",
        availableDatabaseLocalUpdate:
            "La base de donnÃ©es locale nÃ©cessite d'etre mise Ã  jour vers une version plus rÃ©cente",
        availableDatabaseMainAndLocalError:
            "Erreur durant la connection de laconnection vers la base de donnÃ©es principale et vers la base de donnÃ©es locale (mauvais fichier, mot de passe invalide)",
        availableDatabaseMainAndLocalMissing: "Les fichiers des bases de donnÃ©es principale et locale sont manquants",
        availableDatabaseMainAndLocalUpdate:
            "Les deux bases de donnÃ©es (locale et principale) doivent etre mises Ã  jour vers une version plus rÃ©cente",
        availableDatabaseMainError:
            "Erreur durant la connection Ã  la base de donnÃ©es principale (mauvais fichier, mot de passe invalide)",
        availableDatabaseMainMissing: "Fichier de la base de donnÃ©es principale invalide",
        availableDatabaseMainPartialUpdate:
            "La base de donnÃ©es principale doit Ãªtre mise Ã  jour vers la nouvelle version par le biais d'une mise Ã  jour partielle.",
        availableDatabaseMainPartialUpdateAndLocalUpdate:
            "La base de donnÃ©es principale doit Ãªtre mise Ã  jour vers la version la plus rÃ©cente via une mise Ã  jour partielle et la base de donnÃ©es locale doit Ãªtre mise Ã  jour vers la version la plus rÃ©cente.",
        availableDatabaseMainUpdate:
            "La base de donnÃ©es principale nÃ©cessite d'etre mise )Ã  jour vers une version plus rÃ©cente",
        closing: "Le logiciel est en cours de fermeture",
        compatibility:
            "VÃ©rifier la version de votre serveur. Votre client est uniquement compatible avec le serveur %{0}.",
        compatibilityCheck: "VÃ©rification de compatibilitÃ© en cours",
        compatibilityDatabase:
            "Votre base de donnÃ©es n'est pas compatible avec le serveur. VÃ©rifiez la base de donnÃ©es de configuration.",
        connectingServer: "Connexion au serveur en cours %{ip}",
        databaseCompatibility: "Votre base de donnÃ©es n'est pas compatible avec le logiciel actuel.",
        databasesCompatibility: "Vos bases de donnÃ©es ne sont pas compatibles avec le logiciel actuel.",
        licenseVerification: "La vÃ©rification de la licence est en cours",
        loading: "Chargement",
        lostConnection: "La connection au serveur a Ã©tÃ© perdue",
        moduleMessage:
            "PrÃ©tez attention au module de sÃ©lection car des changements future de ce module seront accessible Ã  certains utilisateurs privilÃ©giÃ©s.",
        refresh: "Rafraichir",
        restoring: "RÃ©tablir la connexion",
        selectModule: "SÃ©lectionnez un des modules disponibles svp",
        stopUpdate: "Arreter mise Ã  jour",
        updateDatabase: "Mettre Ã  jour la base de donnÃ©es",
        updatingDatabase: "La base de donnÃ©es se met Ã  jour",
        updatingDatabases: "Les bases de donnÃ©es se mettent Ã  jour",
        updatingWarning:
            "La structure de la base de donnÃ©es est en cours de mise Ã  jour vers la derniÃ¨re version, veuillez patienter.",
        updatingWarningInfo:
            "Ne fermez pas cette fenÃªtre car cela pourrait entrainer une reprise Ã  zero de la mise Ã  jour."
    }
};
